var _assertThisInitialized = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _possibleConstructorReturn = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _toConsumableArray = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.SolidFileClient = e() : t.SolidFileClient = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        r.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 205);
  }([function (t, e, r) {
    t.exports = r(28);
  }, function (t, e) {
    function r(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
            u = s.value;
      } catch (t) {
        return void r(t);
      }

      s.done ? e(u) : Promise.resolve(u).then(n, i);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            n = arguments;
        return new Promise(function (i, o) {
          var a = t.apply(e, n);

          function s(t) {
            r(a, i, o, s, u, "next", t);
          }

          function u(t) {
            r(a, i, o, s, u, "throw", t);
          }

          s(void 0);
        });
      };
    };
  }, function (t, e, r) {
    var n = r(4),
        i = r(22).f,
        o = r(14),
        a = r(17),
        s = r(62),
        u = r(101),
        c = r(68);

    t.exports = function (t, e) {
      var r,
          f,
          l,
          h,
          p,
          d = t.target,
          v = t.global,
          g = t.stat;
      if (r = v ? n : g ? n[d] || s(d, {}) : (n[d] || {}).prototype) for (f in e) {
        if (h = e[f], l = t.noTargetGet ? (p = i(r, f)) && p.value : r[f], !c(v ? f : d + (g ? "." : "#") + f, t.forced) && void 0 !== l) {
          if (typeof h == typeof l) continue;
          u(h, l);
        }

        (t.sham || l && l.sham) && o(h, "sham", !0), a(r, f, h, t);
      }
    };
  }, function (t, e, r) {
    var n = r(4),
        i = r(64),
        o = r(13),
        a = r(65),
        s = r(69),
        u = r(107),
        c = i("wks"),
        f = n.Symbol,
        l = u ? f : f && f.withoutSetter || a;

    t.exports = function (t) {
      return o(c, t) || (s && o(f, t) ? c[t] = f[t] : c[t] = l("Symbol." + t)), c[t];
    };
  }, function (t, e, r) {
    (function (e) {
      var r = function r(t) {
        return t && t.Math == Math && t;
      };

      t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || Function("return this")();
    }).call(this, r(21));
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
        i = "http://www.w3.org/2001/XMLSchema#",
        o = "http://www.w3.org/2000/10/swap/";
    e.a = {
      xsd: {
        decimal: i + "decimal",
        boolean: i + "boolean",
        double: i + "double",
        integer: i + "integer",
        string: i + "string"
      },
      rdf: {
        type: n + "type",
        nil: n + "nil",
        first: n + "first",
        rest: n + "rest",
        langString: n + "langString"
      },
      owl: {
        sameAs: "http://www.w3.org/2002/07/owl#sameAs"
      },
      r: {
        forSome: o + "reify#forSome",
        forAll: o + "reify#forAll"
      },
      log: {
        implies: o + "log#implies"
      }
    };
  }, function (t, e, r) {
    var n = r(5);
    t.exports = !n(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, r) {
    var n = r(10);

    t.exports = function (t) {
      if (!n(t)) throw TypeError(String(t) + " is not an object");
      return t;
    };
  }, function (t, e, r) {
    var n = r(169),
        i = r(170),
        o = r(171);

    t.exports = function (t) {
      return n(t) || i(t) || o();
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e, r) {
    var n = r(7),
        i = r(99),
        o = r(8),
        a = r(43),
        s = Object.defineProperty;
    e.f = n ? s : function (t, e, r) {
      if (o(t), e = a(e, !0), o(r), i) try {
        return s(t, e, r);
      } catch (t) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
      return "value" in r && (t[e] = r.value), t;
    };
  }, function (t, e, r) {
    var n = r(60),
        i = r(20);

    t.exports = function (t) {
      return n(i(t));
    };
  }, function (t, e) {
    var r = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return r.call(t, e);
    };
  }, function (t, e, r) {
    var n = r(7),
        i = r(11),
        o = r(31);
    t.exports = n ? function (t, e, r) {
      return i.f(t, e, o(1, r));
    } : function (t, e, r) {
      return t[e] = r, t;
    };
  }, function (t, e, r) {
    var n = r(32),
        i = Math.min;

    t.exports = function (t) {
      return t > 0 ? i(n(t), 9007199254740991) : 0;
    };
  }, function (t, e) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(4),
        i = r(14),
        o = r(13),
        a = r(62),
        s = r(63),
        u = r(24),
        c = u.get,
        f = u.enforce,
        l = String(String).split("String");
    (t.exports = function (t, e, r, s) {
      var u = !!s && !!s.unsafe,
          c = !!s && !!s.enumerable,
          h = !!s && !!s.noTargetGet;
      "function" == typeof r && ("string" != typeof e || o(r, "name") || i(r, "name", e), f(r).source = l.join("string" == typeof e ? e : "")), t !== n ? (u ? !h && t[e] && (c = !0) : delete t[e], c ? t[e] = r : i(t, e, r)) : c ? t[e] = r : a(e, r);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && c(this).source || s(this);
    });
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    var r = {}.toString;

    t.exports = function (t) {
      return r.call(t).slice(8, -1);
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on " + t);
      return t;
    };
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(7),
        i = r(59),
        o = r(31),
        a = r(12),
        s = r(43),
        u = r(13),
        c = r(99),
        f = Object.getOwnPropertyDescriptor;
    e.f = n ? f : function (t, e) {
      if (t = a(t), e = s(e, !0), c) try {
        return f(t, e);
      } catch (t) {}
      if (u(t, e)) return o(!i.f.call(t, e), t[e]);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(55),
        i = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e;
    };

    t.exports = l;
    var o = r(39);
    o.inherits = r(29);
    var a = r(138),
        s = r(95);
    o.inherits(l, a);

    for (var u = i(s.prototype), c = 0; c < u.length; c++) {
      var f = u[c];
      l.prototype[f] || (l.prototype[f] = s.prototype[f]);
    }

    function l(t) {
      if (!(this instanceof l)) return new l(t);
      a.call(this, t), s.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
    }

    function h() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(p, this);
    }

    function p(t) {
      t.end();
    }

    Object.defineProperty(l.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(l.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), l.prototype._destroy = function (t, e) {
      this.push(null), this.end(), n.nextTick(e, t);
    };
  }, function (t, e, r) {
    var n,
        i,
        o,
        a = r(147),
        s = r(4),
        u = r(10),
        c = r(14),
        f = r(13),
        l = r(44),
        h = r(45),
        p = s.WeakMap;

    if (a) {
      var d = new p(),
          v = d.get,
          g = d.has,
          y = d.set;
      n = function n(t, e) {
        return y.call(d, t, e), e;
      }, i = function i(t) {
        return v.call(d, t) || {};
      }, o = function o(t) {
        return g.call(d, t);
      };
    } else {
      var b = l("state");
      h[b] = !0, n = function n(t, e) {
        return c(t, b, e), e;
      }, i = function i(t) {
        return f(t, b) ? t[b] : {};
      }, o = function o(t) {
        return f(t, b);
      };
    }

    t.exports = {
      set: n,
      get: i,
      has: o,
      enforce: function enforce(t) {
        return o(t) ? i(t) : n(t, {});
      },
      getterFor: function getterFor(t) {
        return function (e) {
          var r;
          if (!u(e) || (r = i(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
          return r;
        };
      }
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e, r) {
    var n = r(103),
        i = r(4),
        o = function o(t) {
      return "function" == typeof t ? t : void 0;
    };

    t.exports = function (t, e) {
      return arguments.length < 2 ? o(n[t]) || o(i[t]) : n[t] && n[t][e] || i[t] && i[t][e];
    };
  }, function (t, e, r) {
    var n = r(20);

    t.exports = function (t) {
      return Object(n(t));
    };
  }, function (t, e, r) {
    var n = function (t) {
      "use strict";

      var e = Object.prototype,
          r = e.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          i = n.iterator || "@@iterator",
          o = n.asyncIterator || "@@asyncIterator",
          a = n.toStringTag || "@@toStringTag";

      function s(t, e, r, n) {
        var i = e && e.prototype instanceof f ? e : f,
            o = Object.create(i.prototype),
            a = new x(n || []);
        return o._invoke = function (t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === i) throw o;
              return E();
            }

            for (r.method = i, r.arg = o;;) {
              var a = r.delegate;

              if (a) {
                var s = _(a, r);

                if (s) {
                  if (s === c) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var f = u(t, e, r);

              if ("normal" === f.type) {
                if (n = r.done ? "completed" : "suspendedYield", f.arg === c) continue;
                return {
                  value: f.arg,
                  done: r.done
                };
              }

              "throw" === f.type && (n = "completed", r.method = "throw", r.arg = f.arg);
            }
          };
        }(t, r, a), o;
      }

      function u(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = s;
      var c = {};

      function f() {}

      function l() {}

      function h() {}

      var p = {};

      p[i] = function () {
        return this;
      };

      var d = Object.getPrototypeOf,
          v = d && d(d(k([])));
      v && v !== e && r.call(v, i) && (p = v);
      var g = h.prototype = f.prototype = Object.create(p);

      function y(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function b(t) {
        var e;

        this._invoke = function (n, i) {
          function o() {
            return new Promise(function (e, o) {
              !function e(n, i, o, a) {
                var s = u(t[n], t, i);

                if ("throw" !== s.type) {
                  var c = s.arg,
                      f = c.value;
                  return f && "object" == typeof f && r.call(f, "__await") ? Promise.resolve(f.__await).then(function (t) {
                    e("next", t, o, a);
                  }, function (t) {
                    e("throw", t, o, a);
                  }) : Promise.resolve(f).then(function (t) {
                    c.value = t, o(c);
                  }, function (t) {
                    return e("throw", t, o, a);
                  });
                }

                a(s.arg);
              }(n, i, e, o);
            });
          }

          return e = e ? e.then(o, o) : o();
        };
      }

      function _(t, e) {
        var r = t.iterator[e.method];

        if (void 0 === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = void 0, _(t, e), "throw" === e.method)) return c;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return c;
        }

        var n = u(r, t.iterator, e.arg);
        if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, c;
        var i = n.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, c) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, c);
      }

      function m(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function w(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function x(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(m, this), this.reset(!0);
      }

      function k(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                o = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return o.next = o;
          }
        }

        return {
          next: E
        };
      }

      function E() {
        return {
          value: void 0,
          done: !0
        };
      }

      return l.prototype = g.constructor = h, h.constructor = l, h[a] = l.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === l || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(g), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, y(b.prototype), b.prototype[o] = function () {
        return this;
      }, t.AsyncIterator = b, t.async = function (e, r, n, i) {
        var o = new b(s(e, r, n, i));
        return t.isGeneratorFunction(r) ? o : o.next().then(function (t) {
          return t.done ? t.value : o.next();
        });
      }, y(g), g[a] = "Generator", g[i] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = k, x.prototype = {
        constructor: x,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i],
                a = o.completion;
            if ("root" === o.tryLoc) return n("end");

            if (o.tryLoc <= this.prev) {
              var s = r.call(o, "catchLoc"),
                  u = r.call(o, "finallyLoc");

              if (s && u) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return n(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var i = this.tryEntries[n];

            if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, c) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), c;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), w(r), c;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var i = n.arg;
                w(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: k(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), c;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : t.exports = function (t, e) {
      t.super_ = e;

      var r = function r() {};

      r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
    };
  }, function (t, e) {
    function r(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    t.exports = function (t, e, n) {
      return e && r(t.prototype, e), n && r(t, n), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    var r = Math.ceil,
        n = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? n : r)(t);
    };
  }, function (t, e, r) {
    var n = r(71),
        i = r(60),
        o = r(27),
        a = r(15),
        s = r(112),
        u = [].push,
        c = function c(t) {
      var e = 1 == t,
          r = 2 == t,
          c = 3 == t,
          f = 4 == t,
          l = 6 == t,
          h = 5 == t || l;
      return function (p, d, v, g) {
        for (var y, b, _ = o(p), m = i(_), w = n(d, v, 3), x = a(m.length), k = 0, E = g || s, S = e ? E(p, x) : r ? E(p, 0) : void 0; x > k; k++) {
          if ((h || k in m) && (b = w(y = m[k], k, _), t)) if (e) S[k] = b;else if (b) switch (t) {
            case 3:
              return !0;

            case 5:
              return y;

            case 6:
              return k;

            case 2:
              u.call(S, y);
          } else if (f) return !1;
        }

        return l ? -1 : c || f ? f : S;
      };
    };

    t.exports = {
      forEach: c(0),
      map: c(1),
      filter: c(2),
      some: c(3),
      every: c(4),
      find: c(5),
      findIndex: c(6)
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(53);
    n({
      target: "RegExp",
      proto: !0,
      forced: /./.exec !== i
    }, {
      exec: i
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(5);

    t.exports = function (t, e) {
      var r = [][t];
      return !r || !n(function () {
        r.call(null, e || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(33).map,
        o = r(5),
        a = r(54)("map"),
        s = a && !o(function () {
      [].map.call({
        length: -1,
        0: 1
      }, function (t) {
        throw t;
      });
    });
    n({
      target: "Array",
      proto: !0,
      forced: !a || !s
    }, {
      map: function map(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e) {
    var r,
        n,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        n = a;
      }
    }();
    var u,
        c = [],
        f = !1,
        l = -1;

    function h() {
      f && u && (f = !1, u.length ? c = u.concat(c) : l = -1, c.length && p());
    }

    function p() {
      if (!f) {
        var t = s(h);
        f = !0;

        for (var e = c.length; e;) {
          for (u = c, c = []; ++l < e;) {
            u && u[l].run();
          }

          l = -1, e = c.length;
        }

        u = null, f = !1, function (t) {
          if (n === clearTimeout) return clearTimeout(t);
          if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

          try {
            n(t);
          } catch (e) {
            try {
              return n.call(null, t);
            } catch (e) {
              return n.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      c.push(new d(t, e)), 1 !== c.length || f || s(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = v, i.addListener = v, i.once = v, i.off = v, i.removeListener = v, i.removeAllListeners = v, i.emit = v, i.prependListener = v, i.prependOnceListener = v, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    (function (t) {
      function r(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, e.isNull = function (t) {
        return null === t;
      }, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = function (t) {
        return "number" == typeof t;
      }, e.isString = function (t) {
        return "string" == typeof t;
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = function (t) {
        return void 0 === t;
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === r(t);
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t;
      }, e.isDate = function (t) {
        return "[object Date]" === r(t);
      }, e.isError = function (t) {
        return "[object Error]" === r(t) || t instanceof Error;
      }, e.isFunction = function (t) {
        return "function" == typeof t;
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = t.isBuffer;
    }).call(this, r(92).Buffer);
  }, function (t, e, r) {
    var n = r(96),
        i = r(155);

    t.exports = function (t, e) {
      return !e || "object" !== n(e) && "function" != typeof e ? i(t) : e;
    };
  }, function (t, e, r) {
    var n = r(80);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && n(t, e);
    };
  }, function (t, e, r) {
    var n = r(166),
        i = r(167),
        o = r(168);

    t.exports = function (t, e) {
      return n(t) || i(t, e) || o();
    };
  }, function (t, e, r) {
    var n = r(10);

    t.exports = function (t, e) {
      if (!n(t)) return t;
      var r, i;
      if (e && "function" == typeof (r = t.toString) && !n(i = r.call(t))) return i;
      if ("function" == typeof (r = t.valueOf) && !n(i = r.call(t))) return i;
      if (!e && "function" == typeof (r = t.toString) && !n(i = r.call(t))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, r) {
    var n = r(64),
        i = r(65),
        o = n("keys");

    t.exports = function (t) {
      return o[t] || (o[t] = i(t));
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, r) {
    var n = r(104),
        i = r(67).concat("length", "prototype");

    e.f = Object.getOwnPropertyNames || function (t) {
      return n(t, i);
    };
  }, function (t, e, r) {
    var n = r(19);

    t.exports = Array.isArray || function (t) {
      return "Array" == n(t);
    };
  }, function (t, e, r) {
    var n = r(104),
        i = r(67);

    t.exports = Object.keys || function (t) {
      return n(t, i);
    };
  }, function (t, e, r) {
    var n = r(11).f,
        i = r(13),
        o = r(3)("toStringTag");

    t.exports = function (t, e, r) {
      t && !i(t = r ? t : t.prototype, o) && n(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
      return t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(12),
        i = r(113),
        o = r(34),
        a = r(24),
        s = r(114),
        u = a.set,
        c = a.getterFor("Array Iterator");
    t.exports = s(Array, "Array", function (t, e) {
      u(this, {
        type: "Array Iterator",
        target: n(t),
        index: 0,
        kind: e
      });
    }, function () {
      var t = c(this),
          e = t.target,
          r = t.kind,
          n = t.index++;
      return !e || n >= e.length ? (t.target = void 0, {
        value: void 0,
        done: !0
      }) : "keys" == r ? {
        value: n,
        done: !1
      } : "values" == r ? {
        value: e[n],
        done: !1
      } : {
        value: [n, e[n]],
        done: !1
      };
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  }, function (t, e, r) {
    var n = r(72),
        i = r(17),
        o = r(154);
    n || i(Object.prototype, "toString", o, {
      unsafe: !0
    });
  }, function (t, e, r) {
    "use strict";

    var n,
        i,
        o = r(73),
        a = r(119),
        s = RegExp.prototype.exec,
        u = String.prototype.replace,
        c = s,
        f = (n = /a/, i = /b*/g, s.call(n, "a"), s.call(i, "a"), 0 !== n.lastIndex || 0 !== i.lastIndex),
        l = a.UNSUPPORTED_Y || a.BROKEN_CARET,
        h = void 0 !== /()??/.exec("")[1];
    (f || h || l) && (c = function c(t) {
      var e,
          r,
          n,
          i,
          a = this,
          c = l && a.sticky,
          p = o.call(a),
          d = a.source,
          v = 0,
          g = t;
      return c && (-1 === (p = p.replace("y", "")).indexOf("g") && (p += "g"), g = String(t).slice(a.lastIndex), a.lastIndex > 0 && (!a.multiline || a.multiline && "\n" !== t[a.lastIndex - 1]) && (d = "(?: " + d + ")", g = " " + g, v++), r = new RegExp("^(?:" + d + ")", p)), h && (r = new RegExp("^" + d + "$(?!\\s)", p)), f && (e = a.lastIndex), n = s.call(c ? r : a, g), c ? n ? (n.input = n.input.slice(v), n[0] = n[0].slice(v), n.index = a.lastIndex, a.lastIndex += n[0].length) : a.lastIndex = 0 : f && n && (a.lastIndex = a.global ? n.index + n[0].length : e), h && n && n.length > 1 && u.call(n[0], r, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          void 0 === arguments[i] && (n[i] = void 0);
        }
      }), n;
    }), t.exports = c;
  }, function (t, e, r) {
    var n = r(5),
        i = r(3),
        o = r(83),
        a = i("species");

    t.exports = function (t) {
      return o >= 51 || !n(function () {
        var e = [];
        return (e.constructor = {})[a] = function () {
          return {
            foo: 1
          };
        }, 1 !== e[t](Boolean).foo;
      });
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function nextTick(t, r, n, i) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var o,
              a,
              s = arguments.length;

          switch (s) {
            case 0:
            case 1:
              return e.nextTick(t);

            case 2:
              return e.nextTick(function () {
                t.call(null, r);
              });

            case 3:
              return e.nextTick(function () {
                t.call(null, r, n);
              });

            case 4:
              return e.nextTick(function () {
                t.call(null, r, n, i);
              });

            default:
              for (o = new Array(s - 1), a = 0; a < o.length;) {
                o[a++] = arguments[a];
              }

              return e.nextTick(function () {
                t.apply(null, o);
              });
          }
        }
      } : t.exports = e;
    }).call(this, r(38));
  }, function (t, e, r) {
    var n = r(92),
        i = n.Buffer;

    function o(t, e) {
      for (var r in t) {
        e[r] = t[r];
      }
    }

    function a(t, e, r) {
      return i(t, e, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, r);
    }, a.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var n = i(t);
      return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    }, a.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, a.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(t);
    };
  }, function (t, e, r) {
    var n = r(156);

    function i(e, r, o) {
      return "undefined" != typeof Reflect && Reflect.get ? t.exports = i = Reflect.get : t.exports = i = function i(t, e, r) {
        var i = n(t, e);

        if (i) {
          var o = Object.getOwnPropertyDescriptor(i, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, i(e, r, o || e);
    }

    t.exports = i;
  }, function (t, e, r) {
    (function (n) {
      e.log = function () {
        var _console;

        return "object" == typeof console && console.log && (_console = console).log.apply(_console, arguments);
      }, e.formatArgs = function (e) {
        if (e[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + e[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors) return;
        var r = "color: " + this.color;
        e.splice(1, 0, r, "color: inherit");
        var n = 0,
            i = 0;
        e[0].replace(/%[a-zA-Z%]/g, function (t) {
          "%%" !== t && (n++, "%c" === t && (i = n));
        }), e.splice(i, 0, r);
      }, e.save = function (t) {
        try {
          t ? e.storage.setItem("debug", t) : e.storage.removeItem("debug");
        } catch (t) {}
      }, e.load = function () {
        var t;

        try {
          t = e.storage.getItem("debug");
        } catch (t) {}

        !t && void 0 !== n && "env" in n && (t = n.env.DEBUG);
        return t;
      }, e.useColors = function () {
        if ("undefined" != typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
        if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
        return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }, e.storage = function () {
        try {
          return localStorage;
        } catch (t) {}
      }(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.exports = r(172)(e);
      var i = t.exports.formatters;

      i.j = function (t) {
        try {
          return JSON.stringify(t);
        } catch (t) {
          return "[UnexpectedJSONParseError]: " + t.message;
        }
      };
    }).call(this, r(38));
  }, function (t, e, r) {
    "use strict";

    var n = {}.propertyIsEnumerable,
        i = Object.getOwnPropertyDescriptor,
        o = i && !n.call({
      1: 2
    }, 1);
    e.f = o ? function (t) {
      var e = i(this, t);
      return !!e && e.enumerable;
    } : n;
  }, function (t, e, r) {
    var n = r(5),
        i = r(19),
        o = "".split;
    t.exports = n(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (t) {
      return "String" == i(t) ? o.call(t, "") : Object(t);
    } : Object;
  }, function (t, e, r) {
    var n = r(4),
        i = r(10),
        o = n.document,
        a = i(o) && i(o.createElement);

    t.exports = function (t) {
      return a ? o.createElement(t) : {};
    };
  }, function (t, e, r) {
    var n = r(4),
        i = r(14);

    t.exports = function (t, e) {
      try {
        i(n, t, e);
      } catch (r) {
        n[t] = e;
      }

      return e;
    };
  }, function (t, e, r) {
    var n = r(100),
        i = Function.toString;
    "function" != typeof n.inspectSource && (n.inspectSource = function (t) {
      return i.call(t);
    }), t.exports = n.inspectSource;
  }, function (t, e, r) {
    var n = r(25),
        i = r(100);
    (t.exports = function (t, e) {
      return i[t] || (i[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: "3.6.1",
      mode: n ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e) {
    var r = 0,
        n = Math.random();

    t.exports = function (t) {
      return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++r + n).toString(36);
    };
  }, function (t, e, r) {
    var n = r(12),
        i = r(15),
        o = r(105),
        a = function a(t) {
      return function (e, r, a) {
        var s,
            u = n(e),
            c = i(u.length),
            f = o(a, c);

        if (t && r != r) {
          for (; c > f;) {
            if ((s = u[f++]) != s) return !0;
          }
        } else for (; c > f; f++) {
          if ((t || f in u) && u[f] === r) return t || f || 0;
        }

        return !t && -1;
      };
    };

    t.exports = {
      includes: a(!0),
      indexOf: a(!1)
    };
  }, function (t, e) {
    t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (t, e, r) {
    var n = r(5),
        i = /#|\.prototype\./,
        o = function o(t, e) {
      var r = s[a(t)];
      return r == c || r != u && ("function" == typeof e ? n(e) : !!e);
    },
        a = o.normalize = function (t) {
      return String(t).replace(i, ".").toLowerCase();
    },
        s = o.data = {},
        u = o.NATIVE = "N",
        c = o.POLYFILL = "P";

    t.exports = o;
  }, function (t, e, r) {
    var n = r(5);
    t.exports = !!Object.getOwnPropertySymbols && !n(function () {
      return !String(Symbol());
    });
  }, function (t, e, r) {
    var n,
        i = r(8),
        o = r(108),
        a = r(67),
        s = r(45),
        u = r(109),
        c = r(61),
        f = r(44),
        l = f("IE_PROTO"),
        h = function h() {},
        p = function p(t) {
      return "<script>" + t + "<\/script>";
    },
        _d = function d() {
      try {
        n = document.domain && new ActiveXObject("htmlfile");
      } catch (t) {}

      var t, e;
      _d = n ? function (t) {
        t.write(p("")), t.close();
        var e = t.parentWindow.Object;
        return t = null, e;
      }(n) : ((e = c("iframe")).style.display = "none", u.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(p("document.F=Object")), t.close(), t.F);

      for (var r = a.length; r--;) {
        delete _d.prototype[a[r]];
      }

      return _d();
    };

    s[l] = !0, t.exports = Object.create || function (t, e) {
      var r;
      return null !== t ? (h.prototype = i(t), r = new h(), h.prototype = null, r[l] = t) : r = _d(), void 0 === e ? r : o(r, e);
    };
  }, function (t, e, r) {
    var n = r(50);

    t.exports = function (t, e, r) {
      if (n(t), void 0 === e) return t;

      switch (r) {
        case 0:
          return function () {
            return t.call(e);
          };

        case 1:
          return function (r) {
            return t.call(e, r);
          };

        case 2:
          return function (r, n) {
            return t.call(e, r, n);
          };

        case 3:
          return function (r, n, i) {
            return t.call(e, r, n, i);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, r) {
    var n = {};
    n[r(3)("toStringTag")] = "z", t.exports = "[object z]" === String(n);
  }, function (t, e, r) {
    "use strict";

    var n = r(8);

    t.exports = function () {
      var t = n(this),
          e = "";
      return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(120).charAt,
        i = r(24),
        o = r(114),
        a = i.set,
        s = i.getterFor("String Iterator");
    o(String, "String", function (t) {
      a(this, {
        type: "String Iterator",
        string: String(t),
        index: 0
      });
    }, function () {
      var t,
          e = s(this),
          r = e.string,
          i = e.index;
      return i >= r.length ? {
        value: void 0,
        done: !0
      } : (t = n(r, i), e.index += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(76),
        i = r(8),
        o = r(15),
        a = r(20),
        s = r(77),
        u = r(78);
    n("match", 1, function (t, e, r) {
      return [function (e) {
        var r = a(this),
            n = null == e ? void 0 : e[t];
        return void 0 !== n ? n.call(e, r) : new RegExp(e)[t](String(r));
      }, function (t) {
        var n = r(e, t, this);
        if (n.done) return n.value;
        var a = i(t),
            c = String(this);
        if (!a.global) return u(a, c);
        var f = a.unicode;
        a.lastIndex = 0;

        for (var l, h = [], p = 0; null !== (l = u(a, c));) {
          var d = String(l[0]);
          h[p] = d, "" === d && (a.lastIndex = s(c, o(a.lastIndex), f)), p++;
        }

        return 0 === p ? null : h;
      }];
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(17),
        i = r(5),
        o = r(3),
        a = r(53),
        s = r(14),
        u = o("species"),
        c = !i(function () {
      var t = /./;
      return t.exec = function () {
        var t = [];
        return t.groups = {
          a: "7"
        }, t;
      }, "7" !== "".replace(t, "$<a>");
    }),
        f = "$0" === "a".replace(/./, "$0"),
        l = !i(function () {
      var t = /(?:)/,
          e = t.exec;

      t.exec = function () {
        return e.apply(this, arguments);
      };

      var r = "ab".split(t);
      return 2 !== r.length || "a" !== r[0] || "b" !== r[1];
    });

    t.exports = function (t, e, r, h) {
      var p = o(t),
          d = !i(function () {
        var e = {};
        return e[p] = function () {
          return 7;
        }, 7 != ""[t](e);
      }),
          v = d && !i(function () {
        var e = !1,
            r = /a/;
        return "split" === t && ((r = {}).constructor = {}, r.constructor[u] = function () {
          return r;
        }, r.flags = "", r[p] = /./[p]), r.exec = function () {
          return e = !0, null;
        }, r[p](""), !e;
      });

      if (!d || !v || "replace" === t && (!c || !f) || "split" === t && !l) {
        var g = /./[p],
            y = r(p, ""[t], function (t, e, r, n, i) {
          return e.exec === a ? d && !i ? {
            done: !0,
            value: g.call(e, r, n)
          } : {
            done: !0,
            value: t.call(r, e, n)
          } : {
            done: !1
          };
        }, {
          REPLACE_KEEPS_$0: f
        }),
            b = y[0],
            _ = y[1];
        n(String.prototype, t, b), n(RegExp.prototype, p, 2 == e ? function (t, e) {
          return _.call(t, this, e);
        } : function (t) {
          return _.call(t, this);
        });
      }

      h && s(RegExp.prototype[p], "sham", !0);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(120).charAt;

    t.exports = function (t, e, r) {
      return e + (r ? n(t, e).length : 1);
    };
  }, function (t, e, r) {
    var n = r(19),
        i = r(53);

    t.exports = function (t, e) {
      var r = t.exec;

      if ("function" == typeof r) {
        var o = r.call(t, e);
        if ("object" != typeof o) throw TypeError("RegExp exec method returned something other than an Object or null");
        return o;
      }

      if ("RegExp" !== n(t)) throw TypeError("RegExp#exec called on incompatible receiver");
      return i.call(t, e);
    };
  }, function (t, e, r) {
    var n = r(4),
        i = r(121),
        o = r(51),
        a = r(14),
        s = r(3),
        u = s("iterator"),
        c = s("toStringTag"),
        f = o.values;

    for (var l in i) {
      var h = n[l],
          p = h && h.prototype;

      if (p) {
        if (p[u] !== f) try {
          a(p, u, f);
        } catch (t) {
          p[u] = f;
        }
        if (p[c] || a(p, c, l), i[l]) for (var d in o) {
          if (p[d] !== o[d]) try {
            a(p, d, o[d]);
          } catch (t) {
            p[d] = o[d];
          }
        }
      }
    }
  }, function (t, e) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, r(e, n);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(5),
        o = r(47),
        a = r(10),
        s = r(27),
        u = r(15),
        c = r(82),
        f = r(112),
        l = r(54),
        h = r(3),
        p = r(83),
        d = h("isConcatSpreadable"),
        v = p >= 51 || !i(function () {
      var t = [];
      return t[d] = !1, t.concat()[0] !== t;
    }),
        g = l("concat"),
        y = function y(t) {
      if (!a(t)) return !1;
      var e = t[d];
      return void 0 !== e ? !!e : o(t);
    };

    n({
      target: "Array",
      proto: !0,
      forced: !v || !g
    }, {
      concat: function concat(t) {
        var e,
            r,
            n,
            i,
            o,
            a = s(this),
            l = f(a, 0),
            h = 0;

        for (e = -1, n = arguments.length; e < n; e++) {
          if (o = -1 === e ? a : arguments[e], y(o)) {
            if (h + (i = u(o.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");

            for (r = 0; r < i; r++, h++) {
              r in o && c(l, h, o[r]);
            }
          } else {
            if (h >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
            c(l, h++, o);
          }
        }

        return l.length = h, l;
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(43),
        i = r(11),
        o = r(31);

    t.exports = function (t, e, r) {
      var a = n(e);
      a in t ? i.f(t, a, o(0, r)) : t[a] = r;
    };
  }, function (t, e, r) {
    var n,
        i,
        o = r(4),
        a = r(122),
        s = o.process,
        u = s && s.versions,
        c = u && u.v8;
    c ? i = (n = c.split("."))[0] + n[1] : a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (i = n[1]), t.exports = i && +i;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(33).filter,
        o = r(5),
        a = r(54)("filter"),
        s = a && !o(function () {
      [].filter.call({
        length: -1,
        0: 1
      }, function (t) {
        throw t;
      });
    });
    n({
      target: "Array",
      proto: !0,
      forced: !a || !s
    }, {
      filter: function filter(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(123);
    n({
      target: "Array",
      proto: !0,
      forced: [].forEach != i
    }, {
      forEach: i
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(66).includes,
        o = r(113);
    n({
      target: "Array",
      proto: !0
    }, {
      includes: function includes(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), o("includes");
  }, function (t, e, r) {
    var n = r(7),
        i = r(11).f,
        o = Function.prototype,
        a = o.toString,
        s = /^\s*function ([^ (]*)/;
    n && !("name" in o) && i(o, "name", {
      configurable: !0,
      get: function get() {
        try {
          return a.call(this).match(s)[1];
        } catch (t) {
          return "";
        }
      }
    });
  }, function (t, e, r) {
    var n = r(10),
        i = r(19),
        o = r(3)("match");

    t.exports = function (t) {
      var e;
      return n(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == i(t));
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(76),
        i = r(8),
        o = r(27),
        a = r(15),
        s = r(32),
        u = r(20),
        c = r(77),
        f = r(78),
        l = Math.max,
        h = Math.min,
        p = Math.floor,
        d = /\$([$&'`]|\d\d?|<[^>]*>)/g,
        v = /\$([$&'`]|\d\d?)/g;
    n("replace", 2, function (t, e, r, n) {
      return [function (r, n) {
        var i = u(this),
            o = null == r ? void 0 : r[t];
        return void 0 !== o ? o.call(r, i, n) : e.call(String(i), r, n);
      }, function (t, o) {
        if (n.REPLACE_KEEPS_$0 || "string" == typeof o && -1 === o.indexOf("$0")) {
          var u = r(e, t, this, o);
          if (u.done) return u.value;
        }

        var p = i(t),
            d = String(this),
            v = "function" == typeof o;
        v || (o = String(o));
        var y = p.global;

        if (y) {
          var b = p.unicode;
          p.lastIndex = 0;
        }

        for (var _ = [];;) {
          var m = f(p, d);
          if (null === m) break;
          if (_.push(m), !y) break;
          "" === String(m[0]) && (p.lastIndex = c(d, a(p.lastIndex), b));
        }

        for (var w, x = "", k = 0, E = 0; E < _.length; E++) {
          m = _[E];

          for (var S = String(m[0]), j = l(h(s(m.index), d.length), 0), R = [], C = 1; C < m.length; C++) {
            R.push(void 0 === (w = m[C]) ? w : String(w));
          }

          var I = m.groups;

          if (v) {
            var O = [S].concat(R, j, d);
            void 0 !== I && O.push(I);
            var T = String(o.apply(void 0, O));
          } else T = g(S, d, j, R, I, o);

          j >= k && (x += d.slice(k, j) + T, k = j + S.length);
        }

        return x + d.slice(k);
      }];

      function g(t, r, n, i, a, s) {
        var u = n + t.length,
            c = i.length,
            f = v;
        return void 0 !== a && (a = o(a), f = d), e.call(s, f, function (e, o) {
          var s;

          switch (o.charAt(0)) {
            case "$":
              return "$";

            case "&":
              return t;

            case "`":
              return r.slice(0, n);

            case "'":
              return r.slice(u);

            case "<":
              s = a[o.slice(1, -1)];
              break;

            default:
              var f = +o;
              if (0 === f) return e;

              if (f > c) {
                var l = p(f / 10);
                return 0 === l ? e : l <= c ? void 0 === i[l - 1] ? o.charAt(1) : i[l - 1] + o.charAt(1) : e;
              }

              s = i[f - 1];
          }

          return void 0 === s ? "" : s;
        });
      }
    });
  }, function (t, e, r) {
    var n = r(4),
        i = r(121),
        o = r(123),
        a = r(14);

    for (var s in i) {
      var u = n[s],
          c = u && u.prototype;
      if (c && c.forEach !== o) try {
        a(c, "forEach", o);
      } catch (t) {
        c.forEach = o;
      }
    }
  }, function (t, e, r) {
    "use strict";

    var n,
        i,
        o,
        a,
        s = r(2),
        u = r(25),
        c = r(4),
        f = r(26),
        l = r(177),
        h = r(17),
        p = r(178),
        d = r(49),
        v = r(125),
        g = r(10),
        y = r(50),
        b = r(179),
        _ = r(19),
        m = r(63),
        w = r(180),
        x = r(184),
        k = r(132),
        E = r(133).set,
        S = r(185),
        j = r(186),
        R = r(187),
        C = r(135),
        I = r(188),
        O = r(24),
        T = r(68),
        P = r(3),
        A = r(83),
        L = P("species"),
        F = "Promise",
        M = O.get,
        N = O.set,
        B = O.getterFor(F),
        _D = l,
        U = c.TypeError,
        q = c.document,
        G = c.process,
        W = f("fetch"),
        z = C.f,
        Y = z,
        Q = "process" == _(G),
        $ = !!(q && q.createEvent && c.dispatchEvent),
        H = T(F, function () {
      if (!(m(_D) !== String(_D))) {
        if (66 === A) return !0;
        if (!Q && "function" != typeof PromiseRejectionEvent) return !0;
      }

      if (u && !_D.prototype.finally) return !0;
      if (A >= 51 && /native code/.test(_D)) return !1;

      var t = _D.resolve(1),
          e = function e(t) {
        t(function () {}, function () {});
      };

      return (t.constructor = {})[L] = e, !(t.then(function () {}) instanceof e);
    }),
        K = H || !x(function (t) {
      _D.all(t).catch(function () {});
    }),
        V = function V(t) {
      var e;
      return !(!g(t) || "function" != typeof (e = t.then)) && e;
    },
        Z = function Z(t, e, r) {
      if (!e.notified) {
        e.notified = !0;
        var n = e.reactions;
        S(function () {
          for (var i = e.value, o = 1 == e.state, a = 0; n.length > a;) {
            var s,
                u,
                c,
                f = n[a++],
                l = o ? f.ok : f.fail,
                h = f.resolve,
                p = f.reject,
                d = f.domain;

            try {
              l ? (o || (2 === e.rejection && et(t, e), e.rejection = 1), !0 === l ? s = i : (d && d.enter(), s = l(i), d && (d.exit(), c = !0)), s === f.promise ? p(U("Promise-chain cycle")) : (u = V(s)) ? u.call(s, h, p) : h(s)) : p(i);
            } catch (t) {
              d && !c && d.exit(), p(t);
            }
          }

          e.reactions = [], e.notified = !1, r && !e.rejection && X(t, e);
        });
      }
    },
        J = function J(t, e, r) {
      var n, i;
      $ ? ((n = q.createEvent("Event")).promise = e, n.reason = r, n.initEvent(t, !1, !0), c.dispatchEvent(n)) : n = {
        promise: e,
        reason: r
      }, (i = c["on" + t]) ? i(n) : "unhandledrejection" === t && R("Unhandled promise rejection", r);
    },
        X = function X(t, e) {
      E.call(c, function () {
        var r,
            n = e.value;
        if (tt(e) && (r = I(function () {
          Q ? G.emit("unhandledRejection", n, t) : J("unhandledrejection", t, n);
        }), e.rejection = Q || tt(e) ? 2 : 1, r.error)) throw r.value;
      });
    },
        tt = function tt(t) {
      return 1 !== t.rejection && !t.parent;
    },
        et = function et(t, e) {
      E.call(c, function () {
        Q ? G.emit("rejectionHandled", t) : J("rejectionhandled", t, e.value);
      });
    },
        rt = function rt(t, e, r, n) {
      return function (i) {
        t(e, r, i, n);
      };
    },
        nt = function nt(t, e, r, n) {
      e.done || (e.done = !0, n && (e = n), e.value = r, e.state = 2, Z(t, e, !0));
    },
        it = function it(t, e, r, n) {
      if (!e.done) {
        e.done = !0, n && (e = n);

        try {
          if (t === r) throw U("Promise can't be resolved itself");
          var i = V(r);
          i ? S(function () {
            var n = {
              done: !1
            };

            try {
              i.call(r, rt(it, t, n, e), rt(nt, t, n, e));
            } catch (r) {
              nt(t, n, r, e);
            }
          }) : (e.value = r, e.state = 1, Z(t, e, !1));
        } catch (r) {
          nt(t, {
            done: !1
          }, r, e);
        }
      }
    };

    H && (_D = function D(t) {
      b(this, _D, F), y(t), n.call(this);
      var e = M(this);

      try {
        t(rt(it, this, e), rt(nt, this, e));
      } catch (t) {
        nt(this, e, t);
      }
    }, (n = function n(t) {
      N(this, {
        type: F,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: [],
        rejection: !1,
        state: 0,
        value: void 0
      });
    }).prototype = p(_D.prototype, {
      then: function then(t, e) {
        var r = B(this),
            n = z(k(this, _D));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = Q ? G.domain : void 0, r.parent = !0, r.reactions.push(n), 0 != r.state && Z(this, r, !1), n.promise;
      },
      catch: function _catch(t) {
        return this.then(void 0, t);
      }
    }), i = function i() {
      var t = new n(),
          e = M(t);
      this.promise = t, this.resolve = rt(it, t, e), this.reject = rt(nt, t, e);
    }, C.f = z = function z(t) {
      return t === _D || t === o ? new i(t) : Y(t);
    }, u || "function" != typeof l || (a = l.prototype.then, h(l.prototype, "then", function (t, e) {
      var r = this;
      return new _D(function (t, e) {
        a.call(r, t, e);
      }).then(t, e);
    }, {
      unsafe: !0
    }), "function" == typeof W && s({
      global: !0,
      enumerable: !0,
      forced: !0
    }, {
      fetch: function fetch(t) {
        return j(_D, W.apply(c, arguments));
      }
    }))), s({
      global: !0,
      wrap: !0,
      forced: H
    }, {
      Promise: _D
    }), d(_D, F, !1, !0), v(F), o = f(F), s({
      target: F,
      stat: !0,
      forced: H
    }, {
      reject: function reject(t) {
        var e = z(this);
        return e.reject.call(void 0, t), e.promise;
      }
    }), s({
      target: F,
      stat: !0,
      forced: u || H
    }, {
      resolve: function resolve(t) {
        return j(u && this === o ? _D : this, t);
      }
    }), s({
      target: F,
      stat: !0,
      forced: K
    }, {
      all: function all(t) {
        var e = this,
            r = z(e),
            n = r.resolve,
            i = r.reject,
            o = I(function () {
          var r = y(e.resolve),
              o = [],
              a = 0,
              s = 1;
          w(t, function (t) {
            var u = a++,
                c = !1;
            o.push(void 0), s++, r.call(e, t).then(function (t) {
              c || (c = !0, o[u] = t, --s || n(o));
            }, i);
          }), --s || n(o);
        });
        return o.error && i(o.value), r.promise;
      },
      race: function race(t) {
        var e = this,
            r = z(e),
            n = r.reject,
            i = I(function () {
          var i = y(e.resolve);
          w(t, function (t) {
            i.call(e, t).then(r.resolve, n);
          });
        });
        return i.error && n(i.value), r.promise;
      }
    });
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var n = r(190),
          i = r(191),
          o = r(137);

      function a() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(t, e) {
        if (a() < e) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
      }

      function u(t, e, r) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return l(this, t);
        }

        return c(this, t, e, r);
      }

      function c(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = h(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | d(e, r),
              i = (t = s(t, n)).write(e, r);
          i !== n && (t = t.slice(0, i));
          return t;
        }(t, e, r) : function (t, e) {
          if (u.isBuffer(e)) {
            var r = 0 | p(e.length);
            return 0 === (t = s(t, r)).length || e.copy(t, 0, 0, r), t;
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : h(t, e);
            if ("Buffer" === e.type && o(e.data)) return h(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function f(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function l(t, e) {
        if (f(e), t = s(t, e < 0 ? 0 : 0 | p(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function h(t, e) {
        var r = e.length < 0 ? 0 : 0 | p(e.length);
        t = s(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function p(t) {
        if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | t;
      }

      function d(t, e) {
        if (u.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return U(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return q(t).length;

            default:
              if (n) return U(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function v(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return I(this, e, r);

            case "utf8":
            case "utf-8":
              return j(this, e, r);

            case "ascii":
              return R(this, e, r);

            case "latin1":
            case "binary":
              return C(this, e, r);

            case "base64":
              return S(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return O(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function g(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function y(t, e, r, n, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (i) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, i);
        if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function b(t, e, r, n, i) {
        var o,
            a = 1,
            s = t.length,
            u = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, s /= 2, u /= 2, r /= 2;
        }

        function c(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a);
        }

        if (i) {
          var f = -1;

          for (o = r; o < s; o++) {
            if (c(t, o) === c(e, -1 === f ? 0 : o - f)) {
              if (-1 === f && (f = o), o - f + 1 === u) return f * a;
            } else -1 !== f && (o -= o - f), f = -1;
          }
        } else for (r + u > s && (r = s - u), o = r; o >= 0; o--) {
          for (var l = !0, h = 0; h < u; h++) {
            if (c(t, o + h) !== c(e, h)) {
              l = !1;
              break;
            }
          }

          if (l) return o;
        }

        return -1;
      }

      function _(t, e, r, n) {
        r = Number(r) || 0;
        var i = t.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        n > o / 2 && (n = o / 2);

        for (var a = 0; a < n; ++a) {
          var s = parseInt(e.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          t[r + a] = s;
        }

        return a;
      }

      function m(t, e, r, n) {
        return G(U(e, t.length - r), t, r, n);
      }

      function w(t, e, r, n) {
        return G(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function x(t, e, r, n) {
        return w(t, e, r, n);
      }

      function k(t, e, r, n) {
        return G(q(e), t, r, n);
      }

      function E(t, e, r, n) {
        return G(function (t, e) {
          for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
            r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }

          return o;
        }(e, t.length - r), t, r, n);
      }

      function S(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function j(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], i = e; i < r;) {
          var o,
              a,
              s,
              u,
              c = t[i],
              f = null,
              l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + l <= r) switch (l) {
            case 1:
              c < 128 && (f = c);
              break;

            case 2:
              128 == (192 & (o = t[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (f = u);
              break;

            case 3:
              o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (f = u);
              break;

            case 4:
              o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (f = u);
          }
          null === f ? (f = 65533, l = 1) : f > 65535 && (f -= 65536, n.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), n.push(f), i += l;
        }

        return function (t) {
          var e = t.length;
          if (e <= 4096) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
          }

          return r;
        }(n);
      }

      e.Buffer = u, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return u.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = a(), u.poolSize = 8192, u._augment = function (t) {
        return t.__proto__ = u.prototype, t;
      }, u.from = function (t, e, r) {
        return c(null, t, e, r);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return f(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
        }(null, t, e, r);
      }, u.allocUnsafe = function (t) {
        return l(null, t);
      }, u.allocUnsafeSlow = function (t) {
        return l(null, t);
      }, u.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, u.compare = function (t, e) {
        if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, u.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, u.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return u.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = u.allocUnsafe(e),
            i = 0;

        for (r = 0; r < t.length; ++r) {
          var a = t[r];
          if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(n, i), i += a.length;
        }

        return n;
      }, u.byteLength = d, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          g(this, e, e + 1);
        }

        return this;
      }, u.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          g(this, e, e + 3), g(this, e + 1, e + 2);
        }

        return this;
      }, u.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
        }

        return this;
      }, u.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? j(this, 0, t) : v.apply(this, arguments);
      }, u.prototype.equals = function (t) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === u.compare(this, t);
      }, u.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, u.prototype.compare = function (t, e, r, n, i) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && e >= r) return 0;
        if (n >= i) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), c = this.slice(n, i), f = t.slice(e, r), l = 0; l < s; ++l) {
          if (c[l] !== f[l]) {
            o = c[l], a = f[l];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, u.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, u.prototype.indexOf = function (t, e, r) {
        return y(this, t, e, r, !0);
      }, u.prototype.lastIndexOf = function (t, e, r) {
        return y(this, t, e, r, !1);
      }, u.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - e;
        if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var o = !1;;) {
          switch (n) {
            case "hex":
              return _(this, t, e, r);

            case "utf8":
            case "utf-8":
              return m(this, t, e, r);

            case "ascii":
              return w(this, t, e, r);

            case "latin1":
            case "binary":
              return x(this, t, e, r);

            case "base64":
              return k(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return E(this, t, e, r);

            default:
              if (o) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), o = !0;
          }
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function R(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(127 & t[i]);
        }

        return n;
      }

      function C(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(t[i]);
        }

        return n;
      }

      function I(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", o = e; o < r; ++o) {
          i += D(t[o]);
        }

        return i;
      }

      function O(t, e, r) {
        for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }

        return i;
      }

      function T(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function P(t, e, r, n, i, o) {
        if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function A(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
          t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function L(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
          t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function F(t, e, r, n, i, o) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function M(t, e, r, n, o) {
        return o || F(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
      }

      function N(t, e, r, n, o) {
        return o || F(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
      }

      u.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
          var i = e - t;
          r = new u(i, void 0);

          for (var o = 0; o < i; ++o) {
            r[o] = this[o + t];
          }
        }
        return r;
      }, u.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || T(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n;
      }, u.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || T(t, e, this.length);

        for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          n += this[t + --e] * i;
        }

        return n;
      }, u.prototype.readUInt8 = function (t, e) {
        return e || T(t, 1, this.length), this[t];
      }, u.prototype.readUInt16LE = function (t, e) {
        return e || T(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, u.prototype.readUInt16BE = function (t, e) {
        return e || T(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, u.prototype.readUInt32LE = function (t, e) {
        return e || T(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, u.prototype.readUInt32BE = function (t, e) {
        return e || T(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, u.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || T(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, u.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || T(t, e, this.length);

        for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
          o += this[t + --n] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, u.prototype.readInt8 = function (t, e) {
        return e || T(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, u.prototype.readInt16LE = function (t, e) {
        e || T(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt16BE = function (t, e) {
        e || T(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt32LE = function (t, e) {
        return e || T(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, u.prototype.readInt32BE = function (t, e) {
        return e || T(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, u.prototype.readFloatLE = function (t, e) {
        return e || T(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, u.prototype.readFloatBE = function (t, e) {
        return e || T(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (t, e) {
        return e || T(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (t, e) {
        return e || T(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || P(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < r && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, u.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || P(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, u.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, u.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : A(this, t, e, !0), e + 2;
      }, u.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : A(this, t, e, !1), e + 2;
      }, u.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
      }, u.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, u.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          P(this, t, e, r, i - 1, -i);
        }

        var o = 0,
            a = 1,
            s = 0;

        for (this[e] = 255 & t; ++o < r && (a *= 256);) {
          t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        }

        return e + r;
      }, u.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          P(this, t, e, r, i - 1, -i);
        }

        var o = r - 1,
            a = 1,
            s = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
          t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        }

        return e + r;
      }, u.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, u.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : A(this, t, e, !0), e + 2;
      }, u.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : A(this, t, e, !1), e + 2;
      }, u.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
      }, u.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || P(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, u.prototype.writeFloatLE = function (t, e, r) {
        return M(this, t, e, !0, r);
      }, u.prototype.writeFloatBE = function (t, e, r) {
        return M(this, t, e, !1, r);
      }, u.prototype.writeDoubleLE = function (t, e, r) {
        return N(this, t, e, !0, r);
      }, u.prototype.writeDoubleBE = function (t, e, r) {
        return N(this, t, e, !1, r);
      }, u.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var i,
            o = n - r;
        if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
          t[i + e] = this[i + r];
        } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          t[i + e] = this[i + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
        return o;
      }, u.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var o;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
          this[o] = t;
        } else {
          var a = u.isBuffer(t) ? t : U(new u(t, n).toString()),
              s = a.length;

          for (o = 0; o < r - e; ++o) {
            this[o + e] = a[o % s];
          }
        }
        return this;
      };
      var B = /[^+\/0-9A-Za-z-_]/g;

      function D(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function U(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
          if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === n) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((e -= 1) < 0) break;
            o.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return o;
      }

      function q(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(B, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function G(t, e, r, n) {
        for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
          e[i + r] = t[i];
        }

        return i;
      }
    }).call(this, r(21));
  }, function (t, e, r) {
    "use strict";

    var n,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
      return Function.prototype.apply.call(t, e, r);
    };
    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var a = Number.isNaN || function (t) {
      return t != t;
    };

    function s() {
      s.init.call(this);
    }

    t.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var u = 10;

    function c(t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    }

    function f(t) {
      return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
    }

    function l(t, e, r, n) {
      var i, o, a, s;
      if (c(r), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), a = o[e]), void 0 === a) a = o[e] = r, ++t._eventsCount;else if ("function" == typeof a ? a = o[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = f(t)) > 0 && a.length > i && !a.warned) {
        a.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = a.length, s = u, console && console.warn && console.warn(s);
      }
      return t;
    }

    function h() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }

    function p(t, e, r) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: r
      },
          i = h.bind(n);
      return i.listener = r, n.wrapFn = i, i;
    }

    function d(t, e, r) {
      var n = t._events;
      if (void 0 === n) return [];
      var i = n[e];
      return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
        for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
          e[r] = t[r].listener || t[r];
        }

        return e;
      }(i) : g(i, i.length);
    }

    function v(t) {
      var e = this._events;

      if (void 0 !== e) {
        var r = e[t];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }

      return 0;
    }

    function g(t, e) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = t[n];
      }

      return r;
    }

    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, s.prototype.getMaxListeners = function () {
      return f(this);
    }, s.prototype.emit = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e.push(arguments[r]);
      }

      var n = "error" === t,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var a;
        if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw s.context = a, s;
      }

      var u = i[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) o(u, this, e);else {
        var c = u.length,
            f = g(u, c);

        for (r = 0; r < c; ++r) {
          o(f[r], this, e);
        }
      }
      return !0;
    }, s.prototype.addListener = function (t, e) {
      return l(this, t, e, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (t, e) {
      return l(this, t, e, !0);
    }, s.prototype.once = function (t, e) {
      return c(e), this.on(t, p(this, t, e)), this;
    }, s.prototype.prependOnceListener = function (t, e) {
      return c(e), this.prependListener(t, p(this, t, e)), this;
    }, s.prototype.removeListener = function (t, e) {
      var r, n, i, o, a;
      if (c(e), void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[t])) return this;
      if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
        for (i = -1, o = r.length - 1; o >= 0; o--) {
          if (r[o] === e || r[o].listener === e) {
            a = r[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? r.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, a || e);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (t) {
      var e, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(r);

        for (n = 0; n < o.length; ++n) {
          "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
        this.removeListener(t, e[n]);
      }
      return this;
    }, s.prototype.listeners = function (t) {
      return d(this, t, !0);
    }, s.prototype.rawListeners = function (t) {
      return d(this, t, !1);
    }, s.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : v.call(t, e);
    }, s.prototype.listenerCount = v, s.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (t, e, r) {
    (e = t.exports = r(138)).Stream = e, e.Readable = e, e.Writable = r(95), e.Duplex = r(23), e.Transform = r(142), e.PassThrough = r(196);
  }, function (t, e, r) {
    "use strict";

    (function (e, n, i) {
      var o = r(55);

      function a(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (t, e, r) {
            var n = t.entry;
            t.entry = null;

            for (; n;) {
              var i = n.callback;
              e.pendingcb--, i(r), n = n.next;
            }

            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
          }(e, t);
        };
      }

      t.exports = b;
      var s,
          u = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
      b.WritableState = y;
      var c = r(39);
      c.inherits = r(29);

      var f = {
        deprecate: r(195)
      },
          l = r(139),
          h = r(56).Buffer,
          p = i.Uint8Array || function () {};

      var d,
          v = r(140);

      function g() {}

      function y(t, e) {
        s = s || r(23), t = t || {};
        var n = e instanceof s;
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            c = t.writableHighWaterMark,
            f = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : f, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var l = !1 === t.decodeStrings;
        this.decodeStrings = !l, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          !function (t, e) {
            var r = t._writableState,
                n = r.sync,
                i = r.writecb;
            if (function (t) {
              t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(r), e) !function (t, e, r, n, i) {
              --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(E, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), E(t, e));
            }(t, r, n, e, i);else {
              var a = x(r);
              a || r.corked || r.bufferProcessing || !r.bufferedRequest || w(t, r), n ? u(m, t, r, a, i) : m(t, r, a, i);
            }
          }(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
      }

      function b(t) {
        if (s = s || r(23), !(d.call(b, this) || this instanceof s)) return new b(t);
        this._writableState = new y(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), l.call(this);
      }

      function _(t, e, r, n, i, o, a) {
        e.writelen = n, e.writecb = a, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function m(t, e, r, n) {
        r || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
        }(t, e), e.pendingcb--, n(), E(t, e);
      }

      function w(t, e) {
        e.bufferProcessing = !0;
        var r = e.bufferedRequest;

        if (t._writev && r && r.next) {
          var n = e.bufferedRequestCount,
              i = new Array(n),
              o = e.corkedRequestsFree;
          o.entry = r;

          for (var s = 0, u = !0; r;) {
            i[s] = r, r.isBuf || (u = !1), r = r.next, s += 1;
          }

          i.allBuffers = u, _(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var c = r.chunk,
                f = r.encoding,
                l = r.callback;
            if (_(t, e, !1, e.objectMode ? 1 : c.length, c, f, l), r = r.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === r && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = r, e.bufferProcessing = !1;
      }

      function x(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function k(t, e) {
        t._final(function (r) {
          e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), E(t, e);
        });
      }

      function E(t, e) {
        var r = x(e);
        return r && (!function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(k, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
      }

      c.inherits(b, l), y.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(y.prototype, "buffer", {
            get: f.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (d = Function.prototype[Symbol.hasInstance], Object.defineProperty(b, Symbol.hasInstance, {
        value: function value(t) {
          return !!d.call(this, t) || this === b && t && t._writableState instanceof y;
        }
      })) : d = function d(t) {
        return t instanceof this;
      }, b.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, b.prototype.write = function (t, e, r) {
        var n,
            i = this._writableState,
            a = !1,
            s = !i.objectMode && (n = t, h.isBuffer(n) || n instanceof p);
        return s && !h.isBuffer(t) && (t = function (t) {
          return h.from(t);
        }(t)), "function" == typeof e && (r = e, e = null), s ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = g), i.ended ? function (t, e) {
          var r = new Error("write after end");
          t.emit("error", r), o.nextTick(e, r);
        }(this, r) : (s || function (t, e, r, n) {
          var i = !0,
              a = !1;
          return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(n, a), i = !1), i;
        }(this, i, t, r)) && (i.pendingcb++, a = function (t, e, r, n, i, o) {
          if (!r) {
            var a = function (t, e, r) {
              t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = h.from(e, r));
              return e;
            }(e, n, i);

            n !== a && (r = !0, i = "buffer", n = a);
          }

          var s = e.objectMode ? 1 : n.length;
          e.length += s;
          var u = e.length < e.highWaterMark;
          u || (e.needDrain = !0);

          if (e.writing || e.corked) {
            var c = e.lastBufferedRequest;
            e.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, c ? c.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
          } else _(t, e, !1, s, n, i, o);

          return u;
        }(this, i, s, t, e, r)), a;
      }, b.prototype.cork = function () {
        this._writableState.corked++;
      }, b.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || w(this, t));
      }, b.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, Object.defineProperty(b.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), b.prototype._write = function (t, e, r) {
        r(new Error("_write() is not implemented"));
      }, b.prototype._writev = null, b.prototype.end = function (t, e, r) {
        var n = this._writableState;
        "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
          e.ending = !0, E(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r));
          e.ended = !0, t.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(b.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), b.prototype.destroy = v.destroy, b.prototype._undestroy = v.undestroy, b.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(this, r(38), r(136).setImmediate, r(21));
  }, function (t, e) {
    function r(e) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = r = function r(t) {
        return typeof t;
      } : t.exports = r = function r(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, r(e);
    }

    t.exports = r;
  }, function (t, e, r) {
    var n = r(16),
        i = r(80),
        o = r(202),
        a = r(203);

    function s(e) {
      var r = "function" == typeof Map ? new Map() : void 0;
      return t.exports = s = function s(t) {
        if (null === t || !o(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== r) {
          if (r.has(t)) return r.get(t);
          r.set(t, e);
        }

        function e() {
          return a(t, arguments, n(this).constructor);
        }

        return e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i(e, t);
      }, s(e);
    }

    t.exports = s;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(4),
        o = r(26),
        a = r(25),
        s = r(7),
        u = r(69),
        c = r(107),
        f = r(5),
        l = r(13),
        h = r(47),
        p = r(10),
        d = r(8),
        v = r(27),
        g = r(12),
        y = r(43),
        b = r(31),
        _ = r(70),
        m = r(48),
        w = r(46),
        x = r(148),
        k = r(106),
        E = r(22),
        S = r(11),
        j = r(59),
        R = r(14),
        C = r(17),
        I = r(64),
        O = r(44),
        T = r(45),
        P = r(65),
        A = r(3),
        L = r(110),
        F = r(111),
        M = r(49),
        N = r(24),
        B = r(33).forEach,
        D = O("hidden"),
        U = A("toPrimitive"),
        q = N.set,
        G = N.getterFor("Symbol"),
        W = Object.prototype,
        _z = i.Symbol,
        Y = o("JSON", "stringify"),
        Q = E.f,
        $ = S.f,
        H = x.f,
        K = j.f,
        V = I("symbols"),
        Z = I("op-symbols"),
        J = I("string-to-symbol-registry"),
        X = I("symbol-to-string-registry"),
        tt = I("wks"),
        et = i.QObject,
        rt = !et || !et.prototype || !et.prototype.findChild,
        nt = s && f(function () {
      return 7 != _($({}, "a", {
        get: function get() {
          return $(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, r) {
      var n = Q(W, e);
      n && delete W[e], $(t, e, r), n && t !== W && $(W, e, n);
    } : $,
        it = function it(t, e) {
      var r = V[t] = _(_z.prototype);

      return q(r, {
        type: "Symbol",
        tag: t,
        description: e
      }), s || (r.description = e), r;
    },
        ot = c ? function (t) {
      return "symbol" == typeof t;
    } : function (t) {
      return Object(t) instanceof _z;
    },
        at = function at(t, e, r) {
      t === W && at(Z, e, r), d(t);
      var n = y(e, !0);
      return d(r), l(V, n) ? (r.enumerable ? (l(t, D) && t[D][n] && (t[D][n] = !1), r = _(r, {
        enumerable: b(0, !1)
      })) : (l(t, D) || $(t, D, b(1, {})), t[D][n] = !0), nt(t, n, r)) : $(t, n, r);
    },
        st = function st(t, e) {
      d(t);
      var r = g(e),
          n = m(r).concat(lt(r));
      return B(n, function (e) {
        s && !ut.call(r, e) || at(t, e, r[e]);
      }), t;
    },
        ut = function ut(t) {
      var e = y(t, !0),
          r = K.call(this, e);
      return !(this === W && l(V, e) && !l(Z, e)) && (!(r || !l(this, e) || !l(V, e) || l(this, D) && this[D][e]) || r);
    },
        ct = function ct(t, e) {
      var r = g(t),
          n = y(e, !0);

      if (r !== W || !l(V, n) || l(Z, n)) {
        var i = Q(r, n);
        return !i || !l(V, n) || l(r, D) && r[D][n] || (i.enumerable = !0), i;
      }
    },
        ft = function ft(t) {
      var e = H(g(t)),
          r = [];
      return B(e, function (t) {
        l(V, t) || l(T, t) || r.push(t);
      }), r;
    },
        lt = function lt(t) {
      var e = t === W,
          r = H(e ? Z : g(t)),
          n = [];
      return B(r, function (t) {
        !l(V, t) || e && !l(W, t) || n.push(V[t]);
      }), n;
    };

    (u || (C((_z = function z() {
      if (this instanceof _z) throw TypeError("Symbol is not a constructor");

      var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
          e = P(t),
          r = function r(t) {
        this === W && r.call(Z, t), l(this, D) && l(this[D], e) && (this[D][e] = !1), nt(this, e, b(1, t));
      };

      return s && rt && nt(W, e, {
        configurable: !0,
        set: r
      }), it(e, t);
    }).prototype, "toString", function () {
      return G(this).tag;
    }), C(_z, "withoutSetter", function (t) {
      return it(P(t), t);
    }), j.f = ut, S.f = at, E.f = ct, w.f = x.f = ft, k.f = lt, L.f = function (t) {
      return it(A(t), t);
    }, s && ($(_z.prototype, "description", {
      configurable: !0,
      get: function get() {
        return G(this).description;
      }
    }), a || C(W, "propertyIsEnumerable", ut, {
      unsafe: !0
    }))), n({
      global: !0,
      wrap: !0,
      forced: !u,
      sham: !u
    }, {
      Symbol: _z
    }), B(m(tt), function (t) {
      F(t);
    }), n({
      target: "Symbol",
      stat: !0,
      forced: !u
    }, {
      for: function _for(t) {
        var e = String(t);
        if (l(J, e)) return J[e];

        var r = _z(e);

        return J[e] = r, X[r] = e, r;
      },
      keyFor: function keyFor(t) {
        if (!ot(t)) throw TypeError(t + " is not a symbol");
        if (l(X, t)) return X[t];
      },
      useSetter: function useSetter() {
        rt = !0;
      },
      useSimple: function useSimple() {
        rt = !1;
      }
    }), n({
      target: "Object",
      stat: !0,
      forced: !u,
      sham: !s
    }, {
      create: function create(t, e) {
        return void 0 === e ? _(t) : st(_(t), e);
      },
      defineProperty: at,
      defineProperties: st,
      getOwnPropertyDescriptor: ct
    }), n({
      target: "Object",
      stat: !0,
      forced: !u
    }, {
      getOwnPropertyNames: ft,
      getOwnPropertySymbols: lt
    }), n({
      target: "Object",
      stat: !0,
      forced: f(function () {
        k.f(1);
      })
    }, {
      getOwnPropertySymbols: function getOwnPropertySymbols(t) {
        return k.f(v(t));
      }
    }), Y) && n({
      target: "JSON",
      stat: !0,
      forced: !u || f(function () {
        var t = _z();

        return "[null]" != Y([t]) || "{}" != Y({
          a: t
        }) || "{}" != Y(Object(t));
      })
    }, {
      stringify: function stringify(t, e, r) {
        for (var n, i = [t], o = 1; arguments.length > o;) {
          i.push(arguments[o++]);
        }

        if (n = e, (p(e) || void 0 !== t) && !ot(t)) return h(e) || (e = function e(t, _e) {
          if ("function" == typeof n && (_e = n.call(this, t, _e)), !ot(_e)) return _e;
        }), i[1] = e, Y.apply(null, i);
      }
    });
    _z.prototype[U] || R(_z.prototype, U, _z.prototype.valueOf), M(_z, "Symbol"), T[D] = !0;
  }, function (t, e, r) {
    var n = r(7),
        i = r(5),
        o = r(61);
    t.exports = !n && !i(function () {
      return 7 != Object.defineProperty(o("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, r) {
    var n = r(4),
        i = r(62),
        o = n["__core-js_shared__"] || i("__core-js_shared__", {});
    t.exports = o;
  }, function (t, e, r) {
    var n = r(13),
        i = r(102),
        o = r(22),
        a = r(11);

    t.exports = function (t, e) {
      for (var r = i(e), s = a.f, u = o.f, c = 0; c < r.length; c++) {
        var f = r[c];
        n(t, f) || s(t, f, u(e, f));
      }
    };
  }, function (t, e, r) {
    var n = r(26),
        i = r(46),
        o = r(106),
        a = r(8);

    t.exports = n("Reflect", "ownKeys") || function (t) {
      var e = i.f(a(t)),
          r = o.f;
      return r ? e.concat(r(t)) : e;
    };
  }, function (t, e, r) {
    var n = r(4);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(13),
        i = r(12),
        o = r(66).indexOf,
        a = r(45);

    t.exports = function (t, e) {
      var r,
          s = i(t),
          u = 0,
          c = [];

      for (r in s) {
        !n(a, r) && n(s, r) && c.push(r);
      }

      for (; e.length > u;) {
        n(s, r = e[u++]) && (~o(c, r) || c.push(r));
      }

      return c;
    };
  }, function (t, e, r) {
    var n = r(32),
        i = Math.max,
        o = Math.min;

    t.exports = function (t, e) {
      var r = n(t);
      return r < 0 ? i(r + e, 0) : o(r, e);
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, r) {
    var n = r(69);
    t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (t, e, r) {
    var n = r(7),
        i = r(11),
        o = r(8),
        a = r(48);
    t.exports = n ? Object.defineProperties : function (t, e) {
      o(t);

      for (var r, n = a(e), s = n.length, u = 0; s > u;) {
        i.f(t, r = n[u++], e[r]);
      }

      return t;
    };
  }, function (t, e, r) {
    var n = r(26);
    t.exports = n("document", "documentElement");
  }, function (t, e, r) {
    var n = r(3);
    e.f = n;
  }, function (t, e, r) {
    var n = r(103),
        i = r(13),
        o = r(110),
        a = r(11).f;

    t.exports = function (t) {
      var e = n.Symbol || (n.Symbol = {});
      i(e, t) || a(e, t, {
        value: o.f(t)
      });
    };
  }, function (t, e, r) {
    var n = r(10),
        i = r(47),
        o = r(3)("species");

    t.exports = function (t, e) {
      var r;
      return i(t) && ("function" != typeof (r = t.constructor) || r !== Array && !i(r.prototype) ? n(r) && null === (r = r[o]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === e ? 0 : e);
    };
  }, function (t, e, r) {
    var n = r(3),
        i = r(70),
        o = r(11),
        a = n("unscopables"),
        s = Array.prototype;
    null == s[a] && o.f(s, a, {
      configurable: !0,
      value: i(null)
    }), t.exports = function (t) {
      s[a][t] = !0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(151),
        o = r(116),
        a = r(117),
        s = r(49),
        u = r(14),
        c = r(17),
        f = r(3),
        l = r(25),
        h = r(34),
        p = r(115),
        d = p.IteratorPrototype,
        v = p.BUGGY_SAFARI_ITERATORS,
        g = f("iterator"),
        y = function y() {
      return this;
    };

    t.exports = function (t, e, r, f, p, b, _) {
      i(r, e, f);

      var m,
          w,
          x,
          k = function k(t) {
        if (t === p && C) return C;
        if (!v && t in j) return j[t];

        switch (t) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new r(this, t);
            };
        }

        return function () {
          return new r(this);
        };
      },
          E = e + " Iterator",
          S = !1,
          j = t.prototype,
          R = j[g] || j["@@iterator"] || p && j[p],
          C = !v && R || k(p),
          I = "Array" == e && j.entries || R;

      if (I && (m = o(I.call(new t())), d !== Object.prototype && m.next && (l || o(m) === d || (a ? a(m, d) : "function" != typeof m[g] && u(m, g, y)), s(m, E, !0, !0), l && (h[E] = y))), "values" == p && R && "values" !== R.name && (S = !0, C = function C() {
        return R.call(this);
      }), l && !_ || j[g] === C || u(j, g, C), h[e] = C, p) if (w = {
        values: k("values"),
        keys: b ? C : k("keys"),
        entries: k("entries")
      }, _) for (x in w) {
        (v || S || !(x in j)) && c(j, x, w[x]);
      } else n({
        target: e,
        proto: !0,
        forced: v || S
      }, w);
      return w;
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i,
        o,
        a = r(116),
        s = r(14),
        u = r(13),
        c = r(3),
        f = r(25),
        l = c("iterator"),
        h = !1;
    [].keys && ("next" in (o = [].keys()) ? (i = a(a(o))) !== Object.prototype && (n = i) : h = !0), null == n && (n = {}), f || u(n, l) || s(n, l, function () {
      return this;
    }), t.exports = {
      IteratorPrototype: n,
      BUGGY_SAFARI_ITERATORS: h
    };
  }, function (t, e, r) {
    var n = r(13),
        i = r(27),
        o = r(44),
        a = r(152),
        s = o("IE_PROTO"),
        u = Object.prototype;
    t.exports = a ? Object.getPrototypeOf : function (t) {
      return t = i(t), n(t, s) ? t[s] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
    };
  }, function (t, e, r) {
    var n = r(8),
        i = r(153);
    t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var t,
          e = !1,
          r = {};

      try {
        (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), e = r instanceof Array;
      } catch (t) {}

      return function (r, o) {
        return n(r), i(o), e ? t.call(r, o) : r.__proto__ = o, r;
      };
    }() : void 0);
  }, function (t, e, r) {
    var n = r(72),
        i = r(19),
        o = r(3)("toStringTag"),
        a = "Arguments" == i(function () {
      return arguments;
    }());
    t.exports = n ? i : function (t) {
      var e, r, n;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), o)) ? r : a ? i(e) : "Object" == (n = i(e)) && "function" == typeof e.callee ? "Arguments" : n;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(5);

    function i(t, e) {
      return RegExp(t, e);
    }

    e.UNSUPPORTED_Y = n(function () {
      var t = i("a", "y");
      return t.lastIndex = 2, null != t.exec("abcd");
    }), e.BROKEN_CARET = n(function () {
      var t = i("^r", "gy");
      return t.lastIndex = 2, null != t.exec("str");
    });
  }, function (t, e, r) {
    var n = r(32),
        i = r(20),
        o = function o(t) {
      return function (e, r) {
        var o,
            a,
            s = String(i(e)),
            u = n(r),
            c = s.length;
        return u < 0 || u >= c ? t ? "" : void 0 : (o = s.charCodeAt(u)) < 55296 || o > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : o : t ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536;
      };
    };

    t.exports = {
      codeAt: o(!1),
      charAt: o(!0)
    };
  }, function (t, e) {
    t.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };
  }, function (t, e, r) {
    var n = r(26);
    t.exports = n("navigator", "userAgent") || "";
  }, function (t, e, r) {
    "use strict";

    var n = r(33).forEach,
        i = r(36);
    t.exports = i("forEach") ? function (t) {
      return n(this, t, arguments.length > 1 ? arguments[1] : void 0);
    } : [].forEach;
  }, function (t, e, r) {
    var n = r(2),
        i = r(27),
        o = r(48);
    n({
      target: "Object",
      stat: !0,
      forced: r(5)(function () {
        o(1);
      })
    }, {
      keys: function keys(t) {
        return o(i(t));
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(26),
        i = r(11),
        o = r(3),
        a = r(7),
        s = o("species");

    t.exports = function (t) {
      var e = n(t),
          r = i.f;
      a && e && !e[s] && r(e, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i = r(2),
        o = r(22).f,
        a = r(15),
        s = r(127),
        u = r(20),
        c = r(128),
        f = r(25),
        l = "".endsWith,
        h = Math.min,
        p = c("endsWith");
    i({
      target: "String",
      proto: !0,
      forced: !!(f || p || (n = o(String.prototype, "endsWith"), !n || n.writable)) && !p
    }, {
      endsWith: function endsWith(t) {
        var e = String(u(this));
        s(t);
        var r = arguments.length > 1 ? arguments[1] : void 0,
            n = a(e.length),
            i = void 0 === r ? n : h(a(r), n),
            o = String(t);
        return l ? l.call(e, o, i) : e.slice(i - o.length, i) === o;
      }
    });
  }, function (t, e, r) {
    var n = r(88);

    t.exports = function (t) {
      if (n(t)) throw TypeError("The method doesn't accept regular expressions");
      return t;
    };
  }, function (t, e, r) {
    var n = r(3)("match");

    t.exports = function (t) {
      var e = /./;

      try {
        "/./"[t](e);
      } catch (r) {
        try {
          return e[n] = !1, "/./"[t](e);
        } catch (t) {}
      }

      return !1;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(127),
        o = r(20);
    n({
      target: "String",
      proto: !0,
      forced: !r(128)("includes")
    }, {
      includes: function includes(t) {
        return !!~String(o(this)).indexOf(i(t), arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e, r) {
    var n = r(2),
        i = r(175);
    n({
      target: "Array",
      proto: !0,
      forced: i !== [].lastIndexOf
    }, {
      lastIndexOf: i
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(10),
        o = r(47),
        a = r(105),
        s = r(15),
        u = r(12),
        c = r(82),
        f = r(54),
        l = r(3)("species"),
        h = [].slice,
        p = Math.max;
    n({
      target: "Array",
      proto: !0,
      forced: !f("slice")
    }, {
      slice: function slice(t, e) {
        var r,
            n,
            f,
            d = u(this),
            v = s(d.length),
            g = a(t, v),
            y = a(void 0 === e ? v : e, v);
        if (o(d) && ("function" != typeof (r = d.constructor) || r !== Array && !o(r.prototype) ? i(r) && null === (r = r[l]) && (r = void 0) : r = void 0, r === Array || void 0 === r)) return h.call(d, g, y);

        for (n = new (void 0 === r ? Array : r)(p(y - g, 0)), f = 0; g < y; g++, f++) {
          g in d && c(n, f, d[g]);
        }

        return n.length = f, n;
      }
    });
  }, function (t, e, r) {
    var n = r(8),
        i = r(50),
        o = r(3)("species");

    t.exports = function (t, e) {
      var r,
          a = n(t).constructor;
      return void 0 === a || null == (r = n(a)[o]) ? e : i(r);
    };
  }, function (t, e, r) {
    var n,
        i,
        o,
        a = r(4),
        s = r(5),
        u = r(19),
        c = r(71),
        f = r(109),
        l = r(61),
        h = r(134),
        p = a.location,
        d = a.setImmediate,
        v = a.clearImmediate,
        g = a.process,
        y = a.MessageChannel,
        b = a.Dispatch,
        _ = 0,
        m = {},
        w = function w(t) {
      if (m.hasOwnProperty(t)) {
        var e = m[t];
        delete m[t], e();
      }
    },
        x = function x(t) {
      return function () {
        w(t);
      };
    },
        k = function k(t) {
      w(t.data);
    },
        E = function E(t) {
      a.postMessage(t + "", p.protocol + "//" + p.host);
    };

    d && v || (d = function d(t) {
      for (var e = [], r = 1; arguments.length > r;) {
        e.push(arguments[r++]);
      }

      return m[++_] = function () {
        ("function" == typeof t ? t : Function(t)).apply(void 0, e);
      }, n(_), _;
    }, v = function v(t) {
      delete m[t];
    }, "process" == u(g) ? n = function n(t) {
      g.nextTick(x(t));
    } : b && b.now ? n = function n(t) {
      b.now(x(t));
    } : y && !h ? (o = (i = new y()).port2, i.port1.onmessage = k, n = c(o.postMessage, o, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || s(E) ? n = "onreadystatechange" in l("script") ? function (t) {
      f.appendChild(l("script")).onreadystatechange = function () {
        f.removeChild(this), w(t);
      };
    } : function (t) {
      setTimeout(x(t), 0);
    } : (n = E, a.addEventListener("message", k, !1))), t.exports = {
      set: d,
      clear: v
    };
  }, function (t, e, r) {
    var n = r(122);
    t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(n);
  }, function (t, e, r) {
    "use strict";

    var n = r(50),
        i = function i(t) {
      var e, r;
      this.promise = new t(function (t, n) {
        if (void 0 !== e || void 0 !== r) throw TypeError("Bad Promise constructor");
        e = t, r = n;
      }), this.resolve = n(e), this.reject = n(r);
    };

    t.exports.f = function (t) {
      return new i(t);
    };
  }, function (t, e, r) {
    (function (t) {
      var n = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, n, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, n, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, r(189), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, r(21));
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e, n) {
      var i = r(55);
      t.exports = _;
      var o,
          a = r(137);
      _.ReadableState = b;
      r(93).EventEmitter;

      var s = function s(t, e) {
        return t.listeners(e).length;
      },
          u = r(139),
          c = r(56).Buffer,
          f = e.Uint8Array || function () {};

      var l = r(39);
      l.inherits = r(29);
      var h = r(192),
          p = void 0;
      p = h && h.debuglog ? h.debuglog("stream") : function () {};
      var d,
          v = r(193),
          g = r(140);
      l.inherits(_, u);
      var y = ["error", "close", "destroy", "pause", "resume"];

      function b(t, e) {
        t = t || {};
        var n = e instanceof (o = o || r(23));
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            a = t.readableHighWaterMark,
            s = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new v(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (d || (d = r(141).StringDecoder), this.decoder = new d(t.encoding), this.encoding = t.encoding);
      }

      function _(t) {
        if (o = o || r(23), !(this instanceof _)) return new _(t);
        this._readableState = new b(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this);
      }

      function m(t, e, r, n, i) {
        var o,
            a = t._readableState;
        null === e ? (a.reading = !1, function (t, e) {
          if (e.ended) return;

          if (e.decoder) {
            var r = e.decoder.end();
            r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
          }

          e.ended = !0, k(t);
        }(t, a)) : (i || (o = function (t, e) {
          var r;
          n = e, c.isBuffer(n) || n instanceof f || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === c.prototype || (e = function (t) {
          return c.from(t);
        }(e)), n ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? w(t, a, e, !1) : S(t, a)) : w(t, a, e, !1))) : n || (a.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
        }(a);
      }

      function w(t, e, r, n) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && k(t)), S(t, e);
      }

      Object.defineProperty(_.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), _.prototype.destroy = g.destroy, _.prototype._undestroy = g.undestroy, _.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, _.prototype.push = function (t, e) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = c.from(t, e), e = ""), r = !0), m(this, t, e, !1, r);
      }, _.prototype.unshift = function (t) {
        return m(this, t, null, !0, !1);
      }, _.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, _.prototype.setEncoding = function (t) {
        return d || (d = r(141).StringDecoder), this._readableState.decoder = new d(t), this._readableState.encoding = t, this;
      };

      function x(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= 8388608 ? t = 8388608 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function k(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (p("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(E, t) : E(t));
      }

      function E(t) {
        p("emit readable"), t.emit("readable"), I(t);
      }

      function S(t, e) {
        e.readingMore || (e.readingMore = !0, i.nextTick(j, t, e));
      }

      function j(t, e) {
        for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (p("maybeReadMore read 0"), t.read(0), r !== e.length);) {
          r = e.length;
        }

        e.readingMore = !1;
      }

      function R(t) {
        p("readable nexttick read 0"), t.read(0);
      }

      function C(t, e) {
        e.reading || (p("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), I(t), e.flowing && !e.reading && t.read(0);
      }

      function I(t) {
        var e = t._readableState;

        for (p("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function O(t, e) {
        return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
          var n;
          t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
            var r = e.head,
                n = 1,
                i = r.data;
            t -= i.length;

            for (; r = r.next;) {
              var o = r.data,
                  a = t > o.length ? o.length : t;

              if (a === o.length ? i += o : i += o.slice(0, t), 0 === (t -= a)) {
                a === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a));
                break;
              }

              ++n;
            }

            return e.length -= n, i;
          }(t, e) : function (t, e) {
            var r = c.allocUnsafe(t),
                n = e.head,
                i = 1;
            n.data.copy(r), t -= n.data.length;

            for (; n = n.next;) {
              var o = n.data,
                  a = t > o.length ? o.length : t;

              if (o.copy(r, r.length - t, 0, a), 0 === (t -= a)) {
                a === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a));
                break;
              }

              ++i;
            }

            return e.length -= i, r;
          }(t, e);
          return n;
        }(t, e.buffer, e.decoder), r);
        var r;
      }

      function T(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, i.nextTick(P, e, t));
      }

      function P(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function A(t, e) {
        for (var r = 0, n = t.length; r < n; r++) {
          if (t[r] === e) return r;
        }

        return -1;
      }

      _.prototype.read = function (t) {
        p("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            r = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return p("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? T(this) : k(this), null;
        if (0 === (t = x(t, e)) && e.ended) return 0 === e.length && T(this), null;
        var n,
            i = e.needReadable;
        return p("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && p("length less than watermark", i = !0), e.ended || e.reading ? p("reading or ended", i = !1) : i && (p("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = x(r, e))), null === (n = t > 0 ? O(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && T(this)), null !== n && this.emit("data", n), n;
      }, _.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, _.prototype.pipe = function (t, e) {
        var r = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = t;
            break;

          case 1:
            o.pipes = [o.pipes, t];
            break;

          default:
            o.pipes.push(t);
        }

        o.pipesCount += 1, p("pipe count=%d opts=%j", o.pipesCount, e);
        var u = (!e || !1 !== e.end) && t !== n.stdout && t !== n.stderr ? f : _;

        function c(e, n) {
          p("onunpipe"), e === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, p("cleanup"), t.removeListener("close", y), t.removeListener("finish", b), t.removeListener("drain", l), t.removeListener("error", g), t.removeListener("unpipe", c), r.removeListener("end", f), r.removeListener("end", _), r.removeListener("data", v), h = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || l());
        }

        function f() {
          p("onend"), t.end();
        }

        o.endEmitted ? i.nextTick(u) : r.once("end", u), t.on("unpipe", c);

        var l = function (t) {
          return function () {
            var e = t._readableState;
            p("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && s(t, "data") && (e.flowing = !0, I(t));
          };
        }(r);

        t.on("drain", l);
        var h = !1;
        var d = !1;

        function v(e) {
          p("ondata"), d = !1, !1 !== t.write(e) || d || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== A(o.pipes, t)) && !h && (p("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, d = !0), r.pause());
        }

        function g(e) {
          p("onerror", e), _(), t.removeListener("error", g), 0 === s(t, "error") && t.emit("error", e);
        }

        function y() {
          t.removeListener("finish", b), _();
        }

        function b() {
          p("onfinish"), t.removeListener("close", y), _();
        }

        function _() {
          p("unpipe"), r.unpipe(t);
        }

        return r.on("data", v), function (t, e, r) {
          if ("function" == typeof t.prependListener) return t.prependListener(e, r);
          t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
        }(t, "error", g), t.once("close", y), t.once("finish", b), t.emit("pipe", r), o.flowing || (p("pipe resume"), r.resume()), t;
      }, _.prototype.unpipe = function (t) {
        var e = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes || (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r)), this;

        if (!t) {
          var n = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, r);
          }

          return this;
        }

        var a = A(e.pipes, t);
        return -1 === a || (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r)), this;
      }, _.prototype.on = function (t, e) {
        var r = u.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(R, this));
        }
        return r;
      }, _.prototype.addListener = _.prototype.on, _.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (p("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(C, t, e));
        }(this, t)), this;
      }, _.prototype.pause = function () {
        return p("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, _.prototype.wrap = function (t) {
        var e = this,
            r = this._readableState,
            n = !1;

        for (var i in t.on("end", function () {
          if (p("wrapped end"), r.decoder && !r.ended) {
            var t = r.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          (p("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
        }), t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < y.length; o++) {
          t.on(y[o], this.emit.bind(this, y[o]));
        }

        return this._read = function (e) {
          p("wrapped _read", e), n && (n = !1, t.resume());
        }, this;
      }, Object.defineProperty(_.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), _._fromList = O;
    }).call(this, r(21), r(38));
  }, function (t, e, r) {
    t.exports = r(93).EventEmitter;
  }, function (t, e, r) {
    "use strict";

    var n = r(55);

    function i(t, e) {
      t.emit("error", e);
    }

    t.exports = {
      destroy: function destroy(t, e) {
        var r = this,
            o = this._readableState && this._readableState.destroyed,
            a = this._writableState && this._writableState.destroyed;
        return o || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
          !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(56).Buffer,
        i = n.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(t) {
      var e;

      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";

          for (var e;;) {
            switch (t) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return t;

              default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
            }
          }
        }(t);

        if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
      }(t), this.encoding) {
        case "utf16le":
          this.text = u, this.end = c, e = 4;
          break;

        case "utf8":
          this.fillLast = s, e = 4;
          break;

        case "base64":
          this.text = f, this.end = l, e = 3;
          break;

        default:
          return this.write = h, void (this.end = p);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
    }

    function a(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
    }

    function s(t) {
      var e = this.lastTotal - this.lastNeed,
          r = function (t, e, r) {
        if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

        if (t.lastNeed > 1 && e.length > 1) {
          if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
          if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
        }
      }(this, t);

      return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function u(t, e) {
      if ((t.length - e) % 2 == 0) {
        var r = t.toString("utf16le", e);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function c(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, r);
      }

      return e;
    }

    function f(t, e) {
      var r = (t.length - e) % 3;
      return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }

    function l(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function h(t) {
      return t.toString(this.encoding);
    }

    function p(t) {
      return t && t.length ? this.write(t) : "";
    }

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, r;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    }, o.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e;
    }, o.prototype.text = function (t, e) {
      var r = function (t, e, r) {
        var n = e.length - 1;
        if (n < r) return 0;
        var i = a(e[n]);
        if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
        return 0;
      }(this, t, e);

      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = r;
      var n = t.length - (r - this.lastNeed);
      return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
    }, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = a;
    var n = r(23),
        i = r(39);

    function o(t, e) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function a(t) {
      if (!(this instanceof a)) return new a(t);
      n.call(this, t), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", s);
    }

    function s() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, r) {
        u(t, e, r);
      }) : u(this, null, null);
    }

    function u(t, e, r) {
      if (e) return t.emit("error", e);
      if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    i.inherits = r(29), i.inherits(a, n), a.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
    }, a.prototype._transform = function (t, e, r) {
      throw new Error("_transform() is not implemented");
    }, a.prototype._write = function (t, e, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, a.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, a.prototype._destroy = function (t, e) {
      var r = this;

      n.prototype._destroy.call(this, t, function (t) {
        e(t), r.emit("close");
      });
    };
  }, function (t, e) {
    t.exports = function (t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    };
  }, function (t, e) {
    var r = {
      acl: "http://www.w3.org/ns/auth/acl#",
      arg: "http://www.w3.org/ns/pim/arg#",
      cal: "http://www.w3.org/2002/12/cal/ical#",
      contact: "http://www.w3.org/2000/10/swap/pim/contact#",
      dc: "http://purl.org/dc/elements/1.1/",
      dct: "http://purl.org/dc/terms/",
      doap: "http://usefulinc.com/ns/doap#",
      foaf: "http://xmlns.com/foaf/0.1/",
      http: "http://www.w3.org/2007/ont/http#",
      httph: "http://www.w3.org/2007/ont/httph#",
      icalTZ: "http://www.w3.org/2002/12/cal/icaltzd#",
      ldp: "http://www.w3.org/ns/ldp#",
      link: "http://www.w3.org/2007/ont/link#",
      log: "http://www.w3.org/2000/10/swap/log#",
      meeting: "http://www.w3.org/ns/pim/meeting#",
      mo: "http://purl.org/ontology/mo/",
      owl: "http://www.w3.org/2002/07/owl#",
      pad: "http://www.w3.org/ns/pim/pad#",
      patch: "http://www.w3.org/ns/pim/patch#",
      qu: "http://www.w3.org/2000/10/swap/pim/qif#",
      trip: "http://www.w3.org/ns/pim/trip#",
      rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      rdfs: "http://www.w3.org/2000/01/rdf-schema#",
      rss: "http://purl.org/rss/1.0/",
      sched: "http://www.w3.org/ns/pim/schedule#",
      schema: "http:/schema.org/",
      sioc: "http://rdfs.org/sioc/ns#",
      solid: "http://www.w3.org/ns/solid/terms#",
      space: "http://www.w3.org/ns/pim/space#",
      stat: "http://www.w3.org/ns/posix/stat#",
      tab: "http://www.w3.org/2007/ont/link#",
      tabont: "http://www.w3.org/2007/ont/link#",
      ui: "http://www.w3.org/ns/ui#",
      vcard: "http://www.w3.org/2006/vcard/ns#",
      wf: "http://www.w3.org/2005/01/wf/flow#",
      xsd: "http://www.w3.org/2001/XMLSchema#"
    };

    t.exports = function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        namedNode: function namedNode(t) {
          return t;
        }
      };
      var e = {};

      var _loop = function _loop(n) {
        var i = r[n];

        e[n] = function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          return t.namedNode(i + e);
        };
      };

      for (var n in r) {
        _loop(n);
      }

      return e;
    };
  }, function (t, e, r) {
    "use strict";

    (function (t, n) {
      r.d(e, "a", function () {
        return h;
      });
      var i = r(6);
      var o = i.a.xsd,
          a = String.fromCharCode;
      var s = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\[uU]|\\(.)/g,
          u = {
        "\\": "\\",
        "'": "'",
        '"': '"',
        n: "\n",
        r: "\r",
        t: "\t",
        f: "\f",
        b: "\b",
        _: "_",
        "~": "~",
        ".": ".",
        "-": "-",
        "!": "!",
        $: "$",
        "&": "&",
        "(": "(",
        ")": ")",
        "*": "*",
        "+": "+",
        ",": ",",
        ";": ";",
        "=": "=",
        "/": "/",
        "?": "?",
        "#": "#",
        "@": "@",
        "%": "%"
      },
          c = /[\x00-\x20<>\\"\{\}\|\^\`]/,
          f = {
        _iri: !0,
        _unescapedIri: !0,
        _simpleQuotedString: !0,
        _langcode: !0,
        _blank: !0,
        _newline: !0,
        _comment: !0,
        _whitespace: !0,
        _endOfFile: !0
      },
          l = /$0^/;

      var h =
      /*#__PURE__*/
      function () {
        function h(t) {
          _classCallCheck(this, h);

          if (this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/, this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/, this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/, this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/, this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i, this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/, this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<]))/, this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<])/, this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<]))/, this._number = /^[\-+]?(?:\d+\.?\d*([eE](?:[\-\+])?\d+)|\d*\.?\d+)(?=\.?[,;:\s#()\[\]\{\}"'<])/, this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<])/, this._keyword = /^@[a-z]+(?=[\s#<:])/i, this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i, this._shortPredicates = /^a(?=[\s()\[\]\{\}"'<])/, this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/, this._comment = /#([^\n\r]*)/, this._whitespace = /^[ \t]+/, this._endOfFile = /^(?:#[^\n\r]*)?$/, t = t || {}, this._lineMode = !!t.lineMode) for (var e in this._n3Mode = !1, this) {
            !(e in f) && this[e] instanceof RegExp && (this[e] = l);
          } else this._n3Mode = !1 !== t.n3;
          this._comments = !!t.comments, this._literalClosingPos = 0;
        }

        _createClass(h, [{
          key: "_tokenizeToEnd",
          value: function _tokenizeToEnd(t, e) {
            var _this$_parseLiteral;

            for (var r = this._input, n = this._comments;;) {
              for (var i, a; i = this._newline.exec(r);) {
                n && (a = this._comment.exec(i[0])) && t(null, {
                  line: this._line,
                  type: "comment",
                  value: a[1],
                  prefix: ""
                }), r = r.substr(i[0].length, r.length), this._line++;
              }

              if (!i && (i = this._whitespace.exec(r)) && (r = r.substr(i[0].length, r.length)), this._endOfFile.test(r)) return e && (n && (a = this._comment.exec(r)) && t(null, {
                line: this._line,
                type: "comment",
                value: a[1],
                prefix: ""
              }), t(r = null, {
                line: this._line,
                type: "eof",
                value: "",
                prefix: ""
              })), this._input = r;
              var s = this._line,
                  u = "",
                  f = "",
                  l = "",
                  h = r[0],
                  p = null,
                  d = 0,
                  v = !1;

              switch (h) {
                case "^":
                  if (r.length < 3) break;

                  if ("^" !== r[1]) {
                    this._n3Mode && (d = 1, u = "^");
                    break;
                  }

                  if (this._previousMarker = "^^", "<" !== (r = r.substr(2))[0]) {
                    v = !0;
                    break;
                  }

                case "<":
                  if (p = this._unescapedIri.exec(r)) u = "IRI", f = p[1];else if (p = this._iri.exec(r)) {
                    if (null === (f = this._unescape(p[1])) || c.test(f)) return y(this);
                    u = "IRI";
                  } else this._n3Mode && r.length > 1 && "=" === r[1] && (u = "inverse", d = 2, f = ">");
                  break;

                case "_":
                  ((p = this._blank.exec(r)) || e && (p = this._blank.exec(r + " "))) && (u = "blank", l = "_", f = p[1]);
                  break;

                case '"':
                  if (p = this._simpleQuotedString.exec(r)) f = p[1];else if ((_this$_parseLiteral = this._parseLiteral(r), f = _this$_parseLiteral.value, d = _this$_parseLiteral.matchLength, _this$_parseLiteral), null === f) return y(this);
                  null === p && 0 === d || (u = "literal", this._literalClosingPos = 0);
                  break;

                case "'":
                  if (!this._lineMode) {
                    var _this$_parseLiteral2;

                    if (p = this._simpleApostropheString.exec(r)) f = p[1];else if ((_this$_parseLiteral2 = this._parseLiteral(r), f = _this$_parseLiteral2.value, d = _this$_parseLiteral2.matchLength, _this$_parseLiteral2), null === f) return y(this);
                    null === p && 0 === d || (u = "literal", this._literalClosingPos = 0);
                  }

                  break;

                case "?":
                  this._n3Mode && (p = this._variable.exec(r)) && (u = "var", f = p[0]);
                  break;

                case "@":
                  "literal" === this._previousMarker && (p = this._langcode.exec(r)) ? (u = "langcode", f = p[1]) : (p = this._keyword.exec(r)) && (u = p[0]);
                  break;

                case ".":
                  if (1 === r.length ? e : r[1] < "0" || r[1] > "9") {
                    u = ".", d = 1;
                    break;
                  }

                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                case "+":
                case "-":
                  (p = this._number.exec(r) || e && (p = this._number.exec(r + " "))) && (u = "literal", f = p[0], l = p[1] ? o.double : /^[+\-]?\d+$/.test(p[0]) ? o.integer : o.decimal);
                  break;

                case "B":
                case "b":
                case "p":
                case "P":
                case "G":
                case "g":
                  (p = this._sparqlKeyword.exec(r)) ? u = p[0].toUpperCase() : v = !0;
                  break;

                case "f":
                case "t":
                  (p = this._boolean.exec(r)) ? (u = "literal", f = p[0], l = o.boolean) : v = !0;
                  break;

                case "a":
                  (p = this._shortPredicates.exec(r)) ? (u = "abbreviation", f = "a") : v = !0;
                  break;

                case "=":
                  this._n3Mode && r.length > 1 && (u = "abbreviation", ">" !== r[1] ? (d = 1, f = "=") : (d = 2, f = ">"));
                  break;

                case "!":
                  if (!this._n3Mode) break;

                case ",":
                case ";":
                case "[":
                case "]":
                case "(":
                case ")":
                case "{":
                case "}":
                  this._lineMode || (d = 1, u = h);
                  break;

                default:
                  v = !0;
              }

              if (v && ("@prefix" !== this._previousMarker && "PREFIX" !== this._previousMarker || !(p = this._prefix.exec(r)) ? ((p = this._prefixed.exec(r)) || e && (p = this._prefixed.exec(r + " "))) && (u = "prefixed", l = p[1] || "", f = this._unescape(p[2])) : (u = "prefix", f = p[1] || "")), "^^" === this._previousMarker) switch (u) {
                case "prefixed":
                  u = "type";
                  break;

                case "IRI":
                  u = "typeIRI";
                  break;

                default:
                  u = "";
              }
              if (!u) return e || !/^'''|^"""/.test(r) && /\n|\r/.test(r) ? y(this) : this._input = r;
              var g = {
                line: s,
                type: u,
                value: f,
                prefix: l
              };
              t(null, g), this.previousToken = g, this._previousMarker = u, r = r.substr(d || p[0].length, r.length);
            }

            function y(e) {
              t(e._syntaxError(/^\S*/.exec(r)[0]));
            }
          }
        }, {
          key: "_unescape",
          value: function _unescape(t) {
            try {
              return t.replace(s, function (t, e, r, n) {
                var i;

                if (e) {
                  if (i = parseInt(e, 16), isNaN(i)) throw new Error();
                  return a(i);
                }

                if (r) {
                  if (i = parseInt(r, 16), isNaN(i)) throw new Error();
                  return i <= 65535 ? a(i) : a(55296 + (i -= 65536) / 1024, 56320 + (1023 & i));
                }

                var o = u[n];
                if (!o) throw new Error();
                return o;
              });
            } catch (t) {
              return null;
            }
          }
        }, {
          key: "_parseLiteral",
          value: function _parseLiteral(t) {
            if (t.length >= 3) {
              var _e2 = t.match(/^(?:"""|"|'''|'|)/)[0],
                  _r = _e2.length;

              var _n = Math.max(this._literalClosingPos, _r);

              for (; (_n = t.indexOf(_e2, _n)) > 0;) {
                var _e3 = 0;

                for (; "\\" === t[_n - _e3 - 1];) {
                  _e3++;
                }

                if (_e3 % 2 == 0) {
                  var _e4 = t.substring(_r, _n),
                      _i = _e4.split(/\r\n|\r|\n/).length - 1,
                      _o = _n + _r;

                  if (1 === _r && 0 !== _i || 3 === _r && this._lineMode) break;
                  return this._line += _i, {
                    value: this._unescape(_e4),
                    matchLength: _o
                  };
                }

                _n++;
              }

              this._literalClosingPos = t.length - _r + 1;
            }

            return {
              value: "",
              matchLength: 0
            };
          }
        }, {
          key: "_syntaxError",
          value: function _syntaxError(t) {
            this._input = null;
            var e = new Error('Unexpected "' + t + '" on line ' + this._line + ".");
            return e.context = {
              token: void 0,
              line: this._line,
              previousToken: this.previousToken
            }, e;
          }
        }, {
          key: "tokenize",
          value: function tokenize(e, r) {
            var i = this;

            if (this._line = 1, "string" == typeof e) {
              if (this._input = e, "function" != typeof r) {
                var o,
                    a = [];
                if (this._tokenizeToEnd(function (t, e) {
                  t ? o = t : a.push(e);
                }, !0), o) throw o;
                return a;
              }

              t(function () {
                i._tokenizeToEnd(r, !0);
              });
            } else this._input = "", this._pendingBuffer = null, "function" == typeof e.setEncoding && e.setEncoding("utf8"), e.on("data", function (t) {
              null !== i._input && 0 !== t.length && (i._pendingBuffer && (t = n.concat([i._pendingBuffer, t]), i._pendingBuffer = null), 128 & t[t.length - 1] ? i._pendingBuffer = t : (i._input += t, i._tokenizeToEnd(r, !1)));
            }), e.on("end", function () {
              null !== i._input && i._tokenizeToEnd(r, !0);
            }), e.on("error", r);
          }
        }]);

        return h;
      }();
    }).call(this, r(136).setImmediate, r(92).Buffer);
  }, function (t, e, r) {
    t.exports = i;
    var n = r(93).EventEmitter;

    function i() {
      n.call(this);
    }

    r(29)(i, n), i.Readable = r(94), i.Writable = r(197), i.Duplex = r(198), i.Transform = r(199), i.PassThrough = r(200), i.Stream = i, i.prototype.pipe = function (t, e) {
      var r = this;

      function i(e) {
        t.writable && !1 === t.write(e) && r.pause && r.pause();
      }

      function o() {
        r.readable && r.resume && r.resume();
      }

      r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", s), r.on("close", u));
      var a = !1;

      function s() {
        a || (a = !0, t.end());
      }

      function u() {
        a || (a = !0, "function" == typeof t.destroy && t.destroy());
      }

      function c(t) {
        if (f(), 0 === n.listenerCount(this, "error")) throw t;
      }

      function f() {
        r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", u), r.removeListener("error", c), t.removeListener("error", c), r.removeListener("end", f), r.removeListener("close", f), t.removeListener("close", f);
      }

      return r.on("error", c), t.on("error", c), r.on("end", f), r.on("close", f), t.on("close", f), t.emit("pipe", r), t;
    };
  }, function (t, e, r) {
    var n = r(4),
        i = r(63),
        o = n.WeakMap;
    t.exports = "function" == typeof o && /native code/.test(i(o));
  }, function (t, e, r) {
    var n = r(12),
        i = r(46).f,
        o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    t.exports.f = function (t) {
      return a && "[object Window]" == o.call(t) ? function (t) {
        try {
          return i(t);
        } catch (t) {
          return a.slice();
        }
      }(t) : i(n(t));
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(7),
        o = r(4),
        a = r(13),
        s = r(10),
        u = r(11).f,
        c = r(101),
        f = o.Symbol;

    if (i && "function" == typeof f && (!("description" in f.prototype) || void 0 !== f().description)) {
      var l = {},
          h = function h() {
        var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
            e = this instanceof h ? new f(t) : void 0 === t ? f() : f(t);
        return "" === t && (l[e] = !0), e;
      };

      c(h, f);
      var p = h.prototype = f.prototype;
      p.constructor = h;
      var d = p.toString,
          v = "Symbol(test)" == String(f("test")),
          g = /^Symbol\((.*)\)[^)]+$/;
      u(p, "description", {
        configurable: !0,
        get: function get() {
          var t = s(this) ? this.valueOf() : this,
              e = d.call(t);
          if (a(l, t)) return "";
          var r = v ? e.slice(7, -1) : e.replace(g, "$1");
          return "" === r ? void 0 : r;
        }
      }), n({
        global: !0,
        forced: !0
      }, {
        Symbol: h
      });
    }
  }, function (t, e, r) {
    r(111)("iterator");
  }, function (t, e, r) {
    "use strict";

    var n = r(115).IteratorPrototype,
        i = r(70),
        o = r(31),
        a = r(49),
        s = r(34),
        u = function u() {
      return this;
    };

    t.exports = function (t, e, r) {
      var c = e + " Iterator";
      return t.prototype = i(n, {
        next: o(1, r)
      }), a(t, c, !1, !0), s[c] = u, t;
    };
  }, function (t, e, r) {
    var n = r(5);
    t.exports = !n(function () {
      function t() {}

      return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    });
  }, function (t, e, r) {
    var n = r(10);

    t.exports = function (t) {
      if (!n(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
      return t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(72),
        i = r(118);
    t.exports = n ? {}.toString : function () {
      return "[object " + i(this) + "]";
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e, r) {
    var n = r(16);

    t.exports = function (t, e) {
      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = n(t));) {
        ;
      }

      return t;
    };
  }, function (t, e, r) {
    var n = r(2),
        i = r(7);
    n({
      target: "Object",
      stat: !0,
      forced: !i,
      sham: !i
    }, {
      defineProperties: r(108)
    });
  }, function (t, e, r) {
    var n = r(2),
        i = r(7);
    n({
      target: "Object",
      stat: !0,
      forced: !i,
      sham: !i
    }, {
      defineProperty: r(11).f
    });
  }, function (t, e, r) {
    var n = r(2),
        i = r(160).entries;
    n({
      target: "Object",
      stat: !0
    }, {
      entries: function entries(t) {
        return i(t);
      }
    });
  }, function (t, e, r) {
    var n = r(7),
        i = r(48),
        o = r(12),
        a = r(59).f,
        s = function s(t) {
      return function (e) {
        for (var r, s = o(e), u = i(s), c = u.length, f = 0, l = []; c > f;) {
          r = u[f++], n && !a.call(s, r) || l.push(t ? [r, s[r]] : s[r]);
        }

        return l;
      };
    };

    t.exports = {
      entries: s(!0),
      values: s(!1)
    };
  }, function (t, e, r) {
    var n = r(2),
        i = r(5),
        o = r(12),
        a = r(22).f,
        s = r(7),
        u = i(function () {
      a(1);
    });
    n({
      target: "Object",
      stat: !0,
      forced: !s || u,
      sham: !s
    }, {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
        return a(o(t), e);
      }
    });
  }, function (t, e, r) {
    var n = r(2),
        i = r(7),
        o = r(102),
        a = r(12),
        s = r(22),
        u = r(82);
    n({
      target: "Object",
      stat: !0,
      sham: !i
    }, {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var e, r, n = a(t), i = s.f, c = o(n), f = {}, l = 0; c.length > l;) {
          void 0 !== (r = i(n, e = c[l++])) && u(f, e, r);
        }

        return f;
      }
    });
  }, function (t, e, r) {
    var n = r(7),
        i = r(4),
        o = r(68),
        a = r(164),
        s = r(11).f,
        u = r(46).f,
        c = r(88),
        f = r(73),
        l = r(119),
        h = r(17),
        p = r(5),
        d = r(24).set,
        v = r(125),
        g = r(3)("match"),
        y = i.RegExp,
        b = y.prototype,
        _ = /a/g,
        m = /a/g,
        w = new y(_) !== _,
        x = l.UNSUPPORTED_Y;

    if (n && o("RegExp", !w || x || p(function () {
      return m[g] = !1, y(_) != _ || y(m) == m || "/a/i" != y(_, "i");
    }))) {
      for (var k = function k(t, e) {
        var r,
            n = this instanceof k,
            i = c(t),
            o = void 0 === e;
        if (!n && i && t.constructor === k && o) return t;
        w ? i && !o && (t = t.source) : t instanceof k && (o && (e = f.call(t)), t = t.source), x && (r = !!e && e.indexOf("y") > -1) && (e = e.replace(/y/g, ""));
        var s = a(w ? new y(t, e) : y(t, e), n ? this : b, k);
        return x && r && d(s, {
          sticky: r
        }), s;
      }, E = function E(t) {
        (t in k) || s(k, t, {
          configurable: !0,
          get: function get() {
            return y[t];
          },
          set: function set(e) {
            y[t] = e;
          }
        });
      }, S = u(y), j = 0; S.length > j;) {
        E(S[j++]);
      }

      b.constructor = k, k.prototype = b, h(i, "RegExp", k);
    }

    v("RegExp");
  }, function (t, e, r) {
    var n = r(10),
        i = r(117);

    t.exports = function (t, e, r) {
      var o, a;
      return i && "function" == typeof (o = e.constructor) && o !== r && n(a = o.prototype) && a !== r.prototype && i(t, a), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(17),
        i = r(8),
        o = r(5),
        a = r(73),
        s = RegExp.prototype,
        u = s.toString,
        c = o(function () {
      return "/a/b" != u.call({
        source: "a",
        flags: "b"
      });
    }),
        f = "toString" != u.name;
    (c || f) && n(RegExp.prototype, "toString", function () {
      var t = i(this),
          e = String(t.source),
          r = t.flags;
      return "/" + e + "/" + String(void 0 === r && t instanceof RegExp && !("flags" in s) ? a.call(t) : r);
    }, {
      unsafe: !0
    });
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) return t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) {
        var r = [],
            n = !0,
            i = !1,
            o = void 0;

        try {
          for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
            ;
          }
        } catch (t) {
          i = !0, o = t;
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }

        return r;
      }
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (t, e, r) {
    t.exports = function (t) {
      function e(t) {
        var e = 0;

        for (var _r2 = 0; _r2 < t.length; _r2++) {
          e = (e << 5) - e + t.charCodeAt(_r2), e |= 0;
        }

        return n.colors[Math.abs(e) % n.colors.length];
      }

      function n(t) {
        var r;

        function a() {
          for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
            t[_key] = arguments[_key];
          }

          if (!a.enabled) return;
          var e = a,
              i = Number(new Date()),
              o = i - (r || i);
          e.diff = o, e.prev = r, e.curr = i, r = i, t[0] = n.coerce(t[0]), "string" != typeof t[0] && t.unshift("%O");
          var s = 0;
          t[0] = t[0].replace(/%([a-zA-Z%])/g, function (r, i) {
            if ("%%" === r) return r;
            s++;
            var o = n.formatters[i];

            if ("function" == typeof o) {
              var _n2 = t[s];
              r = o.call(e, _n2), t.splice(s, 1), s--;
            }

            return r;
          }), n.formatArgs.call(e, t), (e.log || n.log).apply(e, t);
        }

        return a.namespace = t, a.enabled = n.enabled(t), a.useColors = n.useColors(), a.color = e(t), a.destroy = i, a.extend = o, "function" == typeof n.init && n.init(a), n.instances.push(a), a;
      }

      function i() {
        var t = n.instances.indexOf(this);
        return -1 !== t && (n.instances.splice(t, 1), !0);
      }

      function o(t, e) {
        var r = n(this.namespace + (void 0 === e ? ":" : e) + t);
        return r.log = this.log, r;
      }

      function a(t) {
        return t.toString().substring(2, t.toString().length - 2).replace(/\.\*\?$/, "*");
      }

      return n.debug = n, n.default = n, n.coerce = function (t) {
        if (t instanceof Error) return t.stack || t.message;
        return t;
      }, n.disable = function () {
        var t = [].concat(_toConsumableArray(n.names.map(a)), _toConsumableArray(n.skips.map(a).map(function (t) {
          return "-" + t;
        }))).join(",");
        return n.enable(""), t;
      }, n.enable = function (t) {
        var e;
        n.save(t), n.names = [], n.skips = [];
        var r = ("string" == typeof t ? t : "").split(/[\s,]+/),
            i = r.length;

        for (e = 0; e < i; e++) {
          r[e] && ("-" === (t = r[e].replace(/\*/g, ".*?"))[0] ? n.skips.push(new RegExp("^" + t.substr(1) + "$")) : n.names.push(new RegExp("^" + t + "$")));
        }

        for (e = 0; e < n.instances.length; e++) {
          var _t2 = n.instances[e];
          _t2.enabled = n.enabled(_t2.namespace);
        }
      }, n.enabled = function (t) {
        if ("*" === t[t.length - 1]) return !0;
        var e, r;

        for (e = 0, r = n.skips.length; e < r; e++) {
          if (n.skips[e].test(t)) return !1;
        }

        for (e = 0, r = n.names.length; e < r; e++) {
          if (n.names[e].test(t)) return !0;
        }

        return !1;
      }, n.humanize = r(173), Object.keys(t).forEach(function (e) {
        n[e] = t[e];
      }), n.instances = [], n.names = [], n.skips = [], n.formatters = {}, n.selectColor = e, n.enable(n.load()), n;
    };
  }, function (t, e) {
    var r = 1e3,
        n = 6e4,
        i = 60 * n,
        o = 24 * i;

    function a(t, e, r, n) {
      var i = e >= 1.5 * r;
      return Math.round(t / r) + " " + n + (i ? "s" : "");
    }

    t.exports = function (t, e) {
      e = e || {};
      var s = typeof t;
      if ("string" === s && t.length > 0) return function (t) {
        if ((t = String(t)).length > 100) return;
        var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
        if (!e) return;
        var a = parseFloat(e[1]);

        switch ((e[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return 315576e5 * a;

          case "weeks":
          case "week":
          case "w":
            return 6048e5 * a;

          case "days":
          case "day":
          case "d":
            return a * o;

          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return a * i;

          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return a * n;

          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return a * r;

          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return a;

          default:
            return;
        }
      }(t);
      if ("number" === s && isFinite(t)) return e.long ? function (t) {
        var e = Math.abs(t);
        if (e >= o) return a(t, e, o, "day");
        if (e >= i) return a(t, e, i, "hour");
        if (e >= n) return a(t, e, n, "minute");
        if (e >= r) return a(t, e, r, "second");
        return t + " ms";
      }(t) : function (t) {
        var e = Math.abs(t);
        if (e >= o) return Math.round(t / o) + "d";
        if (e >= i) return Math.round(t / i) + "h";
        if (e >= n) return Math.round(t / n) + "m";
        if (e >= r) return Math.round(t / r) + "s";
        return t + "ms";
      }(t);
      throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(33).every;
    n({
      target: "Array",
      proto: !0,
      forced: r(36)("every")
    }, {
      every: function every(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(12),
        i = r(32),
        o = r(15),
        a = r(36),
        s = Math.min,
        u = [].lastIndexOf,
        c = !!u && 1 / [1].lastIndexOf(1, -0) < 0,
        f = a("lastIndexOf");
    t.exports = c || f ? function (t) {
      if (c) return u.apply(this, arguments) || 0;
      var e = n(this),
          r = o(e.length),
          a = r - 1;

      for (arguments.length > 1 && (a = s(a, i(arguments[1]))), a < 0 && (a = r + a); a >= 0; a--) {
        if (a in e && e[a] === t) return a || 0;
      }

      return -1;
    } : u;
  }, function (t, e, r) {
    "use strict";

    var n = r(76),
        i = r(88),
        o = r(8),
        a = r(20),
        s = r(132),
        u = r(77),
        c = r(15),
        f = r(78),
        l = r(53),
        h = r(5),
        p = [].push,
        d = Math.min,
        v = !h(function () {
      return !RegExp(4294967295, "y");
    });
    n("split", 2, function (t, e, r) {
      var n;
      return n = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, r) {
        var n = String(a(this)),
            o = void 0 === r ? 4294967295 : r >>> 0;
        if (0 === o) return [];
        if (void 0 === t) return [n];
        if (!i(t)) return e.call(n, t, o);

        for (var s, u, c, f = [], h = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), d = 0, v = new RegExp(t.source, h + "g"); (s = l.call(v, n)) && !((u = v.lastIndex) > d && (f.push(n.slice(d, s.index)), s.length > 1 && s.index < n.length && p.apply(f, s.slice(1)), c = s[0].length, d = u, f.length >= o));) {
          v.lastIndex === s.index && v.lastIndex++;
        }

        return d === n.length ? !c && v.test("") || f.push("") : f.push(n.slice(d)), f.length > o ? f.slice(0, o) : f;
      } : "0".split(void 0, 0).length ? function (t, r) {
        return void 0 === t && 0 === r ? [] : e.call(this, t, r);
      } : e, [function (e, r) {
        var i = a(this),
            o = null == e ? void 0 : e[t];
        return void 0 !== o ? o.call(e, i, r) : n.call(String(i), e, r);
      }, function (t, i) {
        var a = r(n, t, this, i, n !== e);
        if (a.done) return a.value;

        var l = o(t),
            h = String(this),
            p = s(l, RegExp),
            g = l.unicode,
            y = (l.ignoreCase ? "i" : "") + (l.multiline ? "m" : "") + (l.unicode ? "u" : "") + (v ? "y" : "g"),
            b = new p(v ? l : "^(?:" + l.source + ")", y),
            _ = void 0 === i ? 4294967295 : i >>> 0;

        if (0 === _) return [];
        if (0 === h.length) return null === f(b, h) ? [h] : [];

        for (var m = 0, w = 0, x = []; w < h.length;) {
          b.lastIndex = v ? w : 0;
          var k,
              E = f(b, v ? h : h.slice(w));
          if (null === E || (k = d(c(b.lastIndex + (v ? 0 : w)), h.length)) === m) w = u(h, w, g);else {
            if (x.push(h.slice(m, w)), x.length === _) return x;

            for (var S = 1; S <= E.length - 1; S++) {
              if (x.push(E[S]), x.length === _) return x;
            }

            w = m = k;
          }
        }

        return x.push(h.slice(m)), x;
      }];
    }, !v);
  }, function (t, e, r) {
    var n = r(4);
    t.exports = n.Promise;
  }, function (t, e, r) {
    var n = r(17);

    t.exports = function (t, e, r) {
      for (var i in e) {
        n(t, i, e[i], r);
      }

      return t;
    };
  }, function (t, e) {
    t.exports = function (t, e, r) {
      if (!(t instanceof e)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
      return t;
    };
  }, function (t, e, r) {
    var n = r(8),
        i = r(181),
        o = r(15),
        a = r(71),
        s = r(182),
        u = r(183),
        c = function c(t, e) {
      this.stopped = t, this.result = e;
    };

    (t.exports = function (t, e, r, f, l) {
      var h,
          p,
          d,
          v,
          g,
          y,
          b,
          _ = a(e, r, f ? 2 : 1);

      if (l) h = t;else {
        if ("function" != typeof (p = s(t))) throw TypeError("Target is not iterable");

        if (i(p)) {
          for (d = 0, v = o(t.length); v > d; d++) {
            if ((g = f ? _(n(b = t[d])[0], b[1]) : _(t[d])) && g instanceof c) return g;
          }

          return new c(!1);
        }

        h = p.call(t);
      }

      for (y = h.next; !(b = y.call(h)).done;) {
        if ("object" == typeof (g = u(h, _, b.value, f)) && g && g instanceof c) return g;
      }

      return new c(!1);
    }).stop = function (t) {
      return new c(!0, t);
    };
  }, function (t, e, r) {
    var n = r(3),
        i = r(34),
        o = n("iterator"),
        a = Array.prototype;

    t.exports = function (t) {
      return void 0 !== t && (i.Array === t || a[o] === t);
    };
  }, function (t, e, r) {
    var n = r(118),
        i = r(34),
        o = r(3)("iterator");

    t.exports = function (t) {
      if (null != t) return t[o] || t["@@iterator"] || i[n(t)];
    };
  }, function (t, e, r) {
    var n = r(8);

    t.exports = function (t, e, r, i) {
      try {
        return i ? e(n(r)[0], r[1]) : e(r);
      } catch (e) {
        var o = t.return;
        throw void 0 !== o && n(o.call(t)), e;
      }
    };
  }, function (t, e, r) {
    var n = r(3)("iterator"),
        i = !1;

    try {
      var o = 0,
          a = {
        next: function next() {
          return {
            done: !!o++
          };
        },
        return: function _return() {
          i = !0;
        }
      };
      a[n] = function () {
        return this;
      }, Array.from(a, function () {
        throw 2;
      });
    } catch (t) {}

    t.exports = function (t, e) {
      if (!e && !i) return !1;
      var r = !1;

      try {
        var o = {};
        o[n] = function () {
          return {
            next: function next() {
              return {
                done: r = !0
              };
            }
          };
        }, t(o);
      } catch (t) {}

      return r;
    };
  }, function (t, e, r) {
    var n,
        i,
        o,
        a,
        s,
        u,
        c,
        f,
        l = r(4),
        h = r(22).f,
        p = r(19),
        d = r(133).set,
        v = r(134),
        g = l.MutationObserver || l.WebKitMutationObserver,
        y = l.process,
        b = l.Promise,
        _ = "process" == p(y),
        m = h(l, "queueMicrotask"),
        w = m && m.value;

    w || (n = function n() {
      var t, e;

      for (_ && (t = y.domain) && t.exit(); i;) {
        e = i.fn, i = i.next;

        try {
          e();
        } catch (t) {
          throw i ? a() : o = void 0, t;
        }
      }

      o = void 0, t && t.enter();
    }, _ ? a = function a() {
      y.nextTick(n);
    } : g && !v ? (s = !0, u = document.createTextNode(""), new g(n).observe(u, {
      characterData: !0
    }), a = function a() {
      u.data = s = !s;
    }) : b && b.resolve ? (c = b.resolve(void 0), f = c.then, a = function a() {
      f.call(c, n);
    }) : a = function a() {
      d.call(l, n);
    }), t.exports = w || function (t) {
      var e = {
        fn: t,
        next: void 0
      };
      o && (o.next = e), i || (i = e, a()), o = e;
    };
  }, function (t, e, r) {
    var n = r(8),
        i = r(10),
        o = r(135);

    t.exports = function (t, e) {
      if (n(t), i(e) && e.constructor === t) return e;
      var r = o.f(t);
      return (0, r.resolve)(e), r.promise;
    };
  }, function (t, e, r) {
    var n = r(4);

    t.exports = function (t, e) {
      var r = n.console;
      r && r.error && (1 === arguments.length ? r.error(t) : r.error(t, e));
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          error: !1,
          value: t()
        };
      } catch (t) {
        return {
          error: !0,
          value: t
        };
      }
    };
  }, function (t, e, r) {
    (function (t, e) {
      !function (t, r) {
        "use strict";

        if (!t.setImmediate) {
          var n,
              i,
              o,
              a,
              s,
              u = 1,
              c = {},
              f = !1,
              l = t.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(t);
          h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? n = function n(t) {
            e.nextTick(function () {
              d(t);
            });
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  r = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = r, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            d(t.data);
          }, n = function n(t) {
            o.port2.postMessage(t);
          }) : l && "onreadystatechange" in l.createElement("script") ? (i = l.documentElement, n = function n(t) {
            var e = l.createElement("script");
            e.onreadystatechange = function () {
              d(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e);
          }) : n = function n(t) {
            setTimeout(d, 0, t);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && d(+e.data.slice(a.length));
          }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), n = function n(e) {
            t.postMessage(a + e, "*");
          }), h.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), r = 0; r < e.length; r++) {
              e[r] = arguments[r + 1];
            }

            var i = {
              callback: t,
              args: e
            };
            return c[u] = i, n(u), u++;
          }, h.clearImmediate = p;
        }

        function p(t) {
          delete c[t];
        }

        function d(t) {
          if (f) setTimeout(d, 0, t);else {
            var e = c[t];

            if (e) {
              f = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      r = t.args;

                  switch (r.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(r[0]);
                      break;

                    case 2:
                      e(r[0], r[1]);
                      break;

                    case 3:
                      e(r[0], r[1], r[2]);
                      break;

                    default:
                      e.apply(void 0, r);
                  }
                }(e);
              } finally {
                p(t), f = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, r(21), r(38));
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = c(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      var e,
          r,
          n = c(t),
          a = n[0],
          s = n[1],
          u = new o(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, a, s)),
          f = 0,
          l = s > 0 ? a - 4 : a;

      for (r = 0; r < l; r += 4) {
        e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[f++] = e >> 16 & 255, u[f++] = e >> 8 & 255, u[f++] = 255 & e;
      }

      2 === s && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[f++] = 255 & e);
      1 === s && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[f++] = e >> 8 & 255, u[f++] = 255 & e);
      return u;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
        o.push(f(t, a, a + 16383 > s ? s : a + 16383));
      }

      1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return o.join("");
    };

    for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, u = a.length; s < u; ++s) {
      n[s] = a[s], i[a.charCodeAt(s)] = s;
    }

    function c(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function f(t, e, r) {
      for (var i, o, a = [], s = e; s < r; s += 3) {
        i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
      }

      return a.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, r, n, i) {
      var o,
          a,
          s = 8 * i - n - 1,
          u = (1 << s) - 1,
          c = u >> 1,
          f = -7,
          l = r ? i - 1 : 0,
          h = r ? -1 : 1,
          p = t[e + l];

      for (l += h, o = p & (1 << -f) - 1, p >>= -f, f += s; f > 0; o = 256 * o + t[e + l], l += h, f -= 8) {
        ;
      }

      for (a = o & (1 << -f) - 1, o >>= -f, f += n; f > 0; a = 256 * a + t[e + l], l += h, f -= 8) {
        ;
      }

      if (0 === o) o = 1 - c;else {
        if (o === u) return a ? NaN : 1 / 0 * (p ? -1 : 1);
        a += Math.pow(2, n), o -= c;
      }
      return (p ? -1 : 1) * a * Math.pow(2, o - n);
    }, e.write = function (t, e, r, n, i, o) {
      var a,
          s,
          u,
          c = 8 * o - i - 1,
          f = (1 << c) - 1,
          l = f >> 1,
          h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = n ? 0 : o - 1,
          d = n ? 1 : -1,
          v = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = f) : (a = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (e += a + l >= 1 ? h / u : h * Math.pow(2, 1 - l)) * u >= 2 && (a++, u /= 2), a + l >= f ? (s = 0, a = f) : a + l >= 1 ? (s = (e * u - 1) * Math.pow(2, i), a += l) : (s = e * Math.pow(2, l - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + p] = 255 & s, p += d, s /= 256, i -= 8) {
        ;
      }

      for (a = a << i | s, c += i; c > 0; t[r + p] = 255 & a, p += d, a /= 256, c -= 8) {
        ;
      }

      t[r + p - d] |= 128 * v;
    };
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(56).Buffer,
        i = r(194);
    t.exports = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, r = "" + e.data; e = e.next;) {
          r += t + e.data;
        }

        return r;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e, r, i, o = n.allocUnsafe(t >>> 0), a = this.head, s = 0; a;) {
          e = a.data, r = o, i = s, e.copy(r, i), s += a.data.length, a = a.next;
        }

        return o;
      }, t;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
      var t = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, r) {
    (function (e) {
      function r(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var r = e.localStorage[t];
        return null != r && "true" === String(r).toLowerCase();
      }

      t.exports = function (t, e) {
        if (r("noDeprecation")) return t;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(e);
            r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
          }

          return t.apply(this, arguments);
        };
      };
    }).call(this, r(21));
  }, function (t, e, r) {
    "use strict";

    t.exports = o;
    var n = r(142),
        i = r(39);

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      n.call(this, t);
    }

    i.inherits = r(29), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
      r(null, t);
    };
  }, function (t, e, r) {
    t.exports = r(95);
  }, function (t, e, r) {
    t.exports = r(23);
  }, function (t, e, r) {
    t.exports = r(94).Transform;
  }, function (t, e, r) {
    t.exports = r(94).PassThrough;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(60),
        o = r(12),
        a = r(36),
        s = [].join,
        u = i != Object,
        c = a("join", ",");
    n({
      target: "Array",
      proto: !0,
      forced: u || c
    }, {
      join: function join(t) {
        return s.call(o(this), void 0 === t ? "," : t);
      }
    });
  }, function (t, e) {
    t.exports = function (t) {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    };
  }, function (t, e, r) {
    var n = r(80);

    function i() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    function o(e, r, a) {
      return i() ? t.exports = o = Reflect.construct : t.exports = o = function o(t, e, r) {
        var i = [null];
        i.push.apply(i, e);
        var o = new (Function.bind.apply(t, i))();
        return r && n(o, r.prototype), o;
      }, o.apply(null, arguments);
    }

    t.exports = o;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(66).indexOf,
        o = r(36),
        a = [].indexOf,
        s = !!a && 1 / [1].indexOf(1, -0) < 0,
        u = o("indexOf");
    n({
      target: "Array",
      proto: !0,
      forced: s || u
    }, {
      indexOf: function indexOf(t) {
        return s ? a.apply(this, arguments) || 0 : i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    r(98), r(149), r(150), r(51), r(52), r(35), r(74), r(75), r(79);

    var n = r(0),
        i = r.n(n),
        o = (r(28), r(1)),
        a = r.n(o),
        s = r(18),
        u = r.n(s),
        c = r(30),
        f = r.n(c),
        l = r(40),
        h = r.n(l),
        p = r(16),
        d = r.n(p),
        v = r(57),
        g = r.n(v),
        y = r(41),
        b = r.n(y),
        _ = (r(81), r(84), r(85), r(86), r(37), r(87), r(157), r(158), r(159), r(161), r(162), r(124), r(163), r(165), r(126), r(129), r(89), r(90), r(42)),
        m = r.n(_),
        w = r(9),
        x = r.n(w),
        k = r(143),
        E = r.n(k),
        S = r(58),
        j = r.n(S),
        R = (r(174), r(130), r(131), r(176), function (t) {
      for (; t.endsWith("/");) {
        t = t.slice(0, -1);
      }

      return t;
    }),
        C = function C(t) {
      for (var e = t.split("/"), r = e[0], n = 0, i = 1; i < e.length - 1; i++) {
        n = i, "" === e[i] && (r += "/");
        break;
      }

      return r = r + "/" + e[n + 1] + "/";
    },
        I = function I(t) {
      return (t = R(t)).substring(0, t.lastIndexOf("/") + 1);
    },
        O = function O(t) {
      return (t = R(t)).substr(t.lastIndexOf("/") + 1);
    },
        T = function T() {
      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
        e[r] = arguments[r];
      }

      return e.every(function (t) {
        return t.endsWith("/");
      });
    },
        P = function P() {
      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
        e[r] = arguments[r];
      }

      return e.every(function (t) {
        return !t.endsWith("/");
      });
    },
        A = {
      CONTAINER: '<http://www.w3.org/ns/ldp#BasicContainer>; rel="type"',
      RESOURCE: '<http://www.w3.org/ns/ldp#Resource>; rel="type"'
    },
        L = (r(91), r(96)),
        F = r.n(L),
        M = r(6);

    var _M$a = M.a,
        N = _M$a.rdf,
        B = _M$a.xsd;
    var D,
        U,
        q = 0;

    var G =
    /*#__PURE__*/
    function () {
      function G(t) {
        _classCallCheck(this, G);

        this.id = t;
      }

      _createClass(G, [{
        key: "equals",
        value: function equals(t) {
          return t instanceof G ? this.id === t.id : !!t && this.termType === t.termType && this.value === t.value;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            termType: this.termType,
            value: this.value
          };
        }
      }, {
        key: "value",
        get: function get() {
          return this.id;
        }
      }]);

      return G;
    }();

    var W =
    /*#__PURE__*/
    function (_G) {
      _inherits(W, _G);

      function W() {
        _classCallCheck(this, W);

        return _possibleConstructorReturn(this, _getPrototypeOf(W).apply(this, arguments));
      }

      _createClass(W, [{
        key: "termType",
        get: function get() {
          return "NamedNode";
        }
      }]);

      return W;
    }(G);

    var z =
    /*#__PURE__*/
    function (_G2) {
      _inherits(z, _G2);

      function z() {
        _classCallCheck(this, z);

        return _possibleConstructorReturn(this, _getPrototypeOf(z).apply(this, arguments));
      }

      _createClass(z, [{
        key: "equals",
        value: function equals(t) {
          return t instanceof z ? this.id === t.id : !!t && !!t.datatype && this.termType === t.termType && this.value === t.value && this.language === t.language && this.datatype.value === t.datatype.value;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            termType: this.termType,
            value: this.value,
            language: this.language,
            datatype: {
              termType: "NamedNode",
              value: this.datatypeString
            }
          };
        }
      }, {
        key: "termType",
        get: function get() {
          return "Literal";
        }
      }, {
        key: "value",
        get: function get() {
          return this.id.substring(1, this.id.lastIndexOf('"'));
        }
      }, {
        key: "language",
        get: function get() {
          var t = this.id,
              e = t.lastIndexOf('"') + 1;
          return e < t.length && "@" === t[e++] ? t.substr(e).toLowerCase() : "";
        }
      }, {
        key: "datatype",
        get: function get() {
          return new W(this.datatypeString);
        }
      }, {
        key: "datatypeString",
        get: function get() {
          var t,
              e = this.id,
              r = e.lastIndexOf('"') + 1;
          return r < e.length && "^" === (t = e[r]) ? e.substr(r + 2) : "@" !== t ? B.string : N.langString;
        }
      }]);

      return z;
    }(G);

    var Y =
    /*#__PURE__*/
    function (_G3) {
      _inherits(Y, _G3);

      function Y(t) {
        _classCallCheck(this, Y);

        return _possibleConstructorReturn(this, _getPrototypeOf(Y).call(this, "_:" + t));
      }

      _createClass(Y, [{
        key: "termType",
        get: function get() {
          return "BlankNode";
        }
      }, {
        key: "value",
        get: function get() {
          return this.id.substr(2);
        }
      }]);

      return Y;
    }(G);

    var Q =
    /*#__PURE__*/
    function (_G4) {
      _inherits(Q, _G4);

      function Q(t) {
        _classCallCheck(this, Q);

        return _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, "?" + t));
      }

      _createClass(Q, [{
        key: "termType",
        get: function get() {
          return "Variable";
        }
      }, {
        key: "value",
        get: function get() {
          return this.id.substr(1);
        }
      }]);

      return Q;
    }(G);

    var $ =
    /*#__PURE__*/
    function (_G5) {
      _inherits($, _G5);

      function $() {
        var _this;

        _classCallCheck(this, $);

        return _possibleConstructorReturn(_this, (_this = _possibleConstructorReturn(this, _getPrototypeOf($).call(this, "")), U || _assertThisInitialized(_assertThisInitialized(_this))));
      }

      _createClass($, [{
        key: "equals",
        value: function equals(t) {
          return this === t || !!t && this.termType === t.termType;
        }
      }, {
        key: "termType",
        get: function get() {
          return "DefaultGraph";
        }
      }]);

      return $;
    }(G);

    U = new $();

    var H =
    /*#__PURE__*/
    function () {
      function H(t, e, r, n) {
        _classCallCheck(this, H);

        this.subject = t, this.predicate = e, this.object = r, this.graph = n || U;
      }

      _createClass(H, [{
        key: "toJSON",
        value: function toJSON() {
          return {
            subject: this.subject.toJSON(),
            predicate: this.predicate.toJSON(),
            object: this.object.toJSON(),
            graph: this.graph.toJSON()
          };
        }
      }, {
        key: "equals",
        value: function equals(t) {
          return !!t && this.subject.equals(t.subject) && this.predicate.equals(t.predicate) && this.object.equals(t.object) && this.graph.equals(t.graph);
        }
      }]);

      return H;
    }();

    var K = D = {
      namedNode: function namedNode(t) {
        return new W(t);
      },
      blankNode: function blankNode(t) {
        t || (t = "n3-" + q++);
        return new Y(t);
      },
      variable: function variable(t) {
        return new Q(t);
      },
      literal: function literal(t, e) {
        if ("string" == typeof e) return new z('"' + t + '"@' + e.toLowerCase());
        var r = e ? e.value : "";
        "" === r && ("boolean" == typeof t ? r = B.boolean : "number" == typeof t && (Number.isFinite(t) ? r = Number.isInteger(t) ? B.integer : B.double : (r = B.double, Number.isNaN(t) || (t = t > 0 ? "INF" : "-INF"))));
        return "" === r || r === B.string ? new z('"' + t + '"') : new z('"' + t + '"^^' + r);
      },
      defaultGraph: function defaultGraph() {
        return U;
      },
      quad: V,
      triple: V,
      internal: {
        Term: G,
        NamedNode: W,
        BlankNode: Y,
        Variable: Q,
        Literal: z,
        DefaultGraph: $,
        Quad: H,
        Triple: H,
        fromId: function fromId(t, e) {
          if (e = e || D, !t) return e.defaultGraph();

          switch (t[0]) {
            case "_":
              return e.blankNode(t.substr(2));

            case "?":
              return e.variable(t.substr(1));

            case '"':
              if (e === D) return new z(t);
              if ('"' === t[t.length - 1]) return e.literal(t.substr(1, t.length - 2));
              var r = t.lastIndexOf('"', t.length - 1);
              return e.literal(t.substr(1, r - 1), "@" === t[r + 1] ? t.substr(r + 2) : e.namedNode(t.substr(r + 3)));

            default:
              return e.namedNode(t);
          }
        },
        toId: function toId(t) {
          if ("string" == typeof t) return t;
          if (t instanceof G) return t.id;
          if (!t) return U.id;

          switch (t.termType) {
            case "NamedNode":
              return t.value;

            case "BlankNode":
              return "_:" + t.value;

            case "Variable":
              return "?" + t.value;

            case "DefaultGraph":
              return "";

            case "Literal":
              return '"' + t.value + '"' + (t.language ? "@" + t.language : t.datatype && t.datatype.value !== B.string ? "^^" + t.datatype.value : "");

            default:
              throw new Error("Unexpected termType: " + t.termType);
          }
        }
      }
    };

    function V(t, e, r, n) {
      return new H(t, e, r, n);
    }

    var Z = r(145),
        J = 0,
        X = 0;

    var tt =
    /*#__PURE__*/
    function () {
      function tt(t) {
        _classCallCheck(this, tt);

        this._contextStack = [], this._graph = null, t = t || {}, this._setBase(t.baseIRI), t.factory && rt(this, t.factory);
        var e = "string" == typeof t.format ? t.format.match(/\w*$/)[0].toLowerCase() : "",
            r = "turtle" === e,
            n = "trig" === e,
            i = /triple/.test(e),
            o = /quad/.test(e),
            a = this._n3Mode = /n3/.test(e),
            s = i || o;
        (this._supportsNamedGraphs = !(r || a)) || (this._readPredicateOrNamedGraph = this._readPredicate), this._supportsQuads = !(r || n || i || a), s && (this._resolveRelativeIRI = function (t) {
          return null;
        }), this._blankNodePrefix = "string" != typeof t.blankNodePrefix ? "" : t.blankNodePrefix.replace(/^(?!_:)/, "_:"), this._lexer = t.lexer || new Z.a({
          lineMode: s,
          n3: a
        }), this._explicitQuantifiers = !!t.explicitQuantifiers;
      }

      _createClass(tt, [{
        key: "_blank",
        value: function _blank() {
          return this._blankNode("b" + X++);
        }
      }, {
        key: "_setBase",
        value: function _setBase(t) {
          if (t) {
            var e = t.indexOf("#");
            e >= 0 && (t = t.substr(0, e)), this._base = t, this._basePath = t.indexOf("/") < 0 ? t : t.replace(/[^\/?]*(?:\?.*)?$/, ""), t = t.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i), this._baseRoot = t[0], this._baseScheme = t[1];
          } else this._base = "", this._basePath = "";
        }
      }, {
        key: "_saveContext",
        value: function _saveContext(t, e, r, n, i) {
          var o = this._n3Mode;
          this._contextStack.push({
            subject: r,
            predicate: n,
            object: i,
            graph: e,
            type: t,
            inverse: !!o && this._inversePredicate,
            blankPrefix: o ? this._prefixes._ : "",
            quantified: o ? this._quantified : null
          }), o && (this._inversePredicate = !1, this._prefixes._ = this._graph ? this._graph.id.substr(2) + "." : ".", this._quantified = Object.create(this._quantified));
        }
      }, {
        key: "_restoreContext",
        value: function _restoreContext() {
          var t = this._contextStack.pop(),
              e = this._n3Mode;

          this._subject = t.subject, this._predicate = t.predicate, this._object = t.object, this._graph = t.graph, e && (this._inversePredicate = t.inverse, this._prefixes._ = t.blankPrefix, this._quantified = t.quantified);
        }
      }, {
        key: "_readInTopContext",
        value: function _readInTopContext(t) {
          switch (t.type) {
            case "eof":
              return null !== this._graph ? this._error("Unclosed graph", t) : (delete this._prefixes._, this._callback(null, null, this._prefixes));

            case "PREFIX":
              this._sparqlStyle = !0;

            case "@prefix":
              return this._readPrefix;

            case "BASE":
              this._sparqlStyle = !0;

            case "@base":
              return this._readBaseIRI;

            case "{":
              if (this._supportsNamedGraphs) return this._graph = "", this._subject = null, this._readSubject;

            case "GRAPH":
              if (this._supportsNamedGraphs) return this._readNamedGraphLabel;

            default:
              return this._readSubject(t);
          }
        }
      }, {
        key: "_readEntity",
        value: function _readEntity(t, e) {
          var r;

          switch (t.type) {
            case "IRI":
            case "typeIRI":
              var n = this._resolveIRI(t.value);

              if (null === n) return this._error("Invalid IRI", t);
              r = this._namedNode(n);
              break;

            case "type":
            case "prefixed":
              var i = this._prefixes[t.prefix];
              if (void 0 === i) return this._error('Undefined prefix "' + t.prefix + ':"', t);
              r = this._namedNode(i + t.value);
              break;

            case "blank":
              r = this._blankNode(this._prefixes[t.prefix] + t.value);
              break;

            case "var":
              r = this._variable(t.value.substr(1));
              break;

            default:
              return this._error("Expected entity but got " + t.type, t);
          }

          return !e && this._n3Mode && r.id in this._quantified && (r = this._quantified[r.id]), r;
        }
      }, {
        key: "_readSubject",
        value: function _readSubject(t) {
          switch (this._predicate = null, t.type) {
            case "[":
              return this._saveContext("blank", this._graph, this._subject = this._blank(), null, null), this._readBlankNodeHead;

            case "(":
              return this._saveContext("list", this._graph, this.RDF_NIL, null, null), this._subject = null, this._readListItem;

            case "{":
              return this._n3Mode ? (this._saveContext("formula", this._graph, this._graph = this._blank(), null, null), this._readSubject) : this._error("Unexpected graph", t);

            case "}":
              return this._readPunctuation(t);

            case "@forSome":
              return this._n3Mode ? (this._subject = null, this._predicate = this.N3_FORSOME, this._quantifier = this._blankNode, this._readQuantifierList) : this._error('Unexpected "@forSome"', t);

            case "@forAll":
              return this._n3Mode ? (this._subject = null, this._predicate = this.N3_FORALL, this._quantifier = this._variable, this._readQuantifierList) : this._error('Unexpected "@forAll"', t);

            default:
              if (void 0 === (this._subject = this._readEntity(t))) return;
              if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
          }

          return this._readPredicateOrNamedGraph;
        }
      }, {
        key: "_readPredicate",
        value: function _readPredicate(t) {
          var e = t.type;

          switch (e) {
            case "inverse":
              this._inversePredicate = !0;

            case "abbreviation":
              this._predicate = this.ABBREVIATIONS[t.value];
              break;

            case ".":
            case "]":
            case "}":
              return null === this._predicate ? this._error("Unexpected " + e, t) : (this._subject = null, "]" === e ? this._readBlankNodeTail(t) : this._readPunctuation(t));

            case ";":
              return null !== this._predicate ? this._readPredicate : this._error("Expected predicate but got ;", t);

            case "blank":
              if (!this._n3Mode) return this._error("Disallowed blank node as predicate", t);

            default:
              if (void 0 === (this._predicate = this._readEntity(t))) return;
          }

          return this._readObject;
        }
      }, {
        key: "_readObject",
        value: function _readObject(t) {
          switch (t.type) {
            case "literal":
              if (0 === t.prefix.length) return this._literalValue = t.value, this._readDataTypeOrLang;
              this._object = this._literal(t.value, this._namedNode(t.prefix));
              break;

            case "[":
              return this._saveContext("blank", this._graph, this._subject, this._predicate, this._subject = this._blank()), this._readBlankNodeHead;

            case "(":
              return this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL), this._subject = null, this._readListItem;

            case "{":
              return this._n3Mode ? (this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blank()), this._readSubject) : this._error("Unexpected graph", t);

            default:
              if (void 0 === (this._object = this._readEntity(t))) return;
              if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
          }

          return this._getContextEndReader();
        }
      }, {
        key: "_readPredicateOrNamedGraph",
        value: function _readPredicateOrNamedGraph(t) {
          return "{" === t.type ? this._readGraph(t) : this._readPredicate(t);
        }
      }, {
        key: "_readGraph",
        value: function _readGraph(t) {
          return "{" !== t.type ? this._error("Expected graph but got " + t.type, t) : (this._graph = this._subject, this._subject = null, this._readSubject);
        }
      }, {
        key: "_readBlankNodeHead",
        value: function _readBlankNodeHead(t) {
          return "]" === t.type ? (this._subject = null, this._readBlankNodeTail(t)) : (this._predicate = null, this._readPredicate(t));
        }
      }, {
        key: "_readBlankNodeTail",
        value: function _readBlankNodeTail(t) {
          if ("]" !== t.type) return this._readBlankNodePunctuation(t);
          null !== this._subject && this._emit(this._subject, this._predicate, this._object, this._graph);
          var e = null === this._predicate;
          return this._restoreContext(), null === this._object ? e ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank : this._getContextEndReader();
        }
      }, {
        key: "_readPredicateAfterBlank",
        value: function _readPredicateAfterBlank(t) {
          switch (t.type) {
            case ".":
            case "}":
              return this._subject = null, this._readPunctuation(t);

            default:
              return this._readPredicate(t);
          }
        }
      }, {
        key: "_readListItem",
        value: function _readListItem(t) {
          var e = null,
              r = null,
              n = this._subject,
              i = this._contextStack,
              o = i[i.length - 1],
              a = this._readListItem;

          switch (t.type) {
            case "[":
              this._saveContext("blank", this._graph, r = this._blank(), this.RDF_FIRST, this._subject = e = this._blank()), a = this._readBlankNodeHead;
              break;

            case "(":
              this._saveContext("list", this._graph, r = this._blank(), this.RDF_FIRST, this.RDF_NIL), this._subject = null;
              break;

            case ")":
              if (this._restoreContext(), 0 !== i.length && "list" === i[i.length - 1].type && this._emit(this._subject, this._predicate, this._object, this._graph), null === this._predicate) {
                if (a = this._readPredicate, this._subject === this.RDF_NIL) return a;
              } else if (a = this._getContextEndReader(), this._object === this.RDF_NIL) return a;

              r = this.RDF_NIL;
              break;

            case "literal":
              0 === t.prefix.length ? (this._literalValue = t.value, a = this._readListItemDataTypeOrLang) : (e = this._literal(t.value, this._namedNode(t.prefix)), a = this._getContextEndReader());
              break;

            default:
              if (void 0 === (e = this._readEntity(t))) return;
          }

          if (null === r && (this._subject = r = this._blank()), null === n ? null === o.predicate ? o.subject = r : o.object = r : this._emit(n, this.RDF_REST, r, this._graph), null !== e) {
            if (this._n3Mode && ("IRI" === t.type || "prefixed" === t.type)) return this._saveContext("item", this._graph, r, this.RDF_FIRST, e), this._subject = e, this._predicate = null, this._getPathReader(this._readListItem);

            this._emit(r, this.RDF_FIRST, e, this._graph);
          }

          return a;
        }
      }, {
        key: "_readDataTypeOrLang",
        value: function _readDataTypeOrLang(t) {
          return this._completeLiteral(t, !1);
        }
      }, {
        key: "_readListItemDataTypeOrLang",
        value: function _readListItemDataTypeOrLang(t) {
          return this._completeLiteral(t, !0);
        }
      }, {
        key: "_completeLiteral",
        value: function _completeLiteral(t, e) {
          switch (t.type) {
            case "type":
            case "typeIRI":
              var r = this._readEntity(t);

              if (void 0 === r) return;
              this._object = this._literal(this._literalValue, r), t = null;
              break;

            case "langcode":
              this._object = this._literal(this._literalValue, t.value), t = null;
              break;

            default:
              this._object = this._literal(this._literalValue);
          }

          return e && this._emit(this._subject, this.RDF_FIRST, this._object, this._graph), null === t ? this._getContextEndReader() : (this._readCallback = this._getContextEndReader(), this._readCallback(t));
        }
      }, {
        key: "_readFormulaTail",
        value: function _readFormulaTail(t) {
          return "}" !== t.type ? this._readPunctuation(t) : (null !== this._subject && this._emit(this._subject, this._predicate, this._object, this._graph), this._restoreContext(), null === this._object ? this._readPredicate : this._getContextEndReader());
        }
      }, {
        key: "_readPunctuation",
        value: function _readPunctuation(t) {
          var e,
              r = this._subject,
              n = this._graph,
              i = this._inversePredicate;

          switch (t.type) {
            case "}":
              if (null === this._graph) return this._error("Unexpected graph closing", t);
              if (this._n3Mode) return this._readFormulaTail(t);
              this._graph = null;

            case ".":
              this._subject = null, e = this._contextStack.length ? this._readSubject : this._readInTopContext, i && (this._inversePredicate = !1);
              break;

            case ";":
              e = this._readPredicate;
              break;

            case ",":
              e = this._readObject;
              break;

            default:
              if (this._supportsQuads && null === this._graph && void 0 !== (n = this._readEntity(t))) {
                e = this._readQuadPunctuation;
                break;
              }

              return this._error('Expected punctuation to follow "' + this._object.id + '"', t);
          }

          if (null !== r) {
            var o = this._predicate,
                a = this._object;
            i ? this._emit(a, o, r, n) : this._emit(r, o, a, n);
          }

          return e;
        }
      }, {
        key: "_readBlankNodePunctuation",
        value: function _readBlankNodePunctuation(t) {
          var e;

          switch (t.type) {
            case ";":
              e = this._readPredicate;
              break;

            case ",":
              e = this._readObject;
              break;

            default:
              return this._error('Expected punctuation to follow "' + this._object.id + '"', t);
          }

          return this._emit(this._subject, this._predicate, this._object, this._graph), e;
        }
      }, {
        key: "_readQuadPunctuation",
        value: function _readQuadPunctuation(t) {
          return "." !== t.type ? this._error("Expected dot to follow quad", t) : this._readInTopContext;
        }
      }, {
        key: "_readPrefix",
        value: function _readPrefix(t) {
          return "prefix" !== t.type ? this._error("Expected prefix to follow @prefix", t) : (this._prefix = t.value, this._readPrefixIRI);
        }
      }, {
        key: "_readPrefixIRI",
        value: function _readPrefixIRI(t) {
          if ("IRI" !== t.type) return this._error('Expected IRI to follow prefix "' + this._prefix + ':"', t);

          var e = this._readEntity(t);

          return this._prefixes[this._prefix] = e.value, this._prefixCallback(this._prefix, e), this._readDeclarationPunctuation;
        }
      }, {
        key: "_readBaseIRI",
        value: function _readBaseIRI(t) {
          var e = "IRI" === t.type && this._resolveIRI(t.value);

          return e ? (this._setBase(e), this._readDeclarationPunctuation) : this._error("Expected valid IRI to follow base declaration", t);
        }
      }, {
        key: "_readNamedGraphLabel",
        value: function _readNamedGraphLabel(t) {
          switch (t.type) {
            case "IRI":
            case "blank":
            case "prefixed":
              return this._readSubject(t), this._readGraph;

            case "[":
              return this._readNamedGraphBlankLabel;

            default:
              return this._error("Invalid graph label", t);
          }
        }
      }, {
        key: "_readNamedGraphBlankLabel",
        value: function _readNamedGraphBlankLabel(t) {
          return "]" !== t.type ? this._error("Invalid graph label", t) : (this._subject = this._blank(), this._readGraph);
        }
      }, {
        key: "_readDeclarationPunctuation",
        value: function _readDeclarationPunctuation(t) {
          return this._sparqlStyle ? (this._sparqlStyle = !1, this._readInTopContext(t)) : "." !== t.type ? this._error("Expected declaration to end with a dot", t) : this._readInTopContext;
        }
      }, {
        key: "_readQuantifierList",
        value: function _readQuantifierList(t) {
          var e;

          switch (t.type) {
            case "IRI":
            case "prefixed":
              if (void 0 !== (e = this._readEntity(t, !0))) break;

            default:
              return this._error("Unexpected " + t.type, t);
          }

          return this._explicitQuantifiers ? (null === this._subject ? this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._blank(), this.QUANTIFIERS_GRAPH) : this._emit(this._subject, this.RDF_REST, this._subject = this._blank(), this.QUANTIFIERS_GRAPH), this._emit(this._subject, this.RDF_FIRST, e, this.QUANTIFIERS_GRAPH)) : this._quantified[e.id] = this._quantifier("b" + X++), this._readQuantifierPunctuation;
        }
      }, {
        key: "_readQuantifierPunctuation",
        value: function _readQuantifierPunctuation(t) {
          return "," === t.type ? this._readQuantifierList : (this._explicitQuantifiers && (this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH), this._subject = null), this._readCallback = this._getContextEndReader(), this._readCallback(t));
        }
      }, {
        key: "_getPathReader",
        value: function _getPathReader(t) {
          return this._afterPath = t, this._readPath;
        }
      }, {
        key: "_readPath",
        value: function _readPath(t) {
          switch (t.type) {
            case "!":
              return this._readForwardPath;

            case "^":
              return this._readBackwardPath;

            default:
              var e = this._contextStack,
                  r = e.length && e[e.length - 1];

              if (r && "item" === r.type) {
                var n = this._subject;
                this._restoreContext(), this._emit(this._subject, this.RDF_FIRST, n, this._graph);
              }

              return this._afterPath(t);
          }
        }
      }, {
        key: "_readForwardPath",
        value: function _readForwardPath(t) {
          var e,
              r,
              n = this._blank();

          if (void 0 !== (r = this._readEntity(t))) return null === this._predicate ? (e = this._subject, this._subject = n) : (e = this._object, this._object = n), this._emit(e, r, n, this._graph), this._readPath;
        }
      }, {
        key: "_readBackwardPath",
        value: function _readBackwardPath(t) {
          var e,
              r,
              n = this._blank();

          if (void 0 !== (e = this._readEntity(t))) return null === this._predicate ? (r = this._subject, this._subject = n) : (r = this._object, this._object = n), this._emit(n, e, r, this._graph), this._readPath;
        }
      }, {
        key: "_getContextEndReader",
        value: function _getContextEndReader() {
          var t = this._contextStack;
          if (!t.length) return this._readPunctuation;

          switch (t[t.length - 1].type) {
            case "blank":
              return this._readBlankNodeTail;

            case "list":
              return this._readListItem;

            case "formula":
              return this._readFormulaTail;
          }
        }
      }, {
        key: "_emit",
        value: function _emit(t, e, r, n) {
          this._callback(null, this._quad(t, e, r, n || this.DEFAULTGRAPH));
        }
      }, {
        key: "_error",
        value: function _error(t, e) {
          var r = new Error(t + " on line " + e.line + ".");
          r.context = {
            token: e,
            line: e.line,
            previousToken: this._lexer.previousToken
          }, this._callback(r), this._callback = et;
        }
      }, {
        key: "_resolveIRI",
        value: function _resolveIRI(t) {
          return /^[a-z][a-z0-9+.-]*:/i.test(t) ? t : this._resolveRelativeIRI(t);
        }
      }, {
        key: "_resolveRelativeIRI",
        value: function _resolveRelativeIRI(t) {
          if (!t.length) return this._base;

          switch (t[0]) {
            case "#":
              return this._base + t;

            case "?":
              return this._base.replace(/(?:\?.*)?$/, t);

            case "/":
              return ("/" === t[1] ? this._baseScheme : this._baseRoot) + this._removeDotSegments(t);

            default:
              return /^[^/:]*:/.test(t) ? null : this._removeDotSegments(this._basePath + t);
          }
        }
      }, {
        key: "_removeDotSegments",
        value: function _removeDotSegments(t) {
          if (!/(^|\/)\.\.?($|[/#?])/.test(t)) return t;

          for (var e = "", r = t.length, n = -1, i = -1, o = 0, a = "/"; n < r;) {
            switch (a) {
              case ":":
                if (i < 0 && "/" === t[++n] && "/" === t[++n]) for (; (i = n + 1) < r && "/" !== t[i];) {
                  n = i;
                }
                break;

              case "?":
              case "#":
                n = r;
                break;

              case "/":
                if ("." === t[n + 1]) switch (a = t[1 + ++n]) {
                  case "/":
                    e += t.substring(o, n - 1), o = n + 1;
                    break;

                  case void 0:
                  case "?":
                  case "#":
                    return e + t.substring(o, n) + t.substr(n + 1);

                  case ".":
                    if (void 0 === (a = t[1 + ++n]) || "/" === a || "?" === a || "#" === a) {
                      if ((o = (e += t.substring(o, n - 2)).lastIndexOf("/")) >= i && (e = e.substr(0, o)), "/" !== a) return e + "/" + t.substr(n + 1);
                      o = n + 1;
                    }

                }
            }

            a = t[++n];
          }

          return e + t.substring(o);
        }
      }, {
        key: "parse",
        value: function parse(t, e, r) {
          var n = this;

          if (this._readCallback = this._readInTopContext, this._sparqlStyle = !1, this._prefixes = Object.create(null), this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : "b" + J++ + "_", this._prefixCallback = r || et, this._inversePredicate = !1, this._quantified = Object.create(null), !e) {
            var i,
                o = [];
            if (this._callback = function (t, e) {
              t ? i = t : e && o.push(e);
            }, this._lexer.tokenize(t).every(function (t) {
              return n._readCallback = n._readCallback(t);
            }), i) throw i;
            return o;
          }

          this._callback = e, this._lexer.tokenize(t, function (t, e) {
            null !== t ? (n._callback(t), n._callback = et) : n._readCallback && (n._readCallback = n._readCallback(e));
          });
        }
      }], [{
        key: "_resetBlankNodeIds",
        value: function _resetBlankNodeIds() {
          J = X = 0;
        }
      }]);

      return tt;
    }();

    function et() {}

    function rt(t, e) {
      var r = e.namedNode;
      t._namedNode = r, t._blankNode = e.blankNode, t._literal = e.literal, t._variable = e.variable, t._quad = e.quad, t.DEFAULTGRAPH = e.defaultGraph(), t.RDF_FIRST = r(M.a.rdf.first), t.RDF_REST = r(M.a.rdf.rest), t.RDF_NIL = r(M.a.rdf.nil), t.N3_FORALL = r(M.a.r.forAll), t.N3_FORSOME = r(M.a.r.forSome), t.ABBREVIATIONS = {
        a: r(M.a.rdf.type),
        "=": r(M.a.owl.sameAs),
        ">": r(M.a.log.implies)
      }, t.QUANTIFIERS_GRAPH = r("urn:n3:quantifiers");
    }

    rt(tt.prototype, K);
    var nt = r(146);
    var _K$internal = K.internal,
        it = _K$internal.toId,
        ot = _K$internal.fromId;

    var at =
    /*#__PURE__*/
    function () {
      function at(t, e) {
        _classCallCheck(this, at);

        this._size = 0, this._graphs = Object.create(null), this._id = 0, this._ids = Object.create(null), this._ids["><"] = 0, this._entities = Object.create(null), this._blankNodeIndex = 0, e || !t || t[0] || (e = t, t = null), e = e || {}, this._factory = e.factory || K, t && this.addQuads(t);
      }

      _createClass(at, [{
        key: "_addToIndex",
        value: function _addToIndex(t, e, r, n) {
          var i = t[e] || (t[e] = {}),
              o = i[r] || (i[r] = {}),
              a = n in o;
          return a || (o[n] = null), !a;
        }
      }, {
        key: "_removeFromIndex",
        value: function _removeFromIndex(t, e, r, n) {
          var i,
              o = t[e],
              a = o[r];

          for (i in delete a[n], a) {
            return;
          }

          for (i in delete o[r], o) {
            return;
          }

          delete t[e];
        }
      }, {
        key: "_findInIndex",
        value: function _findInIndex(t, e, r, n, i, o, a, s, u, c) {
          var f,
              l,
              h,
              p = !e + !r + !n > 1 ? Object.keys(this._ids) : this._entities;

          for (var d in e && ((f = t, t = {})[e] = f[e]), t) {
            var v = p[d];
            if (l = t[d]) for (var g in r && ((f = l, l = {})[r] = f[r]), l) {
              var y = p[g];
              if (h = l[g]) for (var b = n ? (n in h) ? [n] : [] : Object.keys(h), _ = 0; _ < b.length; _++) {
                var m = {
                  subject: null,
                  predicate: null,
                  object: null
                };
                m[i] = ot(v, this._factory), m[o] = ot(y, this._factory), m[a] = ot(p[b[_]], this._factory);

                var w = this._factory.quad(m.subject, m.predicate, m.object, ot(s, this._factory));

                if (c) c.push(w);else if (u(w)) return !0;
              }
            }
          }

          return c;
        }
      }, {
        key: "_loop",
        value: function _loop(t, e) {
          for (var r in t) {
            e(r);
          }
        }
      }, {
        key: "_loopByKey0",
        value: function _loopByKey0(t, e, r) {
          var n, i;
          if (n = t[e]) for (i in n) {
            r(i);
          }
        }
      }, {
        key: "_loopByKey1",
        value: function _loopByKey1(t, e, r) {
          var n;

          for (n in t) {
            t[n][e] && r(n);
          }
        }
      }, {
        key: "_loopBy2Keys",
        value: function _loopBy2Keys(t, e, r, n) {
          var i, o, a;
          if ((i = t[e]) && (o = i[r])) for (a in o) {
            n(a);
          }
        }
      }, {
        key: "_countInIndex",
        value: function _countInIndex(t, e, r, n) {
          var i,
              o,
              a,
              s = 0;

          for (var u in e && ((i = t, t = {})[e] = i[e]), t) {
            if (o = t[u]) for (var c in r && ((i = o, o = {})[r] = i[r]), o) {
              (a = o[c]) && (n ? n in a && s++ : s += Object.keys(a).length);
            }
          }

          return s;
        }
      }, {
        key: "_getGraphs",
        value: function _getGraphs(t) {
          if (!st(t)) return this._graphs;
          var e = {};
          return e[t] = this._graphs[t], e;
        }
      }, {
        key: "_uniqueEntities",
        value: function _uniqueEntities(t) {
          var e = Object.create(null),
              r = this._entities;
          return function (n) {
            n in e || (e[n] = !0, t(ot(r[n])));
          };
        }
      }, {
        key: "addQuad",
        value: function addQuad(t, e, r, n) {
          e || (n = t.graph, r = t.object, e = t.predicate, t = t.subject), t = it(t), e = it(e), r = it(r), n = it(n);
          var i = this._graphs[n];
          i || (i = this._graphs[n] = {
            subjects: {},
            predicates: {},
            objects: {}
          }, Object.freeze(i));
          var o = this._ids,
              a = this._entities;
          t = o[t] || (o[a[++this._id] = t] = this._id), e = o[e] || (o[a[++this._id] = e] = this._id), r = o[r] || (o[a[++this._id] = r] = this._id);

          var s = this._addToIndex(i.subjects, t, e, r);

          return this._addToIndex(i.predicates, e, r, t), this._addToIndex(i.objects, r, t, e), this._size = null, s;
        }
      }, {
        key: "addQuads",
        value: function addQuads(t) {
          for (var e = 0; e < t.length; e++) {
            this.addQuad(t[e]);
          }
        }
      }, {
        key: "import",
        value: function _import(t) {
          var e = this;
          return t.on("data", function (t) {
            e.addQuad(t);
          }), t;
        }
      }, {
        key: "removeQuad",
        value: function removeQuad(t, e, r, n) {
          e || (n = t.graph, r = t.object, e = t.predicate, t = t.subject), t = it(t), e = it(e), r = it(r), n = it(n);
          var i,
              o,
              a,
              s = this._ids,
              u = this._graphs;
          if (!((t = s[t]) && (e = s[e]) && (r = s[r]) && (i = u[n]) && (o = i.subjects[t]) && (a = o[e]) && r in a)) return !1;

          for (t in this._removeFromIndex(i.subjects, t, e, r), this._removeFromIndex(i.predicates, e, r, t), this._removeFromIndex(i.objects, r, t, e), null !== this._size && this._size--, i.subjects) {
            return !0;
          }

          return delete u[n], !0;
        }
      }, {
        key: "removeQuads",
        value: function removeQuads(t) {
          for (var e = 0; e < t.length; e++) {
            this.removeQuad(t[e]);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = this;
          return t.on("data", function (t) {
            e.removeQuad(t);
          }), t;
        }
      }, {
        key: "removeMatches",
        value: function removeMatches(t, e, r, n) {
          return this.remove(this.match(t, e, r, n));
        }
      }, {
        key: "deleteGraph",
        value: function deleteGraph(t) {
          return this.removeMatches(null, null, null, t);
        }
      }, {
        key: "getQuads",
        value: function getQuads(t, e, r, n) {
          t = t && it(t), e = e && it(e), r = r && it(r), n = n && it(n);

          var i,
              o,
              a,
              s,
              u = [],
              c = this._getGraphs(n),
              f = this._ids;

          if (st(t) && !(o = f[t]) || st(e) && !(a = f[e]) || st(r) && !(s = f[r])) return u;

          for (var l in c) {
            (i = c[l]) && (o ? s ? this._findInIndex(i.objects, s, o, a, "object", "subject", "predicate", l, null, u) : this._findInIndex(i.subjects, o, a, null, "subject", "predicate", "object", l, null, u) : a ? this._findInIndex(i.predicates, a, s, null, "predicate", "object", "subject", l, null, u) : s ? this._findInIndex(i.objects, s, null, null, "object", "subject", "predicate", l, null, u) : this._findInIndex(i.subjects, null, null, null, "subject", "predicate", "object", l, null, u));
          }

          return u;
        }
      }, {
        key: "match",
        value: function match(t, e, r, n) {
          var _this2 = this;

          var i = new nt.Readable({
            objectMode: !0
          });
          return i._read = function () {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = _this2.getQuads(t, e, r, n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var o = _step.value;
                i.push(o);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            i.push(null);
          }, i;
        }
      }, {
        key: "countQuads",
        value: function countQuads(t, e, r, n) {
          t = t && it(t), e = e && it(e), r = r && it(r), n = n && it(n);

          var i,
              o,
              a,
              s,
              u = 0,
              c = this._getGraphs(n),
              f = this._ids;

          if (st(t) && !(o = f[t]) || st(e) && !(a = f[e]) || st(r) && !(s = f[r])) return 0;

          for (var l in c) {
            (i = c[l]) && (u += t ? r ? this._countInIndex(i.objects, s, o, a) : this._countInIndex(i.subjects, o, a, s) : e ? this._countInIndex(i.predicates, a, s, o) : this._countInIndex(i.objects, s, o, a));
          }

          return u;
        }
      }, {
        key: "forEach",
        value: function forEach(t, e, r, n, i) {
          this.some(function (e) {
            return t(e), !1;
          }, e, r, n, i);
        }
      }, {
        key: "every",
        value: function every(t, e, r, n, i) {
          var o = !1,
              a = !this.some(function (e) {
            return o = !0, !t(e);
          }, e, r, n, i);
          return o && a;
        }
      }, {
        key: "some",
        value: function some(t, e, r, n, i) {
          e = e && it(e), r = r && it(r), n = n && it(n), i = i && it(i);

          var o,
              a,
              s,
              u,
              c = this._getGraphs(i),
              f = this._ids;

          if (st(e) && !(a = f[e]) || st(r) && !(s = f[r]) || st(n) && !(u = f[n])) return !1;

          for (var l in c) {
            if (o = c[l]) if (a) {
              if (u) {
                if (this._findInIndex(o.objects, u, a, s, "object", "subject", "predicate", l, t, null)) return !0;
              } else if (this._findInIndex(o.subjects, a, s, null, "subject", "predicate", "object", l, t, null)) return !0;
            } else if (s) {
              if (this._findInIndex(o.predicates, s, u, null, "predicate", "object", "subject", l, t, null)) return !0;
            } else if (u) {
              if (this._findInIndex(o.objects, u, null, null, "object", "subject", "predicate", l, t, null)) return !0;
            } else if (this._findInIndex(o.subjects, null, null, null, "subject", "predicate", "object", l, t, null)) return !0;
          }

          return !1;
        }
      }, {
        key: "getSubjects",
        value: function getSubjects(t, e, r) {
          var n = [];
          return this.forSubjects(function (t) {
            n.push(t);
          }, t, e, r), n;
        }
      }, {
        key: "forSubjects",
        value: function forSubjects(t, e, r, n) {
          e = e && it(e), r = r && it(r), n = n && it(n);

          var i,
              o,
              a,
              s = this._ids,
              u = this._getGraphs(n);

          if (t = this._uniqueEntities(t), !(st(e) && !(o = s[e]) || st(r) && !(a = s[r]))) for (n in u) {
            (i = u[n]) && (o ? a ? this._loopBy2Keys(i.predicates, o, a, t) : this._loopByKey1(i.subjects, o, t) : a ? this._loopByKey0(i.objects, a, t) : this._loop(i.subjects, t));
          }
        }
      }, {
        key: "getPredicates",
        value: function getPredicates(t, e, r) {
          var n = [];
          return this.forPredicates(function (t) {
            n.push(t);
          }, t, e, r), n;
        }
      }, {
        key: "forPredicates",
        value: function forPredicates(t, e, r, n) {
          e = e && it(e), r = r && it(r), n = n && it(n);

          var i,
              o,
              a,
              s = this._ids,
              u = this._getGraphs(n);

          if (t = this._uniqueEntities(t), !(st(e) && !(o = s[e]) || st(r) && !(a = s[r]))) for (n in u) {
            (i = u[n]) && (o ? a ? this._loopBy2Keys(i.objects, a, o, t) : this._loopByKey0(i.subjects, o, t) : a ? this._loopByKey1(i.predicates, a, t) : this._loop(i.predicates, t));
          }
        }
      }, {
        key: "getObjects",
        value: function getObjects(t, e, r) {
          var n = [];
          return this.forObjects(function (t) {
            n.push(t);
          }, t, e, r), n;
        }
      }, {
        key: "forObjects",
        value: function forObjects(t, e, r, n) {
          e = e && it(e), r = r && it(r), n = n && it(n);

          var i,
              o,
              a,
              s = this._ids,
              u = this._getGraphs(n);

          if (t = this._uniqueEntities(t), !(st(e) && !(o = s[e]) || st(r) && !(a = s[r]))) for (n in u) {
            (i = u[n]) && (o ? a ? this._loopBy2Keys(i.subjects, o, a, t) : this._loopByKey1(i.objects, o, t) : a ? this._loopByKey0(i.predicates, a, t) : this._loop(i.objects, t));
          }
        }
      }, {
        key: "getGraphs",
        value: function getGraphs(t, e, r) {
          var n = [];
          return this.forGraphs(function (t) {
            n.push(t);
          }, t, e, r), n;
        }
      }, {
        key: "forGraphs",
        value: function forGraphs(t, e, r, n) {
          for (var i in this._graphs) {
            this.some(function (e) {
              return t(e.graph), !0;
            }, e, r, n, i);
          }
        }
      }, {
        key: "createBlankNode",
        value: function createBlankNode(t) {
          var e, r;
          if (t) for (e = t = "_:" + t, r = 1; this._ids[e];) {
            e = t + r++;
          } else do {
            e = "_:b" + this._blankNodeIndex++;
          } while (this._ids[e]);
          return this._ids[e] = ++this._id, this._entities[this._id] = e, this._factory.blankNode(e.substr(2));
        }
      }, {
        key: "extractLists",
        value: function extractLists() {
          var _this3 = this;

          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref$remove = _ref.remove,
              t = _ref$remove === void 0 ? !1 : _ref$remove,
              _ref$ignoreErrors = _ref.ignoreErrors,
              e = _ref$ignoreErrors === void 0 ? !1 : _ref$ignoreErrors;

          var r = {},
              n = e ? function () {
            return !0;
          } : function (t, e) {
            throw new Error("".concat(t.value, " ").concat(e));
          },
              i = this.getQuads(null, M.a.rdf.rest, M.a.rdf.nil, null),
              o = t ? _toConsumableArray(i) : [];
          return i.forEach(function (e) {
            for (var i, a, s = [], u = !1, c = e.graph, f = e.subject; f && !u;) {
              var l,
                  h,
                  p = _this3.getQuads(null, null, f, null),
                  d = _this3.getQuads(f, null, null, null),
                  v = null,
                  g = null,
                  y = null;

              for (l = 0; l < d.length && !u; l++) {
                (h = d[l]).graph.equals(c) ? i ? u = n(f, "has non-list arcs out") : h.predicate.value === M.a.rdf.first ? v ? u = n(f, "has multiple rdf:first arcs") : o.push(v = h) : h.predicate.value === M.a.rdf.rest ? g ? u = n(f, "has multiple rdf:rest arcs") : o.push(g = h) : p.length ? u = n(f, "can't be subject and object") : (i = h, a = "subject") : u = n(f, "not confined to single graph");
              }

              for (l = 0; l < p.length && !u; ++l) {
                h = p[l], i ? u = n(f, "can't have coreferences") : h.predicate.value === M.a.rdf.rest ? y ? u = n(f, "has incoming rdf:rest arcs") : y = h : (i = h, a = "object");
              }

              v ? s.unshift(v.object) : u = n(f, "has no list head"), f = y && y.subject;
            }

            u ? t = !1 : i && (r[i[a].value] = s);
          }), t && this.removeQuads(o), r;
        }
      }, {
        key: "size",
        get: function get() {
          var t = this._size;
          if (null !== t) return t;
          t = 0;
          var e,
              r,
              n = this._graphs;

          for (var i in n) {
            for (var o in e = n[i].subjects) {
              for (var a in r = e[o]) {
                t += Object.keys(r[a]).length;
              }
            }
          }

          return this._size = t;
        }
      }]);

      return at;
    }();

    function st(t) {
      return "string" == typeof t || t instanceof String;
    }

    var ut = r(144),
        ct = r.n(ut)()(),
        ft = K.namedNode,
        lt = K.literal,
        ht = function () {
      function t(e) {
        u()(this, t), this._fetch = e, this.parser = new tt(), this.store = new at(), this.cache = {}, this.prefix = {};
      }

      var e, r, n, o;
      return f()(t, [{
        key: "setPrefix",
        value: function value(t, e) {
          this.prefix[t] = e;
        }
      }, {
        key: "getPrefix",
        value: function value(t) {
          return this.prefix[t];
        }
      }, {
        key: "query",
        value: (o = a()(i.a.mark(function t(e, r, n, o, a) {
          var s,
              u,
              c = arguments;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (!(c.length > 5 && void 0 !== c[5] ? c[5] : {
                    useCache: !0
                  }).useCache || !(e in this.cache)) {
                    t.next = 3;
                    break;
                  }

                  return t.abrupt("return", this._queryCached(e, r, n, o, a));

                case 3:
                  return t.next = 5, this._fetch(e, {
                    headers: {
                      Accept: "text/turtle"
                    }
                  });

                case 5:
                  return s = t.sent, t.next = 8, s.text();

                case 8:
                  return u = t.sent, t.abrupt("return", this.queryTurtle(e, u, r, n, o, a));

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r, n, i) {
          return o.apply(this, arguments);
        })
      }, {
        key: "queryTurtle",
        value: (n = a()(i.a.mark(function t(e, r, n, o, a, s) {
          var u;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._parse(r, e);

                case 2:
                  return u = t.sent, this.cache[e] = u, t.abrupt("return", this._queryCached(e, n, o, a, s));

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r, i, o, a) {
          return n.apply(this, arguments);
        })
      }, {
        key: "_queryCached",
        value: (r = a()(i.a.mark(function t(e, r, n, o, a) {
          var s,
              u = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return a || (a = ft(e)[a] = [r, n, o, a].map(function (t) {
                    if ("object" === F()(t) && t) {
                      if (t.id) return t;
                      var r = Object.keys(t),
                          n = t[r];
                      return 1 === r.length && "thisDoc" === r[0] ? ft(n ? e + "#" + n : e) : ct[r] ? ft(ct[r](n)) : u.prefix[r] ? ft(u.prefix[r] + n) : ft(r + n);
                    }

                    return t && void 0 !== t ? lt(t) : t;
                  })), s = this.cache[e], t.abrupt("return", s.getQuads(a[0], a[1], a[2], a[3]));

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, n, i, o) {
          return r.apply(this, arguments);
        })
      }, {
        key: "_parse",
        value: (e = a()(i.a.mark(function t(e, r) {
          var n, o;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return n = [], o = new tt({
                    baseIRI: r
                  }), t.abrupt("return", new Promise(function (t, r) {
                    o.parse(e, function (e, i, o) {
                      if (i && n.push(i), e) return r(e);

                      if (!i) {
                        var a = new at();
                        a.addQuads(n), t(a);
                      }
                    });
                  }));

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        })), function (t, r) {
          return e.apply(this, arguments);
        })
      }]), t;
    }(),
        pt = I,
        dt = O;

    function vt(t, e) {
      var r = {
        url: t
      };

      for (var n in e.forEach(function (t) {
        var e = t.predicate.value.replace(/.*\//, "").replace(/.*#/, ""),
            n = t.object.value.match("http://www.w3.org/ns/iana/media-types/") ? t.object.value.replace("http://www.w3.org/ns/iana/media-types/", "") : t.object.value.replace(/.*\//, "");
        e.match("type") || (n = n.replace(/.*#/, "")), "ldp#Resource" !== n && "ldp#Container" !== n && (r[e] = [].concat(x()(r[e] || []), [n.replace("#Resource", "")]));
      }), r) {
        1 === r[n].length && (r[n] = r[n][0]);
      }

      return void 0 === r.type && (r.type = "application/octet-stream"), r.itemType = r.type.includes("ldp#BasicContainer") ? "Container" : "Resource", r.name = dt(t), r.parent = pt(t), r;
    }

    function gt(t, e, r) {
      var n = {
        type: "folder"
      };
      return n.modified = t.modified, n.mtime = t.mtime, n.size = t.size, n.itemType = t.itemType, n.name = t.name, n.parent = t.parent, n.url = t.url, n.folders = e, n.files = r, n;
    }

    var yt = {
      parseFolderResponse: function () {
        var t = a()(i.a.mark(function t(e) {
          var r,
              n,
              o,
              s,
              u,
              c,
              f,
              l,
              h = arguments;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return r = h.length > 1 && void 0 !== h[1] ? h[1] : e.url, t.next = 3, e.text();

                case 3:
                  return n = t.sent, o = new ht(), t.next = 7, o.queryTurtle(r, n, {
                    thisDoc: ""
                  });

                case 7:
                  return s = t.sent, u = vt(r, s), t.next = 11, o.queryTurtle(r, n, {
                    thisDoc: ""
                  }, {
                    ldp: "contains"
                  });

                case 11:
                  return c = t.sent, f = [], l = [], t.next = 16, Promise.all(c.map(function () {
                    var t = a()(i.a.mark(function t(e) {
                      var n, a, s;
                      return i.a.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return n = e.object, t.next = 3, o.query(r, n);

                            case 3:
                              a = t.sent, (s = vt(n.value, a)).itemType.includes("Container") ? (s.type = "folder", f.push(s)) : l.push(s);

                            case 6:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }()));

                case 16:
                  return t.abrupt("return", gt(u, f, l));

                case 17:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }()
    },
        bt = (r(201), r(97)),
        _t = r.n(bt),
        mt = function (t) {
      function e(t) {
        var r, n;
        u()(this, e);

        for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
          o[a - 1] = arguments[a];
        }

        return (n = h()(this, (r = d()(e)).call.apply(r, [this].concat(o)))).name = "SingleResponseError", o.length || (n.message = "".concat(t.status, " ").concat(t.url)), n.response = t, n.ok = !1, n.status = t.status, n.statusText = t.statusText, n.url = t.url, n;
      }

      return b()(e, t), e;
    }(_t()(Error)),
        wt = function (t) {
      function e(t) {
        var r,
            n,
            i = t.successful,
            o = void 0 === i ? [] : i,
            a = t.rejectedErrors,
            s = void 0 === a ? [] : a,
            c = t.errors,
            f = void 0 === c ? [] : c;
        u()(this, e);

        for (var l = arguments.length, p = new Array(l > 1 ? l - 1 : 0), v = 1; v < l; v++) {
          p[v - 1] = arguments[v];
        }

        return (n = h()(this, (r = d()(e)).call.apply(r, [this].concat(p)))).name = "SFCFetchError", n.successful = o, n.rejected = s.map(function (t) {
          return t.response;
        }), n.rejectedErrors = s, n.errors = f, n.ok = !1, s.length ? 1 !== s.length || f.length ? (n.message = "".concat(n.name, " ").concat([].concat(x()(s), x()(f)).map(function (t) {
          return t.message;
        }).join("\n")), n.status = -2, n.statusText = n.message) : (n.message = "".concat(n.name, " ").concat(s[0].message), n.status = s[0].status, n.statusText = s[0].statusText) : (n.message = "".concat(n.name, " ").concat(f.map(function (t) {
          return t.message;
        }).join("\n")), n.status = -1, n.statusText = n.message), n.successful = o, n.rejected = s.map(function (t) {
          return t.response;
        }), n.rejectedErrors = s, n.errors = f, n;
      }

      return b()(e, t), e;
    }(_t()(Error)),
        xt = {
      401: "Make sure that the user is properly logged in",
      403: "Make sure that the origin of your app is authorized for your pod",
      404: "The requested resource could not be found",
      409: "A conflict appeared. If you tried to delete a folder, make sure that it is empty",
      500: "An internal server error occured"
    };

    function kt(t) {
      return Et.apply(this, arguments);
    }

    function Et() {
      return (Et = a()(i.a.mark(function t(e) {
        var r;
        return i.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r = e.map(function (t) {
                  return t.then(function (t) {
                    return {
                      status: "fulfilled",
                      value: t
                    };
                  }).catch(function (t) {
                    return {
                      status: "rejected",
                      reason: t
                    };
                  });
                }), t.abrupt("return", Promise.all(r));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function St() {
      return (St = a()(i.a.mark(function t(e) {
        var r, n, o, a, s, u, c, f;
        return i.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, kt(e);

              case 2:
                if (n = t.sent, o = (r = []).concat.apply(r, x()(n.filter(function (t) {
                  return "fulfilled" === t.status;
                }).map(function (t) {
                  return t.value;
                }))), !(a = n.filter(function (t) {
                  return "rejected" === t.status;
                }).map(function (t) {
                  return t.reason;
                })).length) {
                  t.next = 9;
                  break;
                }

                throw c = (s = []).concat.apply(s, x()(a.map(function (t) {
                  return t.errors;
                }))), f = (u = []).concat.apply(u, x()(a.map(function (t) {
                  return t.rejectedErrors;
                }))), new wt({
                  successful: o,
                  rejectedErrors: f,
                  errors: c
                });

              case 9:
                return t.abrupt("return", o);

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    var jt = {
      FetchError: wt,
      SingleResponseError: mt,
      assertResponseOk: function assertResponseOk(t) {
        if (!t.ok) {
          var e = t.status in xt ? new mt(t, "".concat(t.status, " ").concat(t.url, " - ").concat(xt[t.status])) : new mt(t);
          throw new wt({
            successful: [],
            rejectedErrors: [e]
          });
        }

        return t;
      },
      composedFetch: function composedFetch(t) {
        return St.apply(this, arguments);
      },
      promisesSettled: kt,
      toFetchError: function toFetchError(t) {
        throw t instanceof wt ? t : t instanceof mt ? new wt({
          rejectedErrors: [t]
        }) : t instanceof Error ? new wt({
          errors: [t]
        }) : t;
      }
    };
    r(204);

    function Rt(t, e) {
      var r = {};
      return function (t) {
        if (t) {
          return t.match(/<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g);
        }
      }(t).map(function (t) {
        var e = t.substring(t.indexOf("<") + 1, t.indexOf(">")),
            r = t.substring(t.indexOf('rel="') + 'rel="'.length, t.lastIndexOf('"'));
        return ["describedby" === r.toLowerCase() ? "meta" : r, e];
      }).filter(function (t) {
        var e = m()(t, 1)[0];
        return ["meta", "acl"].includes(e);
      }).forEach(function (t) {
        var n = m()(t, 2),
            i = n[0],
            o = n[1];

        r[i] = function (t, e) {
          var r,
              n,
              i,
              o,
              a,
              s = e.indexOf("#");
          s > 0 && (e = e.slice(0, s));
          if (0 === t.length) return e;
          if (0 === t.indexOf("#")) return e + t;
          if (t.indexOf(":") >= 0) return t;
          if (r = e.indexOf(":"), 0 === e.length) return t;
          if (r < 0) return t;
          if (n = e.slice(0, +r + 1 || 9e9), 0 === t.indexOf("//")) return n + t;

          if (e.indexOf("//", r) === r + 1) {
            if ((i = e.indexOf("/", r + 3)) < 0) return e.length - r - 3 > 0 ? e + "/" + t : n + t;
          } else if ((i = e.indexOf("/", r + 1)) < 0) return e.length - r - 1 > 0 ? e + "/" + t : n + t;

          if (0 === t.indexOf("/")) return e.slice(0, i) + t;
          if (a = e.slice(i), (o = a.lastIndexOf("/")) < 0) return n + t;
          o >= 0 && o < a.length - 1 && (a = a.slice(0, +o + 1 || 9e9));
          a += t;

          for (; a.match(/[^\/]*\/\.\.\//);) {
            a = a.replace(/[^\/]*\/\.\.\//, "");
          }

          return a = (a = a.replace(/\.\//g, "")).replace(/\/\.$/, "/"), e.slice(0, i) + a;
        }(o, e);
      }), r;
    }

    var Ct = function Ct(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.url,
          r = t.headers.get("link");
      return null === r ? {} : Rt(r, e);
    };

    function It(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ot(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? It(Object(r), !0).forEach(function (e) {
          E()(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : It(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }

    var Tt = j()("solid-file-client:fetch"),
        Pt = C,
        At = I,
        Lt = O,
        Ft = T,
        Mt = P,
        Nt = A,
        Bt = jt.FetchError,
        Dt = jt.assertResponseOk,
        Ut = jt.composedFetch,
        qt = jt.toFetchError,
        Gt = Ct,
        Wt = yt.parseFolderResponse,
        zt = {
      REPLACE: "replace",
      KEEP_SOURCE: "keep_source",
      KEEP_TARGET: "keep_target"
    },
        Yt = {
      EXCLUDE: "exclude",
      INCLUDE: "include",
      INCLUDE_POSSIBLE: "include_possible"
    },
        Qt = "no_modify",
        $t = "to_target",
        Ht = "to_source",
        Kt = {
      withAcl: !0,
      withMeta: !0,
      agent: Qt,
      merge: zt.REPLACE,
      createPath: !0
    },
        Vt = {
      enableLogging: !1
    };

    function Zt(t) {
      return Jt(function (e) {
        return e.status === t;
      });
    }

    function Jt(t) {
      return function (e) {
        if (!t(e)) throw qt(e);
        return e;
      };
    }

    var Xt = function (t) {
      function e(t, r) {
        var n;
        return u()(this, e), (n = h()(this, d()(e).call(this, t.fetch.bind(t), r)))._auth = t, n;
      }

      var r, n, o, s;
      return b()(e, t), f()(e, [{
        key: "readFile",
        value: (s = a()(i.a.mark(function t(e, r) {
          var n, o;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.get(e, r);

                case 2:
                  if (n = t.sent, !(o = n.headers.get("content-type")) || !o.match(/(image|audio|video)/)) {
                    t.next = 6;
                    break;
                  }

                  return t.abrupt("return", n.blob());

                case 6:
                  if (!n.text) {
                    t.next = 8;
                    break;
                  }

                  return t.abrupt("return", n.text());

                case 8:
                  return t.abrupt("return", n);

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return s.apply(this, arguments);
        })
      }, {
        key: "readHead",
        value: (o = a()(i.a.mark(function t(r, n) {
          var o, a, s, u, c, f, l, h;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, g()(d()(e.prototype), "head", this).call(this, r, n);

                case 2:
                  for (o = t.sent, a = "", s = !0, u = !1, c = void 0, t.prev = 7, f = o.headers.entries()[Symbol.iterator](); !(s = (l = f.next()).done); s = !0) {
                    h = l.value, a += h[0] + ": " + h[1] + "\n";
                  }

                  t.next = 15;
                  break;

                case 11:
                  t.prev = 11, t.t0 = t.catch(7), u = !0, c = t.t0;

                case 15:
                  t.prev = 15, t.prev = 16, s || null == f.return || f.return();

                case 18:
                  if (t.prev = 18, !u) {
                    t.next = 21;
                    break;
                  }

                  throw c;

                case 21:
                  return t.finish(18);

                case 22:
                  return t.finish(15);

                case 23:
                  return t.abrupt("return", a);

                case 24:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[7, 11, 15, 23], [16,, 18, 22]]);
        })), function (t, e) {
          return o.apply(this, arguments);
        })
      }, {
        key: "deleteFile",
        value: (n = a()(i.a.mark(function t(r) {
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", g()(d()(e.prototype), "_deleteItemWithLinks", this).call(this, r));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "deleteFolder",
        value: (r = a()(i.a.mark(function t(r, n) {
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", g()(d()(e.prototype), "deleteFolderRecursively", this).call(this, r));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return r.apply(this, arguments);
        })
      }]), e;
    }(function () {
      function t(e, r) {
        u()(this, t), r = Ot({}, Vt, {}, r), this._fetch = e, this.rdf = new ht(this.fetch.bind(this)), r.enableLogging && ("string" == typeof r.enableLogging ? j.a.enable(r.enableLogging) : j.a.enable("solid-file-client:*"));
      }

      var e, r, n, o, s, c, l, h, p, d, v, g, y, b, _, w, k;

      return f()(t, [{
        key: "fetch",
        value: function value(t, e) {
          return this._fetch(t, e).then(function (r) {
            return Tt("".concat(r.status, " - ").concat(e && e.method, " ").concat(t)), r;
          }).then(Dt);
        }
      }, {
        key: "get",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "GET"
          }));
        }
      }, {
        key: "delete",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "DELETE"
          }));
        }
      }, {
        key: "post",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "POST"
          }));
        }
      }, {
        key: "put",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "PUT"
          }));
        }
      }, {
        key: "patch",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "PATCH"
          }));
        }
      }, {
        key: "head",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "HEAD"
          }));
        }
      }, {
        key: "options",
        value: function value(t, e) {
          return this.fetch(t, Ot({}, e, {
            method: "OPTIONS"
          }));
        }
      }, {
        key: "itemExists",
        value: (k = a()(i.a.mark(function t(e) {
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", this.head(e).then(function () {
                    return !0;
                  }).catch(function (t) {
                    return Zt(404)(t), !1;
                  }));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return k.apply(this, arguments);
        })
      }, {
        key: "postItem",
        value: (w = a()(i.a.mark(function t(e, r, n, o, a) {
          var s, u;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (a = Ot({}, {
                    createPath: !0
                  }, {}, a), s = At(e), !a.createPath) {
                    t.next = 5;
                    break;
                  }

                  return t.next = 5, this.createFolder(s);

                case 5:
                  return u = {
                    headers: {
                      link: o,
                      slug: Lt(e),
                      "Content-Type": n
                    },
                    body: r
                  }, t.abrupt("return", this.post(s, u));

                case 7:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r, n, i) {
          return w.apply(this, arguments);
        })
      }, {
        key: "createFolder",
        value: (_ = a()(i.a.mark(function t(e, r) {
          var n;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return r = Ot({}, {
                    createPath: !0,
                    merge: zt.KEEP_TARGET
                  }, {}, r), t.prev = 1, t.next = 4, this.head(e);

                case 4:
                  if (n = t.sent, r.merge === zt.REPLACE) {
                    t.next = 7;
                    break;
                  }

                  return t.abrupt("return", n);

                case 7:
                  return t.next = 9, this.deleteFolderRecursively(e);

                case 9:
                  t.next = 14;
                  break;

                case 11:
                  t.prev = 11, t.t0 = t.catch(1), Zt(404)(t.t0);

                case 14:
                  return t.abrupt("return", this.postItem(e, "", "text/turtle", Nt.CONTAINER, r));

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[1, 11]]);
        })), function (t, e) {
          return _.apply(this, arguments);
        })
      }, {
        key: "postFile",
        value: function value(t, e, r, n) {
          return this.postItem(t, e, r, Nt.RESOURCE, n);
        }
      }, {
        key: "createFile",
        value: function value(t, e, r, n) {
          return this.putFile(t, e, r, n);
        }
      }, {
        key: "putFile",
        value: (b = a()(i.a.mark(function t(e, r, n, o) {
          var a;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (o = Ot({}, Kt, {}, o), t.t0 = o.merge === zt.KEEP_TARGET, !t.t0) {
                    t.next = 6;
                    break;
                  }

                  return t.next = 5, this.itemExists(e);

                case 5:
                  t.t0 = t.sent;

                case 6:
                  if (!t.t0) {
                    t.next = 8;
                    break;
                  }

                  qt(new Error("File already existed: " + e));

                case 8:
                  return a = {
                    headers: {
                      link: Nt.RESOURCE,
                      "Content-Type": n
                    },
                    body: r
                  }, t.abrupt("return", this.put(e, a));

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r, n) {
          return b.apply(this, arguments);
        })
      }, {
        key: "readFolder",
        value: (y = a()(i.a.mark(function t(e, r) {
          var n,
              o,
              s,
              u = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return e = e.endsWith("/") ? e : e + "/", r = Ot({
                    links: Yt.EXCLUDE
                  }, r), t.next = 4, this.get(e, {
                    headers: {
                      Accept: "text/turtle"
                    }
                  });

                case 4:
                  return n = t.sent, t.next = 7, Wt(n, e);

                case 7:
                  if (o = t.sent, r.links !== Yt.INCLUDE_POSSIBLE && r.links !== Yt.INCLUDE) {
                    t.next = 12;
                    break;
                  }

                  return s = function () {
                    var t = a()(i.a.mark(function t(e) {
                      return i.a.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return t.next = 2, u.getItemLinks(e.url, r);

                            case 2:
                              e.links = t.sent;

                            case 3:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }(), t.next = 12, Ut([s(o)].concat(x()(o.files.map(s))));

                case 12:
                  return t.abrupt("return", o);

                case 13:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return y.apply(this, arguments);
        })
      }, {
        key: "getItemLinks",
        value: (g = a()(i.a.mark(function t(e) {
          var r,
              n,
              o = arguments;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return (r = o.length > 1 && void 0 !== o[1] ? o[1] : {
                    links: Yt.INCLUDE_POSSIBLE
                  }).links === Yt.EXCLUDE && qt(new Error("Invalid option LINKS.EXCLUDE for getItemLinks")), t.next = 4, this.head(e).then(Gt);

                case 4:
                  if (n = t.sent, r.links !== Yt.INCLUDE) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 8, this._removeInexistingLinks(n);

                case 8:
                  return t.abrupt("return", n);

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return g.apply(this, arguments);
        })
      }, {
        key: "_removeInexistingLinks",
        value: (v = a()(i.a.mark(function t(e) {
          var r = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, Ut(Object.entries(e).map(function (t) {
                    var n = m()(t, 2),
                        i = n[0],
                        o = n[1];
                    return r.itemExists(o).catch(Zt(404)).then(function (t) {
                      t || delete e[i];
                    });
                  }));

                case 2:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        })), function (t) {
          return v.apply(this, arguments);
        })
      }, {
        key: "copyFile",
        value: (d = a()(i.a.mark(function t(e, r, n) {
          var o, a, s, u;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (n = Ot({}, Kt, {}, n), !e.endsWith("/") && !r.endsWith("/")) {
                    t.next = 3;
                    break;
                  }

                  throw qt(new Error("Folders are not allowed with copyFile. Found: ".concat(e, " and ").concat(r)));

                case 3:
                  if (!e.endsWith(".acl") && !r.endsWith(".acl")) {
                    t.next = 5;
                    break;
                  }

                  throw qt(new Error("Use copyAclFile for copying ACL files. Found: ".concat(e, " and ").concat(r)));

                case 5:
                  return t.next = 7, this.get(e);

                case 7:
                  return o = t.sent, t.next = 10, o.blob();

                case 10:
                  return a = t.sent, s = o.headers.get("content-type"), t.next = 14, this.putFile(r, a, s, n);

                case 14:
                  return u = t.sent, t.next = 17, this.copyLinksForItem(e, r, n, o, u);

                case 17:
                  return t.abrupt("return", u);

                case 18:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return d.apply(this, arguments);
        })
      }, {
        key: "_linkUrlsDefined",
        value: (p = a()(i.a.mark(function t(e, r) {
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ("string" == typeof e) {
                    t.next = 4;
                    break;
                  }

                  return t.abrupt("return", !1);

                case 4:
                  if (t.t0 = "string" != typeof r, !t.t0) {
                    t.next = 9;
                    break;
                  }

                  return t.next = 8, this.itemExists(e);

                case 8:
                  t.t0 = t.sent;

                case 9:
                  if (!t.t0) {
                    t.next = 13;
                    break;
                  }

                  throw qt(new Error("Cannot copy link file because target location was not provided by the pod"));

                case 13:
                  if ("string" == typeof r) {
                    t.next = 17;
                    break;
                  }

                  return t.abrupt("return", !1);

                case 17:
                  return t.abrupt("return", !0);

                case 18:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return p.apply(this, arguments);
        })
      }, {
        key: "copyMetaFileForItem",
        value: (h = a()(i.a.mark(function t(e, r) {
          var n,
              o,
              a,
              s,
              u,
              c = arguments;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return n = c.length > 2 && void 0 !== c[2] ? c[2] : {}, t.next = 3, this.getItemLinks(e);

                case 3:
                  return o = t.sent, a = o.meta, t.next = 7, this.getItemLinks(r);

                case 7:
                  return s = t.sent, u = s.meta, t.next = 11, this._linkUrlsDefined(a, u);

                case 11:
                  if (t.sent) {
                    t.next = 13;
                    break;
                  }

                  return t.abrupt("return", void 0);

                case 13:
                  return t.abrupt("return", this.copyFile(a, u, {
                    withAcl: n.withAcl,
                    withMeta: !1
                  }));

                case 14:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return h.apply(this, arguments);
        })
      }, {
        key: "copyAclFileForItem",
        value: (l = a()(i.a.mark(function t(e, r, n) {
          var o, a, s, u, c, f, l, h, p;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return n = Ot({}, Kt, {}, {
                    agent: Qt
                  }, {}, n), t.next = 3, this.getItemLinks(e);

                case 3:
                  return o = t.sent, a = o.acl, t.next = 7, this.getItemLinks(r);

                case 7:
                  return s = t.sent, u = s.acl, t.next = 11, this._linkUrlsDefined(a, u);

                case 11:
                  if (t.sent) {
                    t.next = 13;
                    break;
                  }

                  return t.abrupt("return", void 0);

                case 13:
                  return t.next = 15, this.get(a);

                case 15:
                  return c = t.sent, f = c.headers.get("Content-Type"), t.next = 19, c.text();

                case 19:
                  return l = t.sent, h = Lt(e), p = Ft(r) ? "" : Lt(r), l.includes(e) && (l = l.replace(new RegExp("<" + e + ">", "g"), "<./" + p + ">")), p !== h && (l = l.replace(new RegExp(h + ">", "g"), p + ">")), n.agent === $t && (l = (l = l.replace(new RegExp("<" + Pt(e) + "profile/card#", "g"), "</profile/card#")).replace(new RegExp("<" + Pt(e) + "profile/card#me>", "g"), "</profile/card#me>")), n.agent === Ht && (l = (l = l.replace(new RegExp("</profile/card#", "g"), "<" + Pt(e) + "profile/card#")).replace(new RegExp("</profile/card#me>", "g"), "<" + Pt(e) + "profile/card#me>")), t.abrupt("return", this.putFile(u, l, f, n));

                case 27:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return l.apply(this, arguments);
        })
      }, {
        key: "copyLinksForItem",
        value: (c = a()(i.a.mark(function t(e, r, n) {
          var o;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (o = [], !n.withMeta) {
                    t.next = 7;
                    break;
                  }

                  return t.t0 = o, t.next = 5, this.copyMetaFileForItem(e, r, n).catch(Zt(404));

                case 5:
                  t.t1 = t.sent, t.t0.push.call(t.t0, t.t1);

                case 7:
                  if (!n.withAcl) {
                    t.next = 13;
                    break;
                  }

                  return t.t2 = o, t.next = 11, this.copyAclFileForItem(e, r, n).catch(Zt(404));

                case 11:
                  t.t3 = t.sent, t.t2.push.call(t.t2, t.t3);

                case 13:
                  return t.abrupt("return", o.filter(function (t) {
                    return t && !(t instanceof Error);
                  }));

                case 14:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return c.apply(this, arguments);
        })
      }, {
        key: "copyFolder",
        value: (s = a()(i.a.mark(function t(e, r, n) {
          var o,
              a,
              s,
              u,
              c,
              f,
              l = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (n = Ot({}, Kt, {}, n), "string" == typeof e && "string" == typeof r) {
                    t.next = 3;
                    break;
                  }

                  throw qt(new Error("The from and to parameters of copyFolder must be strings. Found: ".concat(e, " and ").concat(r)));

                case 3:
                  if (e.endsWith("/") && r.endsWith("/")) {
                    t.next = 5;
                    break;
                  }

                  throw qt(new Error("Files are not allowed with copyFolder. Found: ".concat(e, " and ").concat(r)));

                case 5:
                  return t.next = 7, this.readFolder(e);

                case 7:
                  return a = t.sent, s = a.folders, u = a.files, t.next = 12, this.createFolder(r, n);

                case 12:
                  return c = t.sent, t.next = 15, this.copyLinksForItem(e, r, n, void 0, c);

                case 15:
                  return t.next = 17, Ut([].concat(x()(s.map(function (t) {
                    var i = t.name;
                    return l.copyFolder("".concat(e).concat(i, "/"), "".concat(r).concat(i, "/"), n);
                  })), x()(u.map(function (t) {
                    var i = t.name;
                    return l.copyFile("".concat(e).concat(i), "".concat(r).concat(i), n).catch(Jt(function (t) {
                      return t.message.includes("already existed");
                    }));
                  })))).then(function (t) {
                    return t.filter(function (t) {
                      return !(t instanceof Bt);
                    });
                  });

                case 17:
                  return f = t.sent, t.abrupt("return", (o = [c]).concat.apply(o, x()(f)));

                case 19:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, r) {
          return s.apply(this, arguments);
        })
      }, {
        key: "copy",
        value: function value(t, e, r) {
          return Ft(t, e) ? this.copyFolder(t, e, r) : Mt(t, e) ? this.copyFile(t, e, r) : void qt(new Error("Cannot copy from a folder url to a file url or vice versa"));
        }
      }, {
        key: "_deleteItemWithLinks",
        value: (o = a()(i.a.mark(function t(e) {
          var r;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.getItemLinks(e, {
                    links: Yt.INCLUDE
                  });

                case 2:
                  if (!(r = t.sent).meta) {
                    t.next = 6;
                    break;
                  }

                  return t.next = 6, this._deleteItemWithLinks(r.meta);

                case 6:
                  if (!r.acl) {
                    t.next = 9;
                    break;
                  }

                  return t.next = 9, this.delete(r.acl);

                case 9:
                  return t.abrupt("return", this.delete(e));

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return o.apply(this, arguments);
        })
      }, {
        key: "deleteFolderContents",
        value: (n = a()(i.a.mark(function t(e) {
          var r,
              n,
              o,
              a = this;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.readFolder(e);

                case 2:
                  return r = t.sent, n = r.folders, o = r.files, t.abrupt("return", Ut([].concat(x()(n.map(function (t) {
                    var e = t.url;
                    return a.deleteFolderRecursively(e);
                  })), x()(o.map(function (t) {
                    var e = t.url;
                    return a._deleteItemWithLinks(e);
                  })))));

                case 6:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "deleteFolderRecursively",
        value: (r = a()(i.a.mark(function t(e) {
          var r;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.deleteFolderContents(e);

                case 2:
                  return r = t.sent, t.t0 = r, t.next = 6, this._deleteItemWithLinks(e);

                case 6:
                  return t.t1 = t.sent, t.t0.unshift.call(t.t0, t.t1), t.abrupt("return", r);

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return r.apply(this, arguments);
        })
      }, {
        key: "move",
        value: (e = a()(i.a.mark(function t(e, r, n) {
          var o;
          return i.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.copy(e, r, n);

                case 2:
                  if (o = t.sent, !Ft(e)) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 6, this.deleteFolderRecursively(e);

                case 6:
                  t.next = 10;
                  break;

                case 8:
                  return t.next = 10, this._deleteItemWithLinks(e);

                case 10:
                  return t.abrupt("return", o);

                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, r, n) {
          return e.apply(this, arguments);
        })
      }, {
        key: "rename",
        value: function value(t, e, r) {
          var n = At(t) + e + (Ft(t) ? "/" : "");
          return this.move(t, n, r);
        }
      }]), t;
    }()),
        te = jt.FetchError,
        ee = jt.SingleResponseError;

    Xt.FetchError = te, Xt.SingleResponseError = ee, Xt.LINKS = Yt, Xt.MERGE = zt;
    e.default = Xt;
  }]).default;
});